var bodyScrollLockOptions = {
  reserveScrollBarGap: true,
};

// Define a global function to load a script
window.loadScript = function (url) {
  // Check if the script already exists
  var existingScript = document.querySelector(`script[src="${url}"]`);

  if (existingScript) {
    return;
  }

  // Create a new script element
  var script = document.createElement('script');
  script.src = url;
  document.body.appendChild(script);
};



var Shopify = Shopify || {};
// ---------------------------------------------------------------------------
// Money format handler
// ---------------------------------------------------------------------------
Shopify.money_format = "${{amount_no_decimals}}";
Shopify.formatMoney = function (cents, format) {
  if (typeof cents == "string") {
    cents = cents.replace(".", "");
  }
  var value = "";
  var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
  var formatString = format || this.money_format;

  function defaultOption(opt, def) {
    return typeof opt == "undefined" ? def : opt;
  }

  function formatWithDelimiters(number, precision, thousands, decimal) {
    precision = defaultOption(precision, 2);
    thousands = defaultOption(thousands, ",");
    decimal = defaultOption(decimal, ".");

    if (isNaN(number) || number == null) {
      return 0;
    }

    number = (number / 100.0).toFixed(precision);

    var parts = number.split("."),
      dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
      cents = parts[1] ? decimal + parts[1] : "";

    return dollars + cents;
  }

  switch (formatString.match(placeholderRegex)[1]) {
    case "amount":
      value = formatWithDelimiters(cents, 2);
      break;
    case "amount_no_decimals":
      value = formatWithDelimiters(cents, 0);
      break;
    case "amount_with_comma_separator":
      value = formatWithDelimiters(cents, 2, ".", ",");
      break;
    case "amount_no_decimals_with_comma_separator":
      value = formatWithDelimiters(cents, 0, ".", ",");
      break;
  }

  return formatString.replace(placeholderRegex, value);
};

/**
 * DOM event delegator
 *
 * The delegator will listen
 * for events that bubble up
 * to the root node.
 *
 * @constructor
 * @param {Node|string} [root] The root node or a selector string matching the root node
 */
function Delegate(root) {
  /**
   * Maintain a map of listener
   * lists, keyed by event name.
   *
   * @type Object
   */
  this.listenerMap = [{}, {}];
  if (root) {
    this.root(root);
  }

  /** @type function() */
  this.handle = Delegate.prototype.handle.bind(this);

  // Cache of event listeners removed during an event cycle
  this._removedListeners = [];
}

/**
 * Start listening for events
 * on the provided DOM element
 *
 * @param  {Node|string} [root] The root node or a selector string matching the root node
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.root = function (root) {
  const listenerMap = this.listenerMap;
  let eventType;

  // Remove master event listeners
  if (this.rootElement) {
    for (eventType in listenerMap[1]) {
      if (listenerMap[1].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, true);
      }
    }
    for (eventType in listenerMap[0]) {
      if (listenerMap[0].hasOwnProperty(eventType)) {
        this.rootElement.removeEventListener(eventType, this.handle, false);
      }
    }
  }

  // If no root or root is not
  // a dom node, then remove internal
  // root reference and exit here
  if (!root || !root.addEventListener) {
    if (this.rootElement) {
      delete this.rootElement;
    }
    return this;
  }

  /**
   * The root node at which
   * listeners are attached.
   *
   * @type Node
   */
  this.rootElement = root;

  // Set up master event listeners
  for (eventType in listenerMap[1]) {
    if (listenerMap[1].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: true, passive: isScrollEvent });
    }
  }
  for (eventType in listenerMap[0]) {
    if (listenerMap[0].hasOwnProperty(eventType)) {
      // Add the 'passive' option for scroll events
      const isScrollEvent = ["wheel", "mousewheel"].indexOf(eventType) !== -1;
      this.rootElement.addEventListener(eventType, this.handle, { capture: false, passive: isScrollEvent });
    }
  }

  return this;
};

/**
 * @param {string} eventType
 * @returns boolean
 */
Delegate.prototype.captureForType = function (eventType) {
  return (
    ["blur", "error", "focus", "load", "resize", "scroll"].indexOf(
      eventType
    ) !== -1
  );
};
/**
 * Attach a handler to one
 * event for all elements
 * that match the selector,
 * now or in the future
 *
 * The handler function receives
 * three arguments: the DOM event
 * object, the node that matched
 * the selector while the event
 * was bubbling and a reference
 * to itself. Within the handler,
 * 'this' is equal to the second
 * argument.
 *
 * The node that actually received
 * the event can be accessed via
 * 'event.target'.
 *
 * @param {string} eventType Listen for these events
 * @param {string|undefined} selector Only handle events on elements matching this selector, if undefined match root element
 * @param {function()} handler Handler function - event data passed here will be in event.data
 * @param {boolean} [useCapture] see 'useCapture' in <https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener>
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.on = function (eventType, selector, handler, useCapture) {
  let root;
  let listenerMap;
  let matcher;
  let matcherParam;

  if (!eventType) {
    throw new TypeError("Invalid event type: " + eventType);
  }

  // handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // Fallback to sensible defaults
  // if useCapture not set
  if (useCapture === undefined) {
    useCapture = this.captureForType(eventType);
  }

  if (typeof handler !== "function") {
    throw new TypeError("Handler must be a type of Function");
  }

  root = this.rootElement;
  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  const isScrollEvent = ["wheel", "mousewheel", "touchstart", "touchmove"].indexOf(eventType) !== -1;

  // Add master handler for type if not created yet
  if (!listenerMap[eventType]) {
    if (root) {
      root.addEventListener(eventType, this.handle, { capture: useCapture, passive: isScrollEvent });
    }
    listenerMap[eventType] = [];
  }

  if (!selector) {
    matcherParam = null;

    // COMPLEX - matchesRoot needs to have access to
    // this.rootElement, so bind the function to this.
    matcher = matchesRoot.bind(this);

    // Compile a matcher for the given selector
  } else if (/^[a-z]+$/i.test(selector)) {
    matcherParam = selector;
    matcher = matchesTag;
  } else if (/^#[a-z0-9\-_]+$/i.test(selector)) {
    matcherParam = selector.slice(1);
    matcher = matchesId;
  } else {
    matcherParam = selector;
    matcher = Element.prototype.matches;
  }

  // Add to the list of listeners
  listenerMap[eventType].push({
    selector: selector,
    handler: handler,
    matcher: matcher,
    matcherParam: matcherParam,
  });

  return this;
};

/**
 * Remove an event handler
 * for elements that match
 * the selector, forever
 *
 * @param {string} [eventType] Remove handlers for events matching this type, considering the other parameters
 * @param {string} [selector] If this parameter is omitted, only handlers which match the other two will be removed
 * @param {function()} [handler] If this parameter is omitted, only handlers which match the previous two will be removed
 * @returns {Delegate} This method is chainable
 */
Delegate.prototype.off = function (eventType, selector, handler, useCapture) {
  let i;
  let listener;
  let listenerMap;
  let listenerList;
  let singleEventType;

  // Handler can be passed as
  // the second or third argument
  if (typeof selector === "function") {
    useCapture = handler;
    handler = selector;
    selector = null;
  }

  // If useCapture not set, remove
  // all event listeners
  if (useCapture === undefined) {
    this.off(eventType, selector, handler, true);
    this.off(eventType, selector, handler, false);
    return this;
  }

  listenerMap = this.listenerMap[useCapture ? 1 : 0];
  if (!eventType) {
    for (singleEventType in listenerMap) {
      if (listenerMap.hasOwnProperty(singleEventType)) {
        this.off(singleEventType, selector, handler);
      }
    }

    return this;
  }

  listenerList = listenerMap[eventType];
  if (!listenerList || !listenerList.length) {
    return this;
  }

  // Remove only parameter matches
  // if specified
  for (i = listenerList.length - 1; i >= 0; i--) {
    listener = listenerList[i];

    if (
      (!selector || selector === listener.selector) &&
      (!handler || handler === listener.handler)
    ) {
      this._removedListeners.push(listener);
      listenerList.splice(i, 1);
    }
  }

  // All listeners removed
  if (!listenerList.length) {
    delete listenerMap[eventType];

    // Remove the main handler
    if (this.rootElement) {
      this.rootElement.removeEventListener(eventType, this.handle, useCapture);
    }
  }

  return this;
};

/**
 * Handle an arbitrary event.
 *
 * @param {Event} event
 */
Delegate.prototype.handle = function (event) {
  let i;
  let l;
  const type = event.type;
  let root;
  let phase;
  let listener;
  let returned;
  let listenerList = [];
  let target;
  const eventIgnore = "ftLabsDelegateIgnore";

  if (event[eventIgnore] === true) {
    return;
  }

  target = event.target;

  // Hardcode value of Node.TEXT_NODE
  // as not defined in IE8
  if (target.nodeType === 3) {
    target = target.parentNode;
  }

  // Handle SVG <use> elements in IE
  if (target.correspondingUseElement) {
    target = target.correspondingUseElement;
  }

  root = this.rootElement;

  phase = event.eventPhase || (event.target !== event.currentTarget ? 3 : 2);

  // eslint-disable-next-line default-case
  switch (phase) {
    case 1: //Event.CAPTURING_PHASE:
      listenerList = this.listenerMap[1][type];
      break;
    case 2: //Event.AT_TARGET:
      if (this.listenerMap[0] && this.listenerMap[0][type]) {
        listenerList = listenerList.concat(this.listenerMap[0][type]);
      }
      if (this.listenerMap[1] && this.listenerMap[1][type]) {
        listenerList = listenerList.concat(this.listenerMap[1][type]);
      }
      break;
    case 3: //Event.BUBBLING_PHASE:
      listenerList = this.listenerMap[0][type];
      break;
  }

  let toFire = [];

  // Need to continuously check
  // that the specific list is
  // still populated in case one
  // of the callbacks actually
  // causes the list to be destroyed.
  l = listenerList.length;
  while (target && l) {
    for (i = 0; i < l; i++) {
      listener = listenerList[i];

      // Bail from this loop if
      // the length changed and
      // no more listeners are
      // defined between i and l.
      if (!listener) {
        break;
      }

      if (
        target.tagName &&
        ["button", "input", "select", "textarea"].indexOf(
          target.tagName.toLowerCase()
        ) > -1 &&
        target.hasAttribute("disabled")
      ) {
        // Remove things that have previously fired
        toFire = [];
      }
      // Check for match and fire
      // the event if there's one
      //
      // TODO:MCG:20120117: Need a way
      // to check if event#stopImmediatePropagation
      // was called. If so, break both loops.
      else if (listener.matcher.call(target, listener.matcherParam, target)) {
        toFire.push([event, target, listener]);
      }
    }

    // TODO:MCG:20120117: Need a way to
    // check if event#stopPropagation
    // was called. If so, break looping
    // through the DOM. Stop if the
    // delegation root has been reached
    if (target === root) {
      break;
    }

    l = listenerList.length;

    // Fall back to parentNode since SVG children have no parentElement in IE
    target = target.parentElement || target.parentNode;

    // Do not traverse up to document root when using parentNode, though
    if (target instanceof HTMLDocument) {
      break;
    }
  }

  let ret;

  for (i = 0; i < toFire.length; i++) {
    // Has it been removed during while the event function was fired
    if (this._removedListeners.indexOf(toFire[i][2]) > -1) {
      continue;
    }
    returned = this.fire.apply(this, toFire[i]);

    // Stop propagation to subsequent
    // callbacks if the callback returned
    // false
    if (returned === false) {
      toFire[i][0][eventIgnore] = true;
      toFire[i][0].preventDefault();
      ret = false;
      break;
    }
  }

  return ret;
};

/**
 * Fire a listener on a target.
 *
 * @param {Event} event
 * @param {Node} target
 * @param {Object} listener
 * @returns {boolean}
 */
Delegate.prototype.fire = function (event, target, listener) {
  return listener.handler.call(target, event, target);
};

/**
 * Check whether an element
 * matches a tag selector.
 *
 * Tags are NOT case-sensitive,
 * except in XML (and XML-based
 * languages such as XHTML).
 *
 * @param {string} tagName The tag name to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesTag(tagName, element) {
  return tagName.toLowerCase() === element.tagName.toLowerCase();
}

/**
 * Check whether an element
 * matches the root.
 *
 * @param {?String} selector In this case this is always passed through as null and not used
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesRoot(selector, element) {
  if (this.rootElement === window) {
    return (
      // Match the outer document (dispatched from document)
      element === document ||
      // The <html> element (dispatched from document.body or document.documentElement)
      element === document.documentElement ||
      // Or the window itself (dispatched from window)
      element === window
    );
  }
  return this.rootElement === element;
}

/**
 * Check whether the ID of
 * the element in 'this'
 * matches the given ID.
 *
 * IDs are case-sensitive.
 *
 * @param {string} id The ID to test against
 * @param {Element} element The element to test with
 * @returns boolean
 */
function matchesId(id, element) {
  return id === element.id;
}

/**
 * Short hand for off()
 * and root(), ie both
 * with no parameters
 *
 * @return void
 */
Delegate.prototype.destroy = function () {
  this.off();
  this.root();
};

class GlobalScrollListener {
  constructor() {
    this.callbacks = new Map();
    this.listenerIdCounter = 0;
    this.isListening = false;
    this.boundRunCallbacks = this.runCallbacks.bind(this);
  }

  addScrollListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.callbacks.set(key, boundFunction);

    if (!this.isListening) {
      window.addEventListener("scroll", this.boundRunCallbacks, { passive: true });
      this.isListening = true;
    }

    return {
      removeScrollListener: () => this.removeScrollListenerFunction(key)
    };
  }

  removeScrollListenerFunction(key) {
    if (this.callbacks.has(key)) {
      this.callbacks.delete(key);
    }

    if (this.callbacks.size === 0 && this.isListening) {
      window.removeEventListener("scroll", this.boundRunCallbacks);
      this.isListening = false;
    }
  }

  runCallbacks() {
    this.callbacks.forEach(callback => callback());
  }
}

const scrollListener = new GlobalScrollListener();

class Responsive {
  constructor(enableGeneralBreakpointChange) {
    this.settings();

    this.generalBreakpointChange = enableGeneralBreakpointChange;
    this.currentBreakpoint = this.getCurrentBreakpoint();
    this.breakpointListeners = new Map(); // Stores listeners with their status
    this.resizeCallbacks = new Map();
    this.listenerIdCounter = 0;

    this.initResizeListener();
  }

  initResizeListener() {
    this.boundHandleResize = this.handleResize.bind(this);
    window.addEventListener("resize", this.boundHandleResize);
  }

  settings() {
    this.matchBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      tablet_and_up: "(min-width: 768px)",
      pocket: "(max-width: 1024px)",
      lap_and_up: "(min-width: 1025px)",
      desktop: "(min-width: 1280px)",
      desktop_wide: "(min-width: 1440px)"
    };

    this.currentBreakpoints = {
      phone: "(max-width: 640px)",
      tablet: "(min-width: 641px) and (max-width: 1024px)",
      lap: "(min-width: 1025px) and (max-width: 1279px)",
      desktop: "(min-width: 1280px)"
    };
  }

  handleResize() {
    const newBreakpoint = this.getCurrentBreakpoint();

    if (this.generalBreakpointChange) {
      // Check for general breakpoint change
      if (this.currentBreakpoint !== newBreakpoint) {
        document.dispatchEvent(new CustomEvent("breakpoint:changed", {
          detail: {
            previousBreakpoint: this.currentBreakpoint,
            currentBreakpoint: newBreakpoint,
          },
        }));
      }
    }

    // Additional check for specific breakpoint
    this.breakpointListeners.forEach((value, key) => {
      const isCurrentlyInBreakpoint = this.matchesBreakpoint(key);
      if (value !== isCurrentlyInBreakpoint) {
        this.breakpointListeners.set(key, isCurrentlyInBreakpoint);
        document.body.dispatchEvent(new CustomEvent(`breakpoint:${key}`, {
          detail: {
            matches: isCurrentlyInBreakpoint
          }
        }));
      }
    });

    this.currentBreakpoint = newBreakpoint;

    // Run additional registered resize callbacks
    this.runCallbacks();
  };

  matchesBreakpoint(breakpoint) {
    const query = this.matchBreakpoints[breakpoint];
    return window.matchMedia(`screen and ${query}`).matches;
  }

  getCurrentBreakpoint() {
    for (const [key, query] of Object.entries(this.currentBreakpoints)) {
      if (window.matchMedia(`screen and ${query}`).matches) {
        return key;
      }
    }
  }

  addBreakpointListener(breakpoint) {
    if (!this.matchBreakpoints[breakpoint]) {
      console.error("Breakpoint does not exist:", breakpoint);
      return;
    }

    if (this.breakpointListeners.has(breakpoint)) {
      console.warn("Listener already exists for breakpoint:", breakpoint);
      return;
    }

    const isInBreakpoint = this.matchesBreakpoint(breakpoint);
    this.breakpointListeners.set(breakpoint, isInBreakpoint);
  }

  addResizeListener(classInstance, func) {
    const id = ++this.listenerIdCounter;
    const keyBase = `${classInstance.constructor.name}_${func.name}_${id}`;
    const key = keyBase.replace(/ /g, '_'); // Replace spaces with underscores
    const boundFunction = func.bind(classInstance);

    this.resizeCallbacks.set(key, boundFunction);

    return {
      removeResizeListener: () => this.removeResizeListenerFunction(key)
    };
  }

  removeResizeListenerFunction(key) {
    if (this.resizeCallbacks.has(key)) {
      this.resizeCallbacks.delete(key);
    }
  }

  runCallbacks() {
    this.resizeCallbacks.forEach(callback => callback());
  }
}

const responsive = new Responsive(false);

let alreadyDelegated = false;
class Popup {
  constructor(element, additionalOverlay) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    if (additionalOverlay == true) {
      this.pageOverlayElement = document.querySelector(".localizationOverlay");
    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }
    if (alreadyDelegated == false) {
      this.bindEvents();
    }

  }
  bindEvents() {
    alreadyDelegated = true;
    this.delegateBody.on(
      "click",
      '[data-action="open-modal"]',
      this.openModal.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-modal"]',
      this.closeModal.bind(this)
    );
    document.addEventListener(
      "posted_successfully",
      this.openModalSpecial.bind(this)
    );

    this.onClickOutsideListener = this.closeModal.bind(this);
  }

  openModal() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(
      event.target.closest("[aria-controls]").getAttribute("aria-controls")
    );
    if(this.activeModal.getAttribute("aria-hidden") === "false") return;
    this.activeModal.setAttribute("aria-hidden", "false");
    this.activeModal.style.display = "block";
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    var focus; 
    if(this.activeModal.id != 'modal-country') {
      focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    } else {
      if(responsive.matchesBreakpoint("lap_and_up")) {
        const clickHandler = (e) => {
          if(e.target.closest("#modal-country")) return;
          this.delegateBody.off("click", clickHandler);
          this.closeModal()
        };
    
        this.delegateBody.on("click", clickHandler);
        focus = this.activeModal.querySelectorAll("[data-scrollable]");
        focus.forEach(focus => bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions));  
      }
    }
    setTimeout(() => {
      trapFocus(this.activeModal);
    }, 100);
  }
  openModalSpecial() {
    event.preventDefault();
    event.stopPropagation();
    this.pageOverlayElement.classList.add("is-visible");
    this.activeModal = document.getElementById(event.detail.id);
    this.activeModal.setAttribute("aria-hidden", "false");
    var focus; 
    if(this.activeModal.id != 'modal-country') {
      focus = this.element.querySelector("[data-scrollable]");
    } else {
      focus = document.querySelector("#country-modal").querySelector("[data-scrollable]");
    }
    this.pageOverlayElement.addEventListener(
      "click",
      this.onClickOutsideListener
    );
    bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
    trapFocus(this.activeModal);
  }
  closeModal() {
    this.activeModal = document.body.querySelector(
      '.Popup[aria-hidden="false"]'
    );

    if(this.activeModal == null){
      this.activeModal = document.body.querySelector('.newsletter-popup[aria-hidden="false"]');
    }
    if(this.activeModal == null) return;
    this.pageOverlayElement.classList.remove("is-visible");
    this.pageOverlayElement.removeEventListener(
      "click",
      this.onClickOutsideListener
    );

    this.activeModal.setAttribute("aria-hidden", "true");

    bodyScrollLock.clearAllBodyScrollLocks();
    this.activeModal.removeAttribute("style");
  }
}

class RevolutionImageZoom {
  constructor(element, slideshow) {
    this.element = element;
    this.slideshow = slideshow;
    this.delegateElement = new Delegate(this.element);
    this.delegateRoot = new Delegate(document.body);
    loadScript(window.theme.pswpScript);
    this.syncHeight();
    this.bindEvents();
  }

  syncHeight() {
    document.documentElement.style.setProperty(
      "--window-inner-height",
      `${window.innerHeight}px`
    );
  }

  bindEvents() {
    window.addEventListener("resize", this.syncHeight());
    this.delegateElement.on(
      "click",
      '[data-action="open-product-zoom"]',
      this.initPhotoSwipe.bind(this)
    );
    this.delegateElement.on(
      "keydown",
      '[data-action="open-product-zoom"]',
      (event) => {
        if (event.key === "Enter") {
          this.initPhotoSwipe(); 
        }
      }
    );
    
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoswiperClose.bind(this)
    );
    this.delegateRoot.on(
      "keydown",
      '.pswp__button--close',
      (event) => {
        if (event.key === "Enter") {
          this.photoswiperClose(); 
        }
      }
    );
  }
  photoswiperClose() {

    this.photoSwipeInstance.close;
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.remove("pswp-open-in-ios");
    }
  }

  initPhotoSwipe() {
    var images = [],
      index = 0;
    if (this.slideshow) {
      this.slideshow.swiperElement.slides.forEach(function (item) {
        if (item.classList.contains("ProductSliderCell--Zoom")) {
          if (item.querySelector("img")) {
            images.push(item.querySelector("img"));
          }
        }
      });
      index = this.slideshow.swiperElement.realIndex;
      this.slideshow.swiperElement.slides[index]
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position");
    } else {
      images.push(document.querySelector(".ProductSlider--Image"));
    }

    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      parseInt(index)
    );
  }

  initPhotoSwipeFromImageClick(event, target) {
    // Check if the current breakpoint is "pocket". If it is, return without doing anything.
    if (new Responsive().matchesBreakpoint("pocket")) {
      return;
    }

    // Create an array of images from the siblings of the target element.
    const images = [];
    const siblings = Array.from(target.parentElement.children);

    siblings.forEach((item) => {
      if (
        item.classList.contains("ProductSliderCell--Zoom") &&
        item.querySelector("img")
      ) {
        images.push(item.querySelector("img"));
      }
    });

    // Get the image position from the target element's data attribute.
    const imagePosition = parseInt(
      target
        .querySelector(".ProductSlider--Element")
        .getAttribute("data-image-position")
    );

    // Create the PhotoSwipe instance using the images and image position.
    this.createPhotoSwipeInstance(
      this.createPhotoSwipeItemsFromImages(images),
      imagePosition
    );


  }

  createPhotoSwipeItemsFromImages(images) {
    return images.map(function (image) {
      var maxWidth = parseInt(image.getAttribute("data-max-width")),
        maxHeight = parseInt(image.getAttribute("data-max-height")),
        maxDimension = new Responsive().matchesBreakpoint("phone")
          ? 1200
          : 2200,
        reduceFactor = 1.0;

      if (maxWidth >= maxHeight) {
        reduceFactor = Math.max(maxWidth / maxDimension, 1.0);
      } else {
        reduceFactor = Math.max(maxHeight / maxDimension, 1.0);
      }
      var requestedWidth = Math.floor(maxWidth / reduceFactor);
      var requestedHeight = Math.floor(maxHeight / reduceFactor);
      return {
        msrc: image.currentSrc || image.src,
        w: requestedWidth,
        h: requestedHeight,
        initialZoomLevel: 0.65,
        src: image.dataset.originalSrc,
      };
    });
  }

  createPhotoSwipeInstance(items, selectedImageIndex) {

    var _this = this;
    var photoswipeContainer = document.querySelector(".pswp");
    this.photoSwipeInstance = new PhotoSwipe(
      photoswipeContainer,
      false,
      items,
      {
        index: selectedImageIndex,
        showHideOpacity: true,
        showAnimationDuration: 500,
        loop: false,
        history: false,
        closeOnVerticalDrag: true,
        allowPanToNext: false,
        pinchToClose: false,
        errorMsg: '<p class="pswp__error-msg"></p>',
        scaleMode: "orig",
        getDoubleTapZoom: function getDoubleTapZoom(isMouseClick, item) {
          if (isMouseClick) {
            return 1.35;
          } else {
            return item.initialZoomLevel < 0.7 ? 1 : 1.33;
          }
        },
        getThumbBoundsFn: function getThumbBoundsFn(index) {
          var allThumbnail = _this.element.querySelectorAll(
            ".mainSwiper .ProductSliderCell--Zoom img"
          ),
            thumbnail = allThumbnail[index],
            pageYScroll =
              window.pageYOffset || document.documentElement.scrollTop,
            rect = thumbnail.getBoundingClientRect();
          return { x: rect.left, y: rect.top + pageYScroll, w: rect.width };
        },
      }
    );

    this.photoSwipeInstance.listen(
      "beforeChange",
      this.onslideChanged.bind(this)
    );
    this.photoSwipeInstance.listen(
      "destroy",
      this.destroyPhotoSwipe.bind(this)
    );
    this.photoSwipeInstance.listen("doubleTap", this.onDoubleTap.bind(this));
    this.photoSwipeInstance.listen(
      "initialZoomIn",
      this.onInitialZoomIn.bind(this)
    );
    this.photoSwipeInstance.listen(
      "initialZoomOut",
      this.onInitialZoomOut.bind(this)
    );

    this.delegateRoot.on(
      "pswpTap",
      ".pswp__scroll-wrap",
      this.onSingleTap.bind(this)
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--close",
      this.photoSwipeInstance.close
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--prev",
      this.photoSwipeInstance.prev
    );
    this.delegateRoot.on(
      "pswpTap",
      ".pswp__button--next",
      this.photoSwipeInstance.next
    );

    this.photoSwipeInstance.listen("close", this.photoswiperClose.bind(this));
    if (/iPhone|iPad|iPod/i.test(window.navigator.userAgent)) {
      document.documentElement.classList.add("pswp-open-in-ios");
    }
    this.photoSwipeInstance.init();
  }

  onslideChanged() {
    if (this.photoSwipeInstance.getCurrentIndex() === 0) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--prev")
        .removeAttribute("disabled");
    }

    if (
      this.photoSwipeInstance.getCurrentIndex() + 1 ===
      this.photoSwipeInstance.options.getNumItemsFn()
    ) {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .setAttribute("disabled", "disabled");
    } else {
      this.photoSwipeInstance.scrollWrap
        .querySelector(".pswp__button--next")
        .removeAttribute("disabled");
    }
  }

  onSingleTap(event) {
    if (!event.detail || event.detail.pointerType === "mouse") {
      if (event.target.classList.contains("pswp__img")) {
        this.photoSwipeInstance.toggleDesktopZoom(event.detail.releasePoint);
      }
    } else {
      if (event.target.classList.contains("pswp__button")) {
        return;
      }

      event.target
        .closest(".pswp")
        .querySelector(".pswp__ui")
        .classList.toggle("pswp__ui--hidden");
    }
  }

  onDoubleTap(point) {
    var initialZoomLevel = this.photoSwipeInstance.currItem.initialZoomLevel;

    if (this.photoSwipeInstance.getZoomLevel() !== initialZoomLevel) {
      this.photoSwipeInstance.zoomTo(initialZoomLevel, point, 333);
    } else {
      this.photoSwipeInstance.zoomTo(
        initialZoomLevel < 0.7 ? 1 : 1.33,
        point,
        333
      );
    }
  }

  onInitialZoomIn() {
    document.querySelector(".pswp__ui").classList.remove("pswp__ui--hidden");
  }
  onInitialZoomOut() {
    document.querySelector(".pswp__ui").classList.add("pswp__ui--hidden");
  }
  destroyPhotoSwipe() {
    this.delegateRoot.off("pswpTap");
    this.photoSwipeInstance = null;
  }
}

class RevolutionSelectbox {
  constructor(element, popover, additionalOverlay) {
    this.element = element;
    this.popover = popover;
    this.changeOverlay = additionalOverlay;
    this.domDelegate = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.dropdown = this.element.querySelector(".RevolutionSelectbox");
    this.isOpen = false;
    this.selectorsOverlay = document.querySelector(".selectorsOverlay");
    this.mainDropdown = this.element.querySelector(
      ".RevolutionSelectbox--Content"
    );

    this.mainDropdownContent = this.element.querySelector(
      ".RevolutionSelectbox--InnerContent"
    );
    this.mainButton = this.element.querySelector(
      ".RevolutionSelectbox--Button"
    );

    this.connectedSelect = this.element.getAttribute("data-select");
    this.selectbox = this.element.querySelector(
      "[name=" + this.connectedSelect + "]"
    );
    if (this.selectbox == null) {
      this.selectbox = this.element.querySelector(
        "[name2=" + this.connectedSelect + "]"
      );
    }
    if (this.popover == true) {
      this.mainDropdown.classList.remove("RevolutionSelectbox--animation");
      this.mainDropdown.classList.add("PopoverContent");
      if (this.changeOverlay) {

        this.pageOverlayElement = document.querySelector(
          ".selectorsOverlay"
        );
      } else {
        this.pageOverlayElement = document.querySelector(".pageOverlay");
      }
    }

    this.bindEvents();
    this.initSelectbox();
  }

  bindEvents() {
    this.onClickOutsideListener = this.onClickOutside.bind(this);
    this.domDelegate.on(
      "click",
      "[data-action='toggle-selectbox']",
      this.toggleDropdown.bind(this)
    );
   
    this.domDelegate.on(
      "click",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );
    this.domDelegate.on(
      "keypress",
      "[data-action=selectbox-submit]",
      this.selectboxSubmit.bind(this)
    );

    this.domDelegate.on(
      "click",
      "[data-action=selectbox-change]",
      this.selectboxChange.bind(this)
    );

    this.delegateBody.on("menu:open", this.onClickOutside.bind(this));
    this.domDelegate.on("click", "body", this.onClickOutside.bind(this));
  }

  selectboxChange(event) {

    var value = event.target.getAttribute("data-value");
    var selectboxID = event.target.getAttribute("data-selectboxid");
    var innerContent = event.target.innerHTML;
    var selEl = this.element.querySelector("#" + selectboxID);
    if (selEl.nodeName == "SELECT") {
      selEl.value = value;
      selEl.dispatchEvent(new Event("change"));
      if(selEl.dataset.card == "true"){

        document.body.dispatchEvent(
          new CustomEvent("favorites:size_change", { bubbles: true,detail: {
            size: selEl.value,
            id: selEl.dataset.id
          } })
        );
      }

    } else {
      selEl.value = value;
    }
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      innerContent;

    if (this.element.classList.contains("dropdownSelector")) {
      this.element
        .querySelector('.RevolutionSelectbox--Item[disabled="true"]')
        .removeAttribute("disabled");
      event.target.setAttribute("disabled", "true");
    }
    if (event.target.dataset.selectboxid == 'country-selector__country-code') {
      this.element.dispatchEvent(
        new CustomEvent("change:countrySelector", {
          bubbles: true,
          detail: {
            currency: event.target.dataset.currency,
            country: event.target.value,
            languages: event.target.dataset.languages
          },
        })
      );

    }

    // Add data-selected attribute to the RevolutionSelectbox element
    this.element.setAttribute("data-selected", value);

    this.closeDropdown(this.element);
  }

  onClickOutside(event) {
    const withinBoundaries = event.composedPath().includes(this.element);
    if (
      !withinBoundaries ||
      event.target.classList.contains("FiltersDesktopWrapper")
    ) {
      this.closeDropdown(this.element);
    }
  }

  selectboxSubmit(event) {
    if (event.key != "Enter" && event.key !== undefined) {
      return;
    }
    event.preventDefault();
   
    var value = event.target.getAttribute("data-value");
    var dataName = event.target.getAttribute("data-name");
    this.selectbox.value = value;
    this.closeDropdown(this.element);
    this.mainButton.querySelector(".RevolutionSelectbox--Title").innerHTML =
      dataName;
    this.selectbox.parentElement.submit();
  }

  initSelectbox() {
    const selectedItem = this.mainDropdown.querySelector(
      '[selected="selected"]'
    ),
    titleElement = this.element.querySelector(".RevolutionSelectbox--Title");
    if (selectedItem) {
      titleElement.innerHTML = selectedItem.getAttribute("data-name");
    }

    trapFocus(this.element);
    this.element.style.display = "block";
  }

  toggleDropdown(event) {
    event.preventDefault();

    const target = event.currentTarget || event.target;

    if (this.isOpen) {
      this.closeDropdown(target);
    } else {
      this.openDropdown(target);
    }
  }

  openDropdown(target) {
    this.element.dispatchEvent(new CustomEvent("close:search", { bubbles: true }));
    this.element.dispatchEvent(new CustomEvent("menu:close", { bubbles: true }));

    const siblings = Array.from(
      target.parentElement.parentElement.children
    ).filter((item) => item.classList.contains("RevolutionSelectbox"));

    siblings.forEach((item) => {
      item.querySelector(".RevolutionSelectbox--Button").setAttribute("aria-expanded", false);
      item.querySelector(".RevolutionSelectbox--Content").setAttribute("aria-hidden", true);
      item.querySelector(".RevolutionSelectbox--Content").style.display = "none";
    });

    if (this.popover) {
      this.pageOverlayElement.classList.add("is-visible");
      this.pageOverlayElement.addEventListener("click", this.onClickOutsideListener);
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
      trapFocus(this.mainDropdown);
    }

    if (this.element.closest("#modal-country")) {
      bodyScrollLock.disableBodyScroll(document, bodyScrollLockOptions);
    }

    const contentElement = target.parentElement.querySelector(".RevolutionSelectbox--Content");

    // Clear any pending transitionend listeners from previous close animations
    if (this.pendingTransitionListener) {
      contentElement.removeEventListener("transitionend", this.pendingTransitionListener);
      this.pendingTransitionListener = null;
    }

    target.setAttribute("aria-expanded", "true");
    contentElement.setAttribute("aria-hidden", "false");

    contentElement.style.display = "block";
    contentElement.style.height = "0";
    contentElement.style.pointerEvents = "all";
    contentElement.offsetHeight;
    new RevolutionAnimation(contentElement, "true").slideDown();

    this.isOpen = true;
    window.addEventListener("click", this.onClickOutsideListener);
  }


  closeDropdown(target) {
    let closestDropdown = target.closest(".RevolutionSelectbox");
    if (closestDropdown === null) {
      closestDropdown = target.querySelector("[aria-expanded='true']")?.parentElement;
    }
    if (!closestDropdown) return;

    const button = closestDropdown.querySelector(".RevolutionSelectbox--Button");
    const content = closestDropdown.querySelector(".RevolutionSelectbox--Content");
    if (!content) return;

    // Clear any existing pending listener before creating a new one
    if (this.pendingTransitionListener) {
      content.removeEventListener("transitionend", this.pendingTransitionListener);
    }

    button.setAttribute("aria-expanded", false);
    content.setAttribute("aria-hidden", "true");

    // 🔼 Animate dropdown close
    new RevolutionAnimation(content, "true").slideUp();

    // Set display none and pointer events after animation completes
    this.pendingTransitionListener = (event) => {
      if (event.propertyName === "height") {
        content.style.display = "none";
        content.style.pointerEvents = "none";
        content.removeEventListener("transitionend", this.pendingTransitionListener);
        this.pendingTransitionListener = null;
      }
    };
    content.addEventListener("transitionend", this.pendingTransitionListener);

    if (this.popover === true) {
      this.pageOverlayElement.classList.remove("is-visible");
      this.pageOverlayElement.removeEventListener("click", this.onClickOutsideListener);

      const menuDrawer = document.querySelector("#mobile-menu");
      if (menuDrawer?.getAttribute("aria-expanded") !== "true") {
        bodyScrollLock.clearAllBodyScrollLocks();
        document.body.classList.remove("scrollLock");
      }
    }

    this.isOpen = false;
    removeTrapFocus(this.mainDropdownContent);
    window.removeEventListener("click", this.onClickOutsideListener);
  }

}

class Form {
  constructor() { }

  serialize(form) {
    function stringKey(key, value) {
      var beginBracket = key.lastIndexOf("[");

      if (beginBracket === -1) {
        var _hash = {};
        _hash[key] = value;
        return _hash;
      }

      var newKey = key.substr(0, beginBracket);
      var newValue = {};

      newValue[key.substring(beginBracket + 1, key.length - 1)] = value;

      return stringKey(newKey, newValue);
    }

    var hash = {};

    for (var i = 0, len = form.elements.length; i < len; i++) {
      var formElement = form.elements[i];

      if (formElement.name === "" || formElement.disabled) {
        continue;
      }

      if (
        formElement.name &&
        !formElement.disabled &&
        (formElement.checked ||
          /select|textarea/i.test(formElement.nodeName) ||
          /hidden|text|search|tel|url|email|password|datetime|date|month|week|time|datetime-local|number|range|color/i.test(
            formElement.type
          ))
      ) {
        var stringKeys = stringKey(formElement.name, formElement.value);
        hash = this.extend(hash, stringKeys);
      }
    }

    return hash;
  }
  extend() {
    var extended = {},
      i = 0,
      _this = this;

    // Merge the object into the extended object
    var merge = function merge(obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          // If property is an object, merge properties
          if (Object.prototype.toString.call(obj[prop]) === "[object Object]") {
            extended[prop] = _this.extend(extended[prop], obj[prop]);
          } else {
            extended[prop] = obj[prop];
          }
        }
      }
    };

    // Loop through each object and conduct a merge
    for (; i < arguments.length; i++) {
      merge(arguments[i]);
    }

    return extended;
  }
}

// Global lock for additional service button to prevent duplicate adds across all AddToCart instances
window._additionalServiceLock = window._additionalServiceLock || {
  isProcessing: false,
  lastClickTime: 0
};

class AddToCart {
  constructor(element) {
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.bindEvents();
    this.isProcessing = false;

  }
  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="add-to-cart"]',
      this.addToCart.bind(this)
    );

    this.delegateElement.on(
      "submit",
      'form[action="/cart/addall"]',
      this.addAllToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action=add-all-to-cart]",
      this.addAllToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action=remove-and-add-all-to-cart]",
      this.removeAndAddToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      ".cart-item-wrapper:has( [data-action=remove-and-add-all-to-cart]) .cartItem--Image",
      this.removeAndAddToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      ".cart-item-wrapper:has( [data-action=remove-and-add-all-to-cart]) .cartItem--Flex",
      this.removeAndAddToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      ".cart-item-wrapper:has( [data-action=remove-and-add-all-to-cart]) .product-option--Wrapper",
      this.removeAndAddToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      ".cart-item-wrapper:has( [data-action=remove-and-add-all-to-cart]) .cartItem__prices",
      this.removeAndAddToCart.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action=remove-group]",
      this.removeGroup.bind(this)
    );

    this.delegateElement.on(
      "click",
      "[data-action=remove-and-add-one]",
      this.removeGroupAndAddOne.bind(this)
    )

    this.delegateElement.on(
      "click",
      "[data-action=remove-and-connect]",
      this.handleMatchingFrame.bind(this)
    )
  }

  handleMatchingFrame(event) {
    event.preventDefault();
    const productIdToRemoveKey_1 = event.target.getAttribute('data-decrease-item-with-key');
    let quantityOfSingleProduct_1 = parseInt(event.target.getAttribute('data-single-frame-quantity'), 10);

    const productIdToRemoveKey_2 = event.target.getAttribute('data-remove-product');
    let quantityOfSingleProduct_2 = parseInt(event.target.getAttribute('data-single-product-quantity'), 10);

    quantityOfSingleProduct_1 = quantityOfSingleProduct_1 ? quantityOfSingleProduct_1 - 1 : null;
    quantityOfSingleProduct_2 = quantityOfSingleProduct_2 ? quantityOfSingleProduct_2 - 1 : null;

    const frame_key = event.target.getAttribute('data-frame-variant-id');
    const product_key = event.target.getAttribute('data-choosen-product');

    const unitSelected = event.target.getAttribute('data-unit-selected') || 
                      document.getElementById('unit-selected-input')?.value || 
                      document.querySelector('[name="properties[_unit_selected]"]')?.value;


    let updates = {
      [productIdToRemoveKey_1]: quantityOfSingleProduct_1,
      [productIdToRemoveKey_2]: quantityOfSingleProduct_2
    };

    const uniqueGroupIdentifier = `group-${Date.now()}`;
    let formData = {
      'items': [{
        'id': frame_key,
        'quantity': 1,
        'properties': {
          '_group_id': uniqueGroupIdentifier,
          // Include _unit_selected in frame properties if it exists
        ...(unitSelected && { '_unit_selected': unitSelected })
        
        },
      },
      {
        'id': product_key,
        'quantity': 1,
        'properties': {
          '_group_id': uniqueGroupIdentifier,
          // Include _unit_selected in product properties if it exists
        ...(unitSelected && { '_unit_selected': unitSelected })
        },
      }]
    };

    this.decreaseByOne(updates).then(() => {
      this.addMatchedToCart(formData).then(() => {

        this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              onlyRender: true,
            },
          })
        );
        this.element.dispatchEvent(
        new CustomEvent("subdrawer:close", {
          bubbles: true,
          detail: {
            onlyRender: true,
          },
        })
      );
      }).catch((error) => {
        console.log('Error add to cart group');
      });
    }).catch((error) => {
      console.log('Error decreaseByOne');
    });
  }

  addMatchedToCart(data) {
    return fetch("/cart/add.js", {
      body: JSON.stringify(data),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((response) => {
      if (!response.ok) {
        return response.json().then((content) => {
          throw new Error(content.description);
        });
      }
      return response.json();
    });
  }

  removeGroupAndAddOne(event) {
    event.preventDefault();
    const productsGroup = event.target.closest('.group-wrapper');
    const productToBeAddedAgainId = productsGroup.querySelector('[data-add-again]').dataset.addAgain;

    const quantityValue = productsGroup.querySelector('[data-add-again] .CartItem__Actions input') ?
      productsGroup.querySelector('[data-add-again] .CartItem__Actions input').getAttribute('value') : null;

    const quantity = parseInt(quantityValue, 10);

    this.addToCartWithId(productToBeAddedAgainId, quantity).then(() => {
      this.removeGroup(event);
    }).catch((error) => {
      this.handleAddToCartError(addToCartButton, error);
    });



  }

  addToCartWithId(productId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        id: productId,
        quantity: quantity
      })
    })
      .then(response => response.json())
      .then(data => {
        return data; // Resolve the promise with the response data
      })
      .catch(error => {
        console.error('Error adding product to cart:', error);
        throw error; // Reject the promise in case of error
      });
  }

  removeGroup(event) {
    event.preventDefault();

    const productsGroup = event.target.closest('.group-wrapper');
    this.loader = productsGroup.querySelector(".itemLoaderGroup");
    const propertyId = productsGroup.querySelector('.grouped-product').getAttribute('group-id');

    this.loader
      .classList.add("is-visible");

    this.getCartItems().then((items) => {
      const changes = items
        .filter(item => item.properties && item.properties._group_id === propertyId)
        .map(item => ({ id: item.key, item_id: item.id }));



      this.updateCart(changes).then(() => {
        changes.forEach(change => {
          this.element.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: change.item_id,
                quantity: 0,
              },
            })
          );

          this.element.dispatchEvent(
            new CustomEvent("subdrawer:close", {
              bubbles: true,
              detail: {
                onlyRender: true,
              },
            })
          );
        });
       
      }).catch(error => {
        console.error('Error processing items:', error);
        this.handleAddToCartError(null, error);
      });
    });
  }


  updateCart(changes) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({
        updates: changes.reduce((acc, change) => {
          acc[change.id] = 0;
          return acc;
        }, {})
      })
    })
      .then(response => response.json())
      .catch(error => {
        console.error('Error updating cart:', error);
        throw error;
      });
  }

  getCartItems() {
    return fetch('/cart.js', {
      credentials: 'same-origin',
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
    }).then(response => {
      if (!response.ok) {
        return response.json().then(content => {
          throw new Error(content.description);
        });
      }
      return response.json();
    }).then(data => data.items);
  }

  removeAndAddToCart(event) {

     // Prevent function from running if it's already in progress
    if (this.isProcessing) return;

    // Set the flag to indicate the function is processing
    this.isProcessing = true;
    
    event.preventDefault();

    const wrapper = event.target.closest(".cart-item-wrapper");
    const target = wrapper.querySelector("[data-action=remove-and-add-all-to-cart]");  
    
    const loader = target.closest('cart-subdrawer').querySelector(".itemLoader");
    loader.classList.add("is-visible");
    const addToCartButton = target;
    const quantityToAdd = parseInt(addToCartButton.dataset.quantity, 10);
    let quantityOfSingleProduct = parseInt(addToCartButton.dataset.singleProductQuantity, 10);

    addToCartButton.setAttribute("disabled", "disabled");
    document.dispatchEvent(new CustomEvent("theme:loading:start"));


    const productIdToRemoveKey = target.getAttribute('data-remove-product');

    const resetState = () => {
      // Reset the guard flag after 1 second (or desired timeout)
      setTimeout(() => {
        this.isProcessing = false;
      }, 1000); // Adjust timeout based on how long your process takes
    };

    if (quantityOfSingleProduct == 1) {
      this.removeProduct(event, productIdToRemoveKey).then(() => {
        this.addProductsToCart(addToCartButton, quantityToAdd).then(() => {
          resetState();
          addToCartButton.removeAttribute("disabled");
          this.element.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                onlyRender: true,
              }
            })
          );
          loader.classList.remove("is-visible");
          this.element.dispatchEvent(
            new CustomEvent("subdrawer:close", {
              bubbles: true,
              detail: {
                onlyRender: true,
              },
            })
          );

        }).catch((error) => {
          this.handleAddToCartError(addToCartButton, error);
          resetState();
        });
      }).catch((error) => {
        this.handleAddToCartError(addToCartButton, error);
        resetState();
      });
    } else {

      quantityOfSingleProduct = quantityOfSingleProduct - 1;
      let updates = {
        [productIdToRemoveKey]: quantityOfSingleProduct
      };

      this.decreaseByOne(updates).then(() => {
        this.addProductsToCart(addToCartButton, quantityToAdd).then(() => {
          resetState();
          addToCartButton.removeAttribute("disabled");
          this.element.dispatchEvent(
            new CustomEvent("product:added", {
              bubbles: true,
              detail: {
                variant: productIdToRemoveKey,
                quantity: quantityOfSingleProduct,
              },
            })
          );

          loader.classList.remove("is-visible"); 

          this.element.dispatchEvent(
            new CustomEvent("subdrawer:close", {
              bubbles: true,
              detail: {
                onlyRender: true,
              },
            })
          );


        }).catch((error) => {
          this.handleAddToCartError(addToCartButton, error);
          resetState();
        });
      }).catch((error) => {
        this.handleAddToCartError(addToCartButton, error);
        resetState();
      });

    }

  }

  decreaseByOne(updates) {
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json'
      },
      body: JSON.stringify({ updates })
    })
      .then(response => response.json())
      .catch(error => {
        console.error('Error updating cart:', error);
        throw error;
      });
  }

  removeProduct(event, productIdToRemoveKey) {
    return fetch("/cart/change.js", {
      body: JSON.stringify({
        id: productIdToRemoveKey,
        quantity: 0,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((response) => {
      if (!response.ok) {
        return response.json().then((content) => {
          throw new Error(content.description);
        });
      }
      return response.json();
    });


  }

  addProductsToCart(button, quantityToAdd) {
    const formElement = button.closest("form");        
    const formHelper = new Form();
    const formElementSerialized = formHelper.serialize(formElement);
    const items = [];
    const keys = Object.keys(formElementSerialized);

    // Get the _unit_selected from the form if it exists
  const unitSelected = formElement.querySelector('[name="properties[_unit_selected]"]')?.value || 
                      document.getElementById('unit-selected-input')?.value;

    const uniqueGroupIdentifier = `group-${Date.now()}`;
    keys.forEach((key) => {
      if (key !== "event_id") {
        const productID = document.body.querySelector(`[name="${key}"]`)?.getAttribute("data-id");
       
          if (productID) {
            items.unshift({
              id: productID,
              quantity: quantityToAdd,
              properties: {
                _group_id: uniqueGroupIdentifier,
                // Include _unit_selected in properties if it exists
              ...(unitSelected && { _unit_selected: unitSelected })
                
              },
            });
          }
      
      
      }
    });

    return fetch("/cart/add.js", {
      body: JSON.stringify({ items }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then((response) => {
      if (!response.ok) {
        return response.json().then((content) => {
          throw new Error(content.description);
        });
      }
      return response.json();
    });
  }

  handleAddToCartError(addToCartButton, error) {
    const errorMessageElement = document.createElement("span");
    errorMessageElement.className = "ProductForm__Error Alert Alert--error u-p4";
    errorMessageElement.innerHTML = error.message;
    addToCartButton.removeAttribute("disabled");
    addToCartButton.insertAdjacentElement("afterend", errorMessageElement);
    setTimeout(() => {
      errorMessageElement.remove();
    }, 2500);
  }




  addAllToCart(event) {

    var _this = this;
    event.preventDefault(); // Prevent form to be submitted
    var addToCartButton = event.target;

    // First, we switch the status of the button
    addToCartButton.setAttribute("disabled", "disabled");
    document.dispatchEvent(new CustomEvent("theme:loading:start"));

    // Then we add the product in Ajax
    var formElement = event.target.closest("form");
    const items = [];

    // Check if we're in favorites section (no form wrapper)
    if (!formElement) {
      // Gather all variant inputs from product cards in favorites
      const favoritesSection = event.target.closest('favorites-section');
      if (favoritesSection) {
        const variantInputs = favoritesSection.querySelectorAll('.product-card__variant-input');
        variantInputs.forEach(input => {
          // Exclude products from recommended products section
          if (input.closest('.favorites-section__recommended-products')) {
            return;
          }
          const variantID = input.value; // Get the selected variant ID from the input value
          const quantity = 1; // Default quantity for favorites
          if (variantID && variantID !== "" && variantID !== "undefined") {
            items.push({
              id: variantID,
              quantity: quantity,
              properties: {}
            });
          }
        });
      }
    } else {
      // Original logic for form-wrapped products
      var formHelper = new Form();
      const formElementSerialized = formHelper.serialize(formElement);
      const keys = Object.keys(formElementSerialized);

      // Get the _unit_selected value if present
      const unitSelected = formElement.querySelector('[name="properties[_unit_selected]"]')?.value ||
                        document.getElementById('unit-selected-input')?.value;

      const uniqueGroupIdentifier = `group-${Date.now()}`; // Generate a unique identifier for the group

      var quant = 1;
      keys.forEach((key) => {
        if (key != "event_id") {
          // Query within the form first, fallback to document.body for backwards compatibility
          const element = formElement.querySelector('[name="' + key + '"]') ||
                          document.body.querySelector('[name="' + key + '"]');
          let productID = null;
          if (element) {
            productID = element.getAttribute("data-id");
          }

          if (productID) {
            quant = document.body.querySelector("#quantity--id_" + productID);
            if (quant) {
              quant = quant.getAttribute("value");
            } else {
              quant = 1;
            }
          }


            if (productID) {
              items.unshift({
                id: productID,
                quantity: quant,
                properties: {
                  _group_id: uniqueGroupIdentifier,
                  // Include _unit_selected in properties if it exists
                ...(unitSelected && { _unit_selected: unitSelected })
                }

              });

          }


        }
      });
    }

    const additionalInfo = formElement ? formElement.querySelector('#additional_pdp_info') : null;
    const frame = document.querySelector('.frame-products__wrapper [aria-selected="true"]');
    let cartDetails = [];
    if (additionalInfo) {

      
      // Add first item
      cartDetails.push({
          productName: additionalInfo.dataset.title,
          quantity: 1,
          price: additionalInfo.dataset.price,
          sku: additionalInfo.dataset.sku,
          variantTitle: additionalInfo.dataset.variant
      });
  
      // Add second item
      if(frame){
        const frameDetails = JSON.parse(frame.dataset.cardSettings);
        cartDetails.push({
          productName: frameDetails.title,
          quantity: 1,
          price: frameDetails.price,
          sku: frameDetails.sku,
          variantTitle: additionalInfo.dataset.variant
      });
      }

  }
  

    fetch("/cart/add.js", {
      body: JSON.stringify({
        items: items,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
      },
    }).then(function (response) {
      if (response.ok) {
        const cartAddEvent = new CustomEvent("cart:add", {
          detail: cartDetails
        });
        document.dispatchEvent(cartAddEvent);
        
        addToCartButton.removeAttribute("disabled");
        // We simply trigger an event so the mini-cart can re-render
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: _this.currentVariant,
              quantity: items.length
            },
          })
        );

        _this.element.dispatchEvent(
          new CustomEvent("subdrawer:close", {
            bubbles: true,
            detail: {
              onlyRender: true,
            },
          })
        );
      } else {
        response.json().then(function (content) {
          var errorMessageElement = document.createElement("span");
          errorMessageElement.className =
            "ProductForm__Error Alert Alert--error u-p4";
          errorMessageElement.innerHTML = content["description"];
          addToCartButton.removeAttribute("disabled");
          addToCartButton.insertAdjacentElement(
            "afterend",
            errorMessageElement
          );
          setTimeout(function () {
            errorMessageElement.remove();
          }, 2500);
        });
      }
    });

    event.preventDefault();
  }


  addToCart() {

    var _this = this;
    event.preventDefault();

    var addToCartButton = event.target.closest('[data-action="add-to-cart"]');
    const isAdditionalServiceButton = addToCartButton.classList.contains('additional-servece-button');
    const globalLock = window._additionalServiceLock;

    // Global throttle and lock for additional-servece-button (500ms + processing lock)
    if (isAdditionalServiceButton) {
      const now = Date.now();

      // Block if already processing OR clicked within 500ms
      if (globalLock.isProcessing || (now - globalLock.lastClickTime < 500)) {
        return;
      }

      // Set lock immediately
      globalLock.isProcessing = true;
      globalLock.lastClickTime = now;
    }

    const productCardForm = addToCartButton.closest(".product-card__form");
    const variantInput = productCardForm?.querySelector(".product-card__variant-input");

    if (productCardForm && variantInput?.value === "") {
      event.stopPropagation();
      this.element.dispatchEvent(new CustomEvent("invalid", { bubbles: true }));
      return;
    }
    this.pageLoader.style.width = 100 + "%";
    addToCartButton.setAttribute("disabled", "disabled");

    var formElement;
    var groupId = null;
    var variantId = null;
    if (addToCartButton.hasAttribute('data-group-id')) {
      groupId = addToCartButton.getAttribute('data-group-id');
      const productId = addToCartButton.getAttribute('data-product-id');
      variantId = addToCartButton.getAttribute('data-variant-id');
      const sku = addToCartButton.getAttribute('data-sku');
      const quantityValue = event.target.dataset.quantity;

      // Create a form dynamically
      formElement = document.createElement('form');

      var quantityInput = document.createElement('input');
      quantityInput.type = 'hidden';
      quantityInput.name = 'quantity';
      quantityInput.value = `${quantityValue}`;
      formElement.appendChild(quantityInput);

      var idInput = document.createElement('input');
      idInput.type = 'hidden';
      idInput.name = 'id';
      idInput.value = variantId;
      idInput.setAttribute('data-productid', productId);
      idInput.setAttribute('data-sku', sku);
      formElement.appendChild(idInput);

      // Add the group id to the form properties
      var propertiesInput = document.createElement('input');
      propertiesInput.type = 'hidden';
      propertiesInput.name = 'properties[_group_id]';
      propertiesInput.value = groupId;
      formElement.appendChild(propertiesInput);

      const unitSelectedInput = document.getElementById('unit-selected-input');
      if (unitSelectedInput) {
        const copiedUnit = document.createElement('input');
        copiedUnit.type = 'hidden';
        copiedUnit.name = 'properties[_unit_selected]';
        copiedUnit.value = unitSelectedInput.value;
        formElement.appendChild(copiedUnit);
      }


    } else {
      formElement = event.target.closest("form");
    }

    const additionalInfo = formElement.querySelector('#additional_pdp_info');
    let cartDetails = [];
    if (additionalInfo) {


      // Add first item
      cartDetails.push({
          productName: additionalInfo.dataset.title,
          quantity: 1,
          price: additionalInfo.dataset.price,
          sku: additionalInfo.dataset.sku,
          variantTitle: additionalInfo.dataset.variant
      });


    }



    formElement.querySelector('[name="id"]').removeAttribute("disabled");
    var formHelper = new Form();
    const serialized = formHelper.serialize(formElement);

    // For additional service button, check cart first to prevent duplicates
    if (isAdditionalServiceButton && groupId && variantId) {
      fetch(window.routes.localeRootUrl + "/cart.js", {
        credentials: "same-origin",
        method: "GET",
        headers: { "Content-Type": "application/json" },
      })
      .then(response => response.json())
      .then(cart => {
        const existingItem = cart.items.find(item =>
          item.properties &&
          item.properties._group_id === groupId &&
          String(item.variant_id) === String(variantId)
        );
        if (existingItem) {
          window._additionalServiceLock.isProcessing = false;
          addToCartButton.removeAttribute("disabled");
          _this.pageLoader.style.left = "unset";
          _this.pageLoader.style.right = 0 + "px";
          _this.pageLoader.style.width = 0 + "%";
          setTimeout(() => {
            _this.pageLoader.style.left = 0 + "px";
            _this.pageLoader.style.right = "unset";
          }, 550);
          return;
        }
        // Product not in cart, proceed with add
        _this.executeAddToCart(serialized, cartDetails, addToCartButton, true);
      })
      .catch(() => {
        _this.executeAddToCart(serialized, cartDetails, addToCartButton, true);
      });
      return;
    }

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      if (response.ok) {
        const cartAddEvent = new CustomEvent("cart:add", {
          detail: cartDetails
        });
        document.dispatchEvent(cartAddEvent);

        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        if (window.theme.cartMode == 'page') {
          location.href = '/cart';
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
              properties: {
                _unit_selected: serialized._unit_selected,
              },
            },
          })
        );

      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }

  executeAddToCart(serialized, cartDetails, addToCartButton, isAdditionalService = false) {
    var _this = this;

    fetch(window.routes.localeRootUrl + "/cart/add.js", {
      body: JSON.stringify(serialized),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      // Release global lock for additional service button
      if (isAdditionalService) {
        window._additionalServiceLock.isProcessing = false;
      }

      if (response.ok) {
        const cartAddEvent = new CustomEvent("cart:add", {
          detail: cartDetails
        });
        document.dispatchEvent(cartAddEvent);

        if (window.location.href.indexOf("cart") != -1) {
          location.reload();
          return;
        }
        if (window.theme.cartMode == 'page') {
          location.href = '/cart';
          return;
        }
        addToCartButton.removeAttribute("disabled");
        _this.element.dispatchEvent(
          new CustomEvent("product:added", {
            bubbles: true,
            detail: {
              variant: serialized.id,
              quantity: serialized.quantity,
              properties: {
                _unit_selected: serialized._unit_selected,
              },
            },
          })
        );

      } else {
        response.json().then(function (content) {
          if (_this.element.querySelector(".ProductForm--Error")) {
            _this.element
              .querySelector(".ProductForm--Error")
              .classList.add("visible");
            setTimeout(function () {
              _this.element
                .querySelector(".ProductForm--Error")
                .classList.remove("visible");
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          } else {
            var errorMessageElement = document.createElement("span");
            errorMessageElement.className = "u-p4 accent";
            errorMessageElement.innerHTML = content["description"];
            addToCartButton.removeAttribute("disabled");
            addToCartButton.insertAdjacentElement(
              "afterend",
              errorMessageElement
            );
            setTimeout(function () {
              errorMessageElement.remove();
            }, 2500);
            _this.pageLoader.style.left = "unset";
            _this.pageLoader.style.right = 0 + "px";
            _this.pageLoader.style.width = 0 + "%";
            setTimeout(() => {
              _this.pageLoader.style.left = 0 + "px";
              _this.pageLoader.style.right = "unset";
            }, 550);
          }
        });
      }
    });
  }


}

/*GLOBAL FUNCTIONS */

function handleFirstTab(e) {
  if (e.keyCode === 9) {
    document.body.classList.add("user-is-tabbing");

    window.removeEventListener("keydown", handleFirstTab);
    window.addEventListener("mousedown", handleMouseDownOnce);
  }
}

function handleMouseDownOnce() {
  document.body.classList.remove("user-is-tabbing");

  window.removeEventListener("mousedown", handleMouseDownOnce);
  window.addEventListener("keydown", handleFirstTab);
}

window.addEventListener("keydown", handleFirstTab);

function getFocusableElements(container) {
  return Array.from(
    container.querySelectorAll(
      "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object, iframe, .focusable"
    )
  );
}

const trapFocusHandlers = {};

function trapFocus(container, elementToFocus = container) {
  var elements = getFocusableElements(container);

  // For favorites drawer, exclude elements inside the swiper to prevent unwanted sliding
  if (container.getAttribute && container.getAttribute('id') === 'product-drawer') {
    elements = elements.filter(el => !el.closest('.favorites-section__recommended-products'));
  }

  var first = elements[0];
  var last = elements[elements.length - 1];

  removeTrapFocus();

  trapFocusHandlers.focusin = (event) => {
    if (
      event.target !== container &&
      event.target !== last &&
      event.target !== first
    )
      return;

    document.addEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.focusout = function () {
    document.removeEventListener("keydown", trapFocusHandlers.keydown);
  };

  trapFocusHandlers.keydown = function (event) {
    if (event.code.toUpperCase() !== "TAB") return; // If not TAB key
    // On the last focusable element and tab forward, focus the first element.
    if (event.target === last && !event.shiftKey) {
      event.preventDefault();
      first.focus();
    }

    //  On the first focusable element and tab backward, focus the last element.
    if (
      (event.target === container || event.target === first) &&
      event.shiftKey
    ) {
      event.preventDefault();
      last.focus();
    }
  };

  document.addEventListener("focusout", trapFocusHandlers.focusout);
  document.addEventListener("focusin", trapFocusHandlers.focusin);
  if (first) {
    // Prevent scroll for product-drawer to avoid image jumping
    if (container.getAttribute && container.getAttribute('id') === 'product-drawer') {
      first.focus({ preventScroll: true });
    } else {
      first.focus();
    }
  } else {
    // Prevent scroll for product-drawer to avoid image jumping
    if (container.getAttribute && container.getAttribute('id') === 'product-drawer') {
      elementToFocus.focus({ preventScroll: true });
    } else {
      elementToFocus.focus();
    }
  }
}

function removeTrapFocus(elementToFocus = null) {
  document.removeEventListener("focusin", trapFocusHandlers.focusin);
  document.removeEventListener("focusout", trapFocusHandlers.focusout);
  document.removeEventListener("keydown", trapFocusHandlers.keydown);

  if (elementToFocus) elementToFocus.focus();
}

class Dropdown {
  constructor() {
    this.domDelegate = new Delegate(document.body);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.allDropdowns = document.querySelectorAll(".Dropdown");
    this.pageOverlayElement = document.querySelector(".pageOverlay");

    this.bindEvents();
  }

  bindEvents() {
    // Bind event for general dropdown toggle
    this.domDelegate.on(
      "click",
      "[data-action=toggle-dropdown]",
      this.toggleDropdown.bind(this)
    );

    let selector;
    switch (this.breakpoint) {

      case "lap-and-up":
        // For lap-and-up breakpoint, bind event for desktop dropdown toggle
        selector = "[data-action=toggle-desktop-dropdown]";
        break;
      case "pocket":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      case "phone":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      case "tablet":
        // For pocket breakpoint, bind event for mobile dropdown toggle
        selector = "[data-action=toggle-mobile-dropdown]";
        break;
      default:
        // If no specific breakpoint, set selector as false to skip binding
        selector = false;
        break;
    }

    if (selector) {
      // Bind event for specific breakpoint dropdown toggle
      this.domDelegate.on("click", selector, this.toggleDropdown.bind(this));
    }
  
  }

  openDropdown(elem, target) {
    this.lock = true;
    // Open the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    this.allDropdowns.forEach((dropdown) => {
      if (
        dropdown !== target.closest(".Dropdown") &&
        dropdown.querySelector("[aria-expanded='true']") &&
        !dropdown.classList.contains("do-not-close")
      ) {
        this.closeDropdown(dropdown);
      }
    });

    DropdownButton.setAttribute("aria-expanded", "true");

    new RevolutionAnimation(DropdownContent, "true").slideDown();

    setTimeout(() => {

      this.lock = false;
    }, 300);
  }

  closeDropdown(elem) {
    this.lock = true;
    // Close the dropdown by setting appropriate attributes and performing animation
    const DropdownButton = elem.querySelector(".Dropdown--Button");
    const DropdownContent = elem.querySelector(".Dropdown--Content");

    new RevolutionAnimation(DropdownContent, "true").slideUp();
    DropdownButton.setAttribute("aria-expanded", false);

    setTimeout(() => {
      if (DropdownContent.getAttribute("aria-hidden") == "false") {
        DropdownContent.setAttribute("aria-hidden", "true");
      }

      this.lock = false;
    }, 300);
  }

  toggleDropdown(event, target) {
    event.preventDefault();
    const mainDropdown = target.closest(".Dropdown");
    const isOpen = target.getAttribute("aria-expanded") === "true";

    if (!this.lock) {
      if (isOpen) {
        // If dropdown is open, close it
        this.closeDropdown(mainDropdown, target);
      } else {
        // If dropdown is closed, open it
        this.openDropdown(mainDropdown, target);
      }
    }
  }
}

const allDropdowns = new Dropdown();

class ReloadWhen1025 {
  constructor() {
    this.previousWidth = window.innerWidth;
    this.bindEvents();
  }

  bindEvents() {
    window.addEventListener('resize', this.checkWidthAndReload.bind(this));
  }

  checkWidthAndReload() {
    const currentWidth = window.innerWidth;
    if ((this.previousWidth < 1025 && currentWidth >= 1025) || (this.previousWidth >= 1025 && currentWidth < 1025)) {
      location.reload();
    }
    this.previousWidth = currentWidth;
  }
}

new ReloadWhen1025();

class RevolutionSwiper {
  constructor(element, additionalSwiper) {
    // Defensive: avoid crashing the entire theme JS if markup is missing
    // (a null element would throw when reading attributes).
    if (!element) {
      this.element = null;
      this.thumb = null;
      this.initialConfig = null;
      return;
    }
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.thumb = additionalSwiper;
    const configAttr = element.getAttribute("data-swiper-settings");
    try {
      this.initialConfig = configAttr ? JSON.parse(configAttr) : {};
    } catch (e) {
      this.initialConfig = {};
    }

    if (additionalSwiper) {
      const thumbAttr = additionalSwiper.getAttribute("data-swiper-thumb-settings");
      try {
        this.initialConfigThumbs = thumbAttr ? JSON.parse(thumbAttr) : null;
      } catch (e) {
        this.initialConfigThumbs = null;
      }
    }
    this.options = options;
    this.build();
  }

  selectCell(index) {
    this.swiperElement.slideTo(index);
  }

  resize() {
    this.swiperElement.resize();
  }

  build() {
    var _this = this,
      configThumb = this.initialConfigThumbs;
    if (configThumb != null) {
      this.thumbSwiper = new Swiper(this.thumb, configThumb);
      this.initialConfig.thumbs["swiper"] = this.thumbSwiper;
    }

    this.swiperElement = new Swiper(this.element, this.initialConfig);
    this.selectedIndex = this.swiperElement.activeIndex;

    this.swiperElement.on("slideChange", function () {

      _this.element.dispatchEvent(
        new CustomEvent("swiper:slide-changed", {
          bubbles: true,
          detail: {
            currentIndex: _this.swiperElement.activeIndex,
            element: _this.swiperElement.el[0],
          },
        })
      );
    });


  }

  destroy() {
    this.swiperElement.destroy();
  }
}

class Drawer {
  constructor(element) {
    var options =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    this.element = element;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pdpInfo = document.body.querySelector('.product-info__wrapper');

    if (this.element.getAttribute("id") === "sizeGuide") {
      this.pageOverlayElement = document.querySelector(
        ".page-overlay-size-guide-block"
      );

    }
    else if (this.element.getAttribute("id") === "frames-info-drawer") {
      this.pageOverlayElement = document.querySelector(
        ".page-overlay-frame-block"
      );

    } else {
      this.pageOverlayElement = document.querySelector(".pageOverlay");
    }


    if (navigator.platform === "iPhone")
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    this.onOpen = options["onOpen"] || function () { };
    this.onClose = options["onClose"] || function () { };
    this.isOpen = false;

    this.bindEvents();
  }

  bindEvents() {
    this.delegateBody.on(
      "click",
      '[data-action="open-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.openDrawer.bind(this)
    );
    this.delegateBody.on(
      "click",
      '[data-action="close-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.closeDrawer.bind(this)
    );
  
   
    this.delegateBody.on(
      "click",
      '[data-action="toggle-drawer"][data-toggle-id="' + this.element.id + '"]',
      this.toggleDrawer.bind(this)
    );

    this._openListener = this.openDrawer.bind(this);
    this._closeListener = this.closeDrawer.bind(this);
    this.calculateMaxHeightListener = this.maxHeight.bind(this);
    responsive.addResizeListener(this, this.calculateMaxHeightListener);

    this.delegateBody.on("drawer:close-other", this._closeListener);

    this.delegateBody.on("keydown", onEscape((event) => {
      if(this.isOpen) {
        this.closeDrawer(event);
      }
    })
  )};


 
  maxHeight() {
    if (
      this.element.getAttribute("id") == "cart" || this.element.getAttribute("id") == "sidebarFavorites"
    ) {
      var footer = this.element.querySelector(".CartDrawer--Footer");
      var footerHeight = 0;
      if (footer !== null) {
        footerHeight = footer.offsetHeight;
      }

      var headerEl = this.element.querySelector(".CartHeader");
      if (headerEl) {
        var header = headerEl.offsetHeight;
      }

      var itemWrapper = this.element.querySelector(".CartItems--Wrapper");

      if (itemWrapper !== null) {

        itemWrapper.style.height =
          window.innerHeight - footerHeight - header + "px";
      }
    } else if(this.element.getAttribute("id")=="product-drawer"){
      this.element.style.maxHeight= `${this.element.closest('.product-card__image-wrapper').offsetHeight + 1}px`;
    }else
      this.element.style.height = window.innerHeight + "px";
    const headerHeight = this.element.querySelector('.Drawer--Header')
      ? this.element.querySelector('.Drawer--Header').offsetHeight : 0;
  }

  toggleDrawer() {
    event.preventDefault();
    event.stopPropagation();
    this.isOpen ? this.closeDrawer() : this.openDrawer();
  }

  openDrawer() {
     if (this.element.getAttribute("id") === "sizeGuide" || this.element.getAttribute("id") === "frames-info-drawer"){
          const scrollableArea = this.element.querySelector("[data-scrollable]");
          if (scrollableArea) {
            scrollableArea.scrollTop = 0; 
          }

     }

  if(this.element.getAttribute("id") == "size-guide-collection-page"){
    this.pageOverlayElement.classList.add("subdrawer");
  }
  if(this.element.getAttribute("id") == "favorites-drawer"){
    this.element.style.display = "";
  }
  // Don't close other drawers for in-card drawers (product-drawer) or subdrawers (size-guide-collection-page)
  const drawerId = this.element.getAttribute("id");
  if(drawerId !== "size-guide-collection-page" && drawerId !== "product-drawer"){
    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );
    // Also don't close search when opening these drawers
    this.element.dispatchEvent(
      new CustomEvent("close:search", { bubbles: true })
    );
  }

    if (this.element.getAttribute("id") == "cart") {
      this.element.dispatchEvent(
        new CustomEvent("cart-drawer:open", { bubbles: true })
      );

    }
    if (this.isOpen) {
      return;
    }

    if (this.element.classList.contains('DrawerPDP')) {
      this.pdpInfo ? this.pdpInfo.style.zIndex = 10 : null;
    }

    this.maxHeight();

    if (this.element.getAttribute("id") == "mobile-menu") {
      this.hamburger = document.body.querySelector(".header--Hamburger");
      this.hamburger.classList.add('is-active');
  
    }

    if (this.element.getAttribute("id") == "mobile-menu") {
      document.querySelector(".Drawer--Close").style.display = "block";
      this.element.dispatchEvent(
        new CustomEvent("sidebar-drawer:open", {
          bubbles: true,
        })
      );
    } else {
      if (this.element.getAttribute("id") !== "product-drawer") {
        this.pageOverlayElement.classList.add("is-visible");
      }
    }

    // For favorites drawer, use requestAnimationFrame to ensure transition works on first open
    if(this.element.getAttribute("id") == "favorites-drawer"){
      requestAnimationFrame(() => {
        this.element.setAttribute("aria-expanded", "true");
      });
    } else {
      this.element.setAttribute("aria-expanded", "true");
    }

    // Don't lock scroll or add overlay listeners for product-drawer
    if (this.element.getAttribute("id") !== "product-drawer") {
      this.pageOverlayElement.addEventListener("click", this._closeListener);
      const focus = this.element.querySelector("[data-scrollable]");
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      document.body.classList.add("scrollLock");
    }

    if(this.element.getAttribute("id") === "product-drawer"){
      const overlay = this.element.closest('.product-card__image-wrapper')?.querySelector(".product-card__overlay");
      if (overlay) {
        overlay.classList.add("is-visible");
      }

      // Add click outside listener for product drawer
      setTimeout(() => {
        this._clickOutsideListener = (e) => {
          if (!this.element.contains(e.target) && !e.target.closest('[data-action="toggle-drawer"][data-toggle-id="product-drawer"]')) {
            this.closeDrawer();
          }
        };
        document.addEventListener("click", this._clickOutsideListener);
      }, 0);
    }

    this.isOpen = true;
    requestAnimationFrame(() => {
      trapFocus(this.element);
    });
    this.onOpen();
    return false;
  }

  closeDrawer(event) {
    if (!this.isOpen) return;
    if (event) {
      event.preventDefault();
    }

    if (this.element.getAttribute("id") == "mobile-menu") {
    }

    if (this.element.getAttribute("id") == "mobile-menu") {
      this.hamburger.classList.remove('is-active');
    }

    this.element.setAttribute("aria-expanded", "false");

    if (this.element.getAttribute("id") !== "product-drawer") {
        // Don't remove overlay or unlock scroll for product-drawer
        this.pageOverlayElement.classList.remove("is-visible");
        document.body.classList.remove("scrollLock");

        bodyScrollLock.clearAllBodyScrollLocks();
        this.pageOverlayElement.removeEventListener("click", this._closeListener);
        removeTrapFocus(this.element);
    } else {
        // Remove overlay for product-drawer
        const overlay = this.element.closest('.product-card__image-wrapper')?.querySelector(".product-card__overlay");
        if (overlay) {
          overlay.classList.remove("is-visible");
        }

        // Remove click outside listener for product drawer
        if (this._clickOutsideListener) {
          document.removeEventListener("click", this._clickOutsideListener);
          this._clickOutsideListener = null;
        }
    }

    this.isOpen = false;
        setTimeout(() => {
          this.pdpInfo ? this.pdpInfo.style.zIndex = 4 : null;
        }, 500);

        
        this.onClose();
      
  }

}

class RevolutionAnimation {
  constructor(element, directAnimation) {
    this.element = element;
    if (!directAnimation) {
      this.intersectionObserver = [];
      this.integer = 0;
      var contentToAnimate = document.querySelectorAll("[data-animation]");
      contentToAnimate.forEach((item, i) => {
        this.animateElement(item, i);
        this.integer = this.integer + 1;
      });

      // Listen for changes to the DOM and animate any new elements
      const observer = new MutationObserver((mutations) => {
        mutations.forEach((mutation) => {
          mutation.addedNodes.forEach((node) => {
            if (node.nodeType === Node.ELEMENT_NODE) {
              const newContentToAnimate = node.querySelectorAll("[data-animation]");

              newContentToAnimate.forEach((item, i) => {
                this.animateElement(item, this.integer);
                this.integer = this.integer + 1;
              });
            }
          });
        });
      });

      observer.observe(document.body, { childList: true, subtree: true });
    }
  }

  slideUp() {
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.offsetHeight;
    this.element.style.height = 0;
  }

  slideDown() {
    if (this.element.style.height === "auto") {
      return;
    }
    var _this = this;
    this.element.style.height = this.element.scrollHeight + "px";
    this.element.setAttribute("aria-hidden", false);
    var transitionEnded = function transitionEnded(event) {
      _this.element.style.pointerEvents = "all";
      if (event.propertyName === "height") {
        _this.element.style.height = "auto";
        _this.element.removeEventListener("transitionend", transitionEnded);
      }
    };

    this.element.addEventListener("transitionend", transitionEnded);
  }

  // A function to animate a list of elements by scaling them out
  elementScaleOut(elements) {
    // Get the animation duration and delay from the theme settings
    const animationDuration = window.theme.animationDuration * 2;
    const animationDelay = window.theme.animationBetweenElements;

    // Loop through each element in the list
    elements.forEach((element, index) => {
      // Check if the element has already been loaded
      if (element.hasAttribute("data-loaded")) {
        // If so, skip this element
        return;
      }

      // Mark the element as loaded to prevent duplicate animations
      element.setAttribute("data-loaded", true);

      // Define the animation keyframes
      const keyframes = [
        { transform: "scale(104%)", opacity: "0" },
        { transform: "scale(100%)", opacity: "1" },
      ];

      // Define the animation options
      const animationOptions = {
        duration: animationDuration,
        fill: "forwards",
      };

      // Schedule the animation with a delay based on the element's position in the list
      setTimeout(() => {
        element.animate(keyframes, animationOptions);
      }, animationDelay * index);
    });
  }



  elementScaleIn(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "scale(96%)", opacity: "0" },
          { transform: "scale(100%)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration * 2,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromTop(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(-30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromBottom(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateY(30px)", opacity: "0" },
          { transform: "translateY(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  elementFromRight(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeft(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-30px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromRightBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
        item.setAttribute("data-loaded", true);
      }, window.theme.animationBetweenElements * i);
    });
  }
  elementFromLeftBig(toReveal) {
    toReveal.forEach((item, i) => {
      if (item.getAttribute("data-loaded")) {
        return;
      }
      setTimeout(() => {
        var elementMove = [
          // keyframes
          { transform: "translateX(-120px)", opacity: "0" },
          { transform: "translateX(0px)", opacity: "1" },
        ];
        item.animate(elementMove, {
          // timing options
          duration: window.theme.animationDuration,
          fill: "forwards",
        });
      }, window.theme.animationBetweenElements * i);
      item.setAttribute("data-loaded", true);
    });
  }

  animateElement(animatedItem, index) {

    const options = {
      integer: index,
      type: animatedItem.dataset.animation,
    };

    if (this.intersectionObserver[index]) {
      this.intersectionObserver[index].disconnect();
    }

    this.intersectionObserver[index] = new IntersectionObserver(
      (results) => {
        const integer = options.integer;
        const elements = [];

        // Iterate over the IntersectionObserverEntry objects in the results array.
        results.forEach((result) => {

          // Check if the target element is intersecting the root element or if its intersection ratio is greater than 0.
          if (result.isIntersecting || result.intersectionRatio > 0) {
            // Add the target element to the elements array.
            elements.push(result.target);
            // Unobserve the target element.
            this.intersectionObserver[integer].unobserve(result.target);
          }
        });

        // If there are no elements to reveal, return.
        if (elements.length === 0) {
          return;
        }

        // An object that maps each animation type to the corresponding animation function.
        const animations = {
          elementFromTop: 'elementFromTop',
          elementFromBottom: 'elementFromBottom',
          elementFromRight: 'elementFromRight',
          elementFromLeft: 'elementFromLeft',
          elementFromLeftBig: 'elementFromLeftBig',
          elementFromRightBig: 'elementFromRightBig',
          elementScaleIn: 'elementScaleIn',
          elementScaleOut: 'elementScaleOut'
        };

        // Get the animation function corresponding to the type from the animations object.
        const animation = animations[options.type];
        // If the animation function exists, call it with the elements array.
        if (animation) {
          this[animation](elements);
        }
      },
      { threshold: 0.1 }
    );

    if (animatedItem.classList.contains('animatedContent')) {
      this.intersectionObserver[index].observe(animatedItem);
    }

    animatedItem.querySelectorAll('.animatedContent').forEach((item) => {
      this.intersectionObserver[index].observe(item);
    });
  }
}

if (window.theme.enableAnimations) {
  document.addEventListener("DOMContentLoaded", function () {
    new RevolutionAnimation();
  });
}


class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.input = this.querySelector("input");
    this.changeEvent = new Event("quantity:changed", { bubbles: true });
    this.options = JSON.parse(this.element.getAttribute("data-settings"));

    this.querySelectorAll("button").forEach((button) =>
      button.addEventListener("click", this.onButtonClick.bind(this))
    );
  }

  onButtonClick(event) {
    event.preventDefault();
    const previousValue = this.input.value;

    event.target.name === "plus" ? this.input.stepUp() : this.input.stepDown();
    if (previousValue !== this.input.value)
      this.input.dispatchEvent(this.changeEvent);

    if (this.options['noVariants'] == "true") {
      this.toggleAddButton();
    }
  }


  toggleAddButton() {
    let priceElement = "";
    let quantity = "";
    const addButtons = document.querySelectorAll(".product__atc");
    const quantityEl = document.querySelector('.QuantitySelector__ProductQuantity');

    if (quantityEl) quantity = quantityEl.value();

    if (window.variantInfo.show_price) {
      let priceValue = this.options['price'] * quantity;
      priceValue = Math.round(priceValue / 100) * 100;
      let priceElement =
        "<span class='u-pb1 ml-s'>" +
        Shopify.formatMoney(
          priceValue,
          window.theme.moneyFormat
        );
      +"</span>";
    }

    if (addButtons.lenght === 0) return;
    if (!quantity) { quantity = 1; }

    addButtons.forEach(addButton => {
      addButtons.removeAttribute("disabled");
      addButtons.classList.remove("ProductCard--Sold__Out");

      const addButtonInner = addButton.querySelector(".SelfAlign");
      addButtonInner.innerHTML = window.variantStrings.addToCart + priceElement;
    });
  }

}

customElements.define("quantity-input", QuantityInput);

function debounce(fn, wait) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
}

const serializeForm = (form) => {
  const obj = {};
  const formData = new FormData(form);
  for (const key of formData.keys()) {
    obj[key] = formData.get(key);
  }
  return JSON.stringify(obj);
};

function fetchConfig(type = "json") {
  return {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      Accept: `application/${type}`,
    },
  };
}

/*
 * Shopify Common JS
 *
 */
if (typeof window.Shopify == "undefined") {
  window.Shopify = {};
}

Shopify.bind = function (fn, scope) {
  return function () {
    return fn.apply(scope, arguments);
  };
};

Shopify.setSelectorByValue = function (selector, value) {
  for (var i = 0, count = selector.options.length; i < count; i++) {
    var option = selector.options[i];
    if (value == option.value || value == option.innerHTML) {
      selector.selectedIndex = i;
      return i;
    }
  }
};

Shopify.addListener = function (target, eventName, callback) {
  target.addEventListener
    ? target.addEventListener(eventName, callback, false)
    : target.attachEvent("on" + eventName, callback);
};

Shopify.postLink = function (path, options) {
  options = options || {};
  var method = options["method"] || "post";
  var params = options["parameters"] || {};

  var form = document.createElement("form");
  form.setAttribute("method", method);
  form.setAttribute("action", path);

  for (var key in params) {
    var hiddenField = document.createElement("input");
    hiddenField.setAttribute("type", "hidden");
    hiddenField.setAttribute("name", key);
    hiddenField.setAttribute("value", params[key]);
    form.appendChild(hiddenField);
  }
  document.body.appendChild(form);
  form.submit();
  document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function (
  country_domid,
  province_domid,
  options
) {
  this.countryEl = document.getElementById(country_domid);
  this.provinceEl = document.getElementById(province_domid);
  this.provinceContainer = document.getElementById(
    options["hideElement"] || province_domid
  );

  Shopify.addListener(
    this.countryEl,
    "change",
    Shopify.bind(this.countryHandler, this)
  );

  this.initCountry();
  this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
  initCountry: function () {
    var value = this.countryEl.getAttribute("data-default");
    Shopify.setSelectorByValue(this.countryEl, value);
    this.countryHandler();
  },

  initProvince: function () {
    var value = this.provinceEl.getAttribute("data-default");
    if (value && this.provinceEl.options.length > 0) {
      Shopify.setSelectorByValue(this.provinceEl, value);
    }
  },

  countryHandler: function (e) {
    var opt = this.countryEl.options[this.countryEl.selectedIndex];
    var raw = opt.getAttribute("data-provinces");
    var provinces = JSON.parse(raw);

    this.clearOptions(this.provinceEl);
    if (provinces && provinces.length == 0) {
      this.provinceContainer.style.display = "none";
    } else {
      for (var i = 0; i < provinces.length; i++) {
        var opt = document.createElement("option");
        opt.value = provinces[i][0];
        opt.innerHTML = provinces[i][1];
        this.provinceEl.appendChild(opt);
      }

      this.provinceContainer.style.display = "";
    }
  },

  clearOptions: function (selector) {
    while (selector.firstChild) {
      selector.removeChild(selector.firstChild);
    }
  },

  setOptions: function (selector, values) {
    for (var i = 0, count = values.length; i < values.length; i++) {
      var opt = document.createElement("option");
      opt.value = values[i];
      opt.innerHTML = values[i];
      selector.appendChild(opt);
    }
  },
};

class ProductForm extends HTMLElement {
  constructor() {
    super();
    new AddToCart(this);
  }
}

customElements.define("product-form", ProductForm);

class Countdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const counterWrapper = this.element.querySelector('.announcement-bar__countdown-text');

    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    let counterString = this.options['countdownString'];
    counterString = counterString.replace('{countdown}', '<span class="u-p2 announcement-bar__countdown-timer">00:00:00</span>');
    counterWrapper.innerHTML = counterString;

    const dateNow = new Date();
    const todaysDay = dateNow.getDay();

    const countdownDay = this.options.countdownDays;


    this.dayDifference = countdownDay - todaysDay;

    if (this.dayDifference < 0) {
      // If the countdown day is earlier in the week, add 7 to the difference
      this.dayDifference += 7;
    }

    this.counter = this.element.querySelector(".announcement-bar__countdown-timer");
    setInterval(this.countDown.bind(this), 1000);
  }

  countDown() {
    const dateNow = new Date();
    const currentHours = dateNow.getHours();
    const currentMinutes = dateNow.getMinutes();
    let countDate = new Date(`March 3, 2099 ${this.options.countdownTime}`);

    if (this.options['countdownType'] == 'to_date') {
      countDate = new Date(this.options.countdownDate);
    }



    const difference = countDate - dateNow;

    const seconds = 1000;
    const minutes = seconds * 60;
    const hours = minutes * 60;
    const days = hours * 24;


    let textDays = Math.floor(difference / (1000 * 60 * 60 * 24));
    let textHours = Math.floor((difference % days) / hours);
    let textMinutes = Math.floor((difference % hours) / minutes);
    let textSeconds = Math.floor((difference % minutes) / seconds);


    const [targetHours, targetMinutes] = this.options.countdownTime.split(':').map(Number);
    if (targetHours < currentHours || (targetHours === currentHours && targetMinutes <= currentMinutes) && this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference - 1;
    } else if (this.options['countdownType'] == 'reccuring') {
      textDays = this.dayDifference;
    }


    const displayHours = textHours;
    const formatHours = displayHours < 10 ? `0${displayHours}` : displayHours;
    const formatMinutes = textMinutes < 10 ? `0${textMinutes}` : textMinutes;
    const formatSeconds = textSeconds < 10 ? `0${textSeconds}` : textSeconds;

    if (textDays > 0) {
      this.counter.innerText = `${textDays}d ${formatHours}:${formatMinutes}:${formatSeconds}`;
    } else {
      this.counter.innerText = `${formatHours}:${formatMinutes}:${formatSeconds}`;
    }
  }
}

customElements.define("countdown-element", Countdown);


class CartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.Drawer = new Drawer(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelectorAll(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.changeEvent = new Event("quantity:changed", { bubbles: true });

    this.addToCartInstance = new AddToCart(this.element);

    this.bindEvents();
    this.buildGroups();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {
      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("cart-drawer:open", this.onOpen.bind(this));
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "keydown",
        '[data-action="update-change-quantity"]',
        this.preventEvent.bind(this)
      );

      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity-for-group"]',
        this.updateItemQuantitForGroup.bind(this)
      );

      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity-for-group"]',
        this.updateItemQuantitForGroup.bind(this)
      );
      this.delegateElement.on(
        "keydown",
        '[data-action="update-change-quantity-for-group"]',
        this.preventEvent.bind(this)
      );

      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );

      window.theme.listener = "true";
    }

  }

  onOpen() {
    if (this.element.getAttribute("aria-expanded") == "false") {
      document.documentElement.style.setProperty(
        "--cartHeader-height",
        document.querySelector(".CartHeader").offsetHeight + "px"
      );
    }

  }

  preventEvent(event, target) {
    if (event.which === 13 || event.keyCode === 13 && event.target.getAttribute('data-action') === "update-change-quantity-for-group") {
      event.preventDefault();
      this.updateItemQuantitForGroup(event, target);
    }
    if (event.which === 13 || event.keyCode === 13) {
      event.preventDefault();
      this.updateItemQuantity(event, target);
    }
  }

  async updateItemQuantitForGroup(event, target) {
    event.preventDefault();
    console.log('event za group ready', event.target.dataset.quantity);
    const productInfo = event.target.closest('.cartItem--Informations');
    const productId = productInfo.dataset.addAgain;
    const value = productInfo.querySelector('.QuantitySelector__CurrentQuantity');

    let quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(event.target.dataset.quantity);

    }


    if (quantity >= 2) {
      quantity = quantity - 1;
      try {
        await this.addToCartInstance.addToCartWithId(productId, quantity);
        /*  */
        value.setAttribute('value', '1');
        this.onProductAdded(event);
      } catch (error) {
        console.error('Error during add to cart:', error);
      }
    }

    if (quantity === 0) {

      this.addToCartInstance.removeGroup(event);

    }
    new CustomEvent("product:changed", {
            bubbles: true})

  }

  updateItemQuantity(event, target) {
    event.preventDefault();

    if (!target.classList.contains('additional-servece-button') && target
      .closest(".cartItem")
      .querySelector(".itemLoader"))
      target
        .closest(".cartItem")
        .querySelector(".itemLoader")
        .classList.add("is-visible");

    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    const unitSelected = target.getAttribute("data-unit-selected");

    // Create the request payload
    const payload = {
      id: target.getAttribute("data-line-id"),
      quantity: quantity
    };
    
    // Add properties if _unit_selected exists
    if (unitSelected) {
      payload.properties = {
        _unit_selected: unitSelected
      };
    }

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify(payload),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      _this.renderCart(target.getAttribute("data-id"), true);
      if (response.ok) {
        _this.element.dispatchEvent(
          new CustomEvent("product:changed", {
            bubbles: true,
            detail: target.getAttribute("data-id").match(/\d+/),
          })
        );
        localStorage.setItem(
          target.getAttribute("data-id").match(/\d+/),
          quantity
        );
      }
    });
  }

  onProductAdded(e) {
    var _this = this;
    if (e.detail.onlyRender) {
      this.disableScroll = false;
      this.renderCart();
    } else {
      this.disableScroll = true;

      this.renderCart().then(function () {
        _this.Drawer.openDrawer();
      });

    }
  }

  renderCart(lineNumber, quantityChange) {
    if(this.element.querySelector(".emptyItem")) {
      this.element.querySelector(".emptyItem").remove();
    }
    this.pageLoader.style.width = 100 + "%";
    var _this = this;

    return fetch(
      window.routes.localeRootUrl + "/?section_id=main-cart_drawer",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange);
      });
    });


  }

  replaceContent(html, lineNumber, quantityChange) {
    // --- Check if Free Shipping block existed before re-render ---
    const hadFreeShippingBlock = !!this.element.querySelector('.cart-footer__free-shipping-ab');

    var _this = this;
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cart").getAttribute("data-settings")
    );


    this.options = this.tempOptions;



    const number = this.tempOptions["itemCount"];
    if(number == 0){
      document.cookie = 'checkout_entered' + '=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
    }
    this.cartCount.forEach(num => {
      num.innerHTML = `${number}`;
    });
    window.theme.cartCount = parseInt(number);

    
    if (lineNumber) {

      
      var cartNodeParent = this.element.querySelector("#" + lineNumber);

      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber
      );


      if (cartNodeParent && cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      } 
      if (itemToReplaceWith) {
        cartNodeParent.replaceWith(
          itemToReplaceWith
        );
        if (window.theme.enableAnimations) {
        new RevolutionAnimation(this.element);
        }
      } else {
       
          this.renderCart();
       
      } 

      if (number > 0 && this.element.querySelector(
        ".CartFooter--Buttons")) {
        const checkoutButtonParent = this.element.querySelector(
          ".CartFooter--Buttons"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".cartCheckout--Button"
        );
        checkoutButtonParent.replaceChild(
          checkoutButtonToReplace,
          checkoutButtonParent.querySelector(".cartCheckout--Button")
        );

        const footerTotalParent = this.element.querySelector(
          ".MetaIcon--Wrappers"
        );
        const footerTotalToReplace = tempElement.querySelector(
          ".CartFooter--Totals"
        );
        if (footerTotalParent && footerTotalToReplace) {
          footerTotalParent.replaceChild(
            footerTotalToReplace,
            footerTotalParent.querySelector(".CartFooter--Totals")
          );

        }

        const cartFreeShippingParent = this.element.querySelector(
          ".cart-drawer__shipping-wrapper"
        );
        const cartFreeShippingToReplace = tempElement.querySelector(
          ".cart-drawer__shipping-wrapperLeftContent"
        );

        const shippingBarTemp = tempElement.querySelector(
          ".cart-drawer__shipping-wrapperLeftMoneyProgress"
        );
        const shippingBarCurrent = this.element.querySelector(
          ".cart-drawer__shipping-wrapperLeftMoneyProgress"
        );

        if (cartFreeShippingToReplace) {
          cartFreeShippingParent.replaceChild(
            cartFreeShippingToReplace,
            cartFreeShippingParent.querySelector(
              ".cart-drawer__shipping-wrapperLeftContent"
            )
          );

          if (shippingBarTemp && shippingBarCurrent) {
            shippingBarCurrent.style.width = shippingBarTemp.style.width;
          } else if (shippingBarCurrent && !shippingBarTemp) {
            shippingBarCurrent.remove();
          } else {
            cartFreeShippingParent.append(
              tempElement.querySelector(
                ".cart-drawer__shipping-wrapperLeftMoneyProgressBar"
              )
            );
          }
        }



      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");

        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren =
            mainPartParent.querySelector("#main-cartItems");
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible");
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
    }
    setTimeout(() => {

      var focus = _this.element.querySelector("[data-scrollable]");
      if (this.disableScroll)
        bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);
      _this.Drawer.maxHeight();
    }, 200);

    window.hadFreeShippingBlock = hadFreeShippingBlock;


    this.element.dispatchEvent(new Event("cart:rendered", { bubbles: true}));
  }

  buildGroups() {
    function getElementsBetween(startElem, endElem) {
      if (!startElem || !endElem) return;

      const elements = [];
      let current = startElem.nextElementSibling;
    
      while (current && current !== endElem) {
        elements.push(current);
        current = current.nextElementSibling;
      }
    
      return elements;
    }

    const openings = this.element.querySelectorAll(".product-card__group-open");
    const closings = this.element.querySelectorAll(".product-card__group-closed");

    const index = openings.length;
    if (!index || index !== closings.length) return;

    for (let i = 0; i < index; i++) {
      const opening = openings[i];
      const closing = closings[i];      
      
      const elementsBetween = getElementsBetween(opening, closing);
      elementsBetween.forEach(elem => opening.append(elem));
      
      opening.classList = opening.dataset.classList;
      opening.removeAttribute("data-class-list");
      opening.removeAttribute("data-index");
      closing.remove();
    }

  }
}
customElements.define("cart-drawer", CartDrawer);



class FeaturedCollectionSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bodyDelegate = new Delegate(document.body);
    if(this.element.querySelector(".swiper.turn-on"))
      this.carouselElement = this.element.querySelector(".swiper.turn-on");

    this.bindEvents();
    this.matchesBreakpoint();
  }

  bindEvents() {
    this.showMoreBinder = this.showMore.bind(this);

    this.delegateElement.on(
      "click",
      '.featured-collection_button--show-more',
      this.showMoreBinder
    )

    if (this.element.dataset.slider === "true") {
      responsive.addBreakpointListener("lap_and_up");

      this.bodyDelegate.on("breakpoint:lap_and_up", (e) => {
        this.matchesBreakpoint();
      });
    }
  }

  matchesBreakpoint() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      if (this.carousel) {
        this.carousel.destroy();
      }
    } else {
      if(this.carouselElement)
        this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

  showMore() {
    if(this.carouselElement)
      this.carouselElement.classList.add("show");
    this.delegateElement.off("click", this.showMoreBinder);
  }
}
customElements.define("featured-collection", FeaturedCollectionSection);


class Header extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.options = JSON.parse(this.getAttribute("data-settings"));
    this.scrollableElement = this.element.querySelector('[data-scrollable]');

    if (this.options.sticky) {
      this.toggleSticky();
    }
    document.documentElement.style.setProperty(
      "--header-height-fixed",
      document.querySelector("#header").offsetHeight + "px"
    );

    this.updateVisibleHeight();
    this.bindEvents();
    this.menuOverlapHandler();

  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);
    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty('--header-dynamic-height', `${visibleHeight}px`);
  }

  menuOverlapHandler() {
    var currentClientWidth = Math.max(
      document.body.scrollWidth,
      document.documentElement.scrollWidth,
      document.body.offsetWidth,
      document.documentElement.offsetWidth,
      document.documentElement.clientWidth
    );

    var menuItems = this.element.querySelector(".header--MenuItems"),
      overlapping = false,
      menuWrapper = this.element.querySelector(".header--Wrapper"),
      allHeights = [],
      _this = this;
    if (menuItems) {
      var desiredHeight = _this.element.querySelectorAll(".mainLinks");
      desiredHeight.forEach((item) => {
        allHeights.push(item.offsetHeight);
      });
      var maxHeight = Math.max.apply(null, allHeights);
      var minHeight = Math.min.apply(null, allHeights);
      if (maxHeight > minHeight) {
        overlapping = true;
        if (
          window.theme.menuBreakpoint == 0 ||
          window.theme.menuBreakpoint == undefined
        ) {
          window.theme.menuBreakpoint = currentClientWidth;
        }
      }
    }
    if (currentClientWidth > window.theme.menuBreakpoint) {
      menuItems.classList.remove("mt-m");
      menuItems.classList.remove("mainMenu--Overlapping");
      menuWrapper.querySelector(".mainMenuItems").prepend(menuItems);
      window.theme.menuBreakpoint = 0;
    } else if (overlapping) {
      menuItems.classList.add("mt-m");
      menuItems.classList.add("mainMenu--Overlapping");
      menuItems.closest(".header").appendChild(menuItems);
    }
    document.documentElement.style.setProperty(
      "--header-height",
      _this.element.clientHeight + "px"
    );
    menuItems.style.opacity = 1;
  }

  toggleSticky() {
    this.element.parentElement.classList.add("header--Sticky");

  }

  bindEvents() {
    const _this = this;
    document.addEventListener("shopify:section:load", function () {
      _this.menuOverlapHandlerListener();
    });
    this.menuOverlapHandlerListener = this.menuOverlapHandler.bind(this);
    responsive.addResizeListener(this, this.menuOverlapHandlerListener);
    this.toggleColorListener = this.toggleColor.bind(this);

    scrollListener.addScrollListener(this, this.toggleColorListener);
    this.delegateBody.on("menu:close", this.closeMenu.bind(this), true);

    this.delegateElement.on(
      "mouseenter",
      "[aria-haspopup='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-haspopup='true']",
      this.openMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseover",
      "[data-action='on-hover']",
      this.handleHoverInMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseleave",
      "[aria-submenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "mouseenter",
      "[aria-singlemenu]",
      this.closeMenu.bind(this), true
    );

    this.delegateElement.on(
      "focusin",
      "[aria-singleMenu], .mainLinks",
      this.closeMenu.bind(this), true
    );
    this.delegateBody.on("keydown", onEscape((event) => {
        this.closeMenu(event);
    })
    );

    scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));
  }

  handleHoverInMenu(event){
    if (!event.target.getAttribute('data-handle')) return;
    const dataHandle = event.target.getAttribute('data-handle');
    const dropdownParent = event.target.closest(".desktopMenu--Dropdown");
    const productsWrapper = dropdownParent.querySelector(".desktop-menu__products-wrapper");
    
    if(!dataHandle || !dropdownParent || !dropdownParent || !productsWrapper)return;
    

    const hoverItems = productsWrapper.querySelectorAll(`.desktop-menu__on-hover-item`);
    hoverItems.forEach(item => {
      if (item.getAttribute("data-handle") === dataHandle) {
        item.style.display = "block";
      } else {
        item.style.display = "none";
      }
    });
  }

  updateMenuPosition() {
    document.documentElement.style.setProperty(
      "--submenu-position",
      `${document.querySelector('#header').offsetHeight}px`
    );
  }

  openMenu(event, target) {
    // Dispatch a custom event to indicate that the menu is being opened.
    this.element.dispatchEvent(new CustomEvent('menu:open', { bubbles: true }));

    // If the event is a mouseenter event and the target is not the same as the event target, return.
    if (event.type === 'mouseenter' && target !== event.target) {
      return;
    }

    // Update the position of the menu and change the ARIA expanded attribute.
    this.updateMenuPosition(target);



    target.setAttribute('aria-expanded', 'true');

    // Close any siblings of the target element.
    const siblings = Array.from(target.parentElement.children).filter((child) => child !== target && child.getAttribute('aria-expanded') === 'true');
    siblings.forEach((item) => item.setAttribute('aria-expanded', 'false'));

    // Disable body scroll on the scrollable element inside the menu.
    bodyScrollLock.disableBodyScroll(this.scrollableElement, bodyScrollLockOptions);
  }


  closeMenu(event, target) {

    if (event.type === "mouseleave" && target !== event.target) { return; }

    const allOpen = this.element.querySelectorAll('[aria-expanded="true"]');
    allOpen.forEach(function (item) {
      item.setAttribute("aria-expanded", "false");
    });
    this.toggleColor();

    bodyScrollLock.enableBodyScroll(this.scrollableElement);
  }

  toggleColor() {
    if (window.pageYOffset > 25) {
      this.element.classList.add('Header--Scrolled');
    } else {
      this.element.classList.remove('Header--Scrolled');
    }
  }
}
customElements.define("header-component", Header);

class MainMenuDropdown extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.SidebarMenu = new Drawer(this.element);

    this.bindEvents();
  }
  bindEvents() {
    document.addEventListener("sidebar-drawer:open", this.onDrawerListener);
  }
}
customElements.define("main-menu-dropdown", MainMenuDropdown);

class Transition {
  constructor() {
    this.pageOverlay = document.querySelector(".pageTransition");

    if (!this.isPageLoaded) {

      document.addEventListener(
        "DOMContentLoaded",
        this.onPageLoaded.bind(this)
      );
    } else {
      this.onPageLoaded();
    }
  }

  onPageLoaded() {
    this.isPageLoaded = true;
    if (this.pageOverlay && window.theme.showPageTransition) {
      this.pageOverlay.animate([{ opacity: 1 }, { opacity: 0 }], {
        duration: 100,
        fill: "forwards",
        easing: "ease-in-out",
        iterations: 1,
      });
    }
  }

  onPageUnload(event, target) {
    if (
      event.defaultPrevented ||
      event.ctrlKey ||
      event.metaKey ||
      !window.theme.showPageTransition ||
      !this.pageOverlay
    ) {
      return;
    }

    event.preventDefault(); // Prevent the click to happen

    if (this.pageOverlay) {
      var timeline = new TimelineLite({
        onComplete: function onComplete() {
          window.location.href = target.href;
        },
      });

      timeline.fromTo(
        this.pageOverlay,
        0.25,
        { autoAlpha: 0, ease: Linear.easeNone },
        { autoAlpha: 1, ease: Linear.easeNone }
      );
    }
  }
}
new Transition();

class VideoComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    this.trueObserver = false;

    if (this.options["using_fade"] == "fade" && new Responsive().matchesBreakpoint('pocket')) {
   
        this.checkLoaded();
        this.bindEvents();
   
    } else {
      
      this.checkLoaded();
    }
  }

  bindEvents() {
    window.removeEventListener(
      "swiper:slide-changed",
      this.onSlideChangeListener
    );
    this.onSlideChangeListener = this.onSlideChange.bind(this);
    window.addEventListener("swiper:slide-changed", this.onSlideChangeListener);
  }

  checkLoaded() {
    var _this = this;
    if (typeof videojs !== "undefined") {
      this.videoPlayerInitialization();
    } else {
      loadScript(window.theme.videoScript);
      setTimeout(function () {
        _this.checkLoaded();
      }, 100);
    }
  }

  onSlideChange(event) {
    this.elementPosition = parseInt(this.element.getAttribute("data-position"));
    if (event.detail.currentIndex == this.elementPosition) {
      if (!this.element.getAttribute("loaded")) {
        var node = document.createElement("div");
        node.appendChild(
          this.element
            .querySelector("template")
            .content.firstElementChild.cloneNode(true)
        );
        this.element.appendChild(node.firstElementChild).focus();
        this.element.setAttribute("loaded", true);
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      } else {
        if (!this.videoPlayer) {
          this.checkLoaded();
        } else {
          if (this.options["viewport"]) {
            this.videoPlayer.play();
            this.createObserver();
          }
        }
      }
    } else if (
      this.videoPlayer &&
      this.videoPlayer.el_.classList.contains("vjs-playing")
    ) {
      this.videoPlayer.pause();
    }
  }

  videoPlayerInitialization() {
    
    if (!this.element.getAttribute("loaded")) {
      const node = document.createElement("div");
      node.appendChild(
        this.element
          .querySelector("template")
          .content.firstElementChild.cloneNode(true)
      );
      this.element.appendChild(node.firstElementChild).focus();
      this.element.setAttribute("loaded", true);
    }

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    let aspect_ratio = "";
    let src = "";
    let host = "html5";

    if (isMobile) {
      aspect_ratio = this.options["aspect_mob"] || "9:16";

      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        src = topQuality["url"] + "#t=0.001";
      } else if (this.options["videoType"] == "video_inside_media_external") {
        const aspectRatioHeight = Math.floor(
          100 / this.options["videom"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        host = this.options["videom"]["host"];
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videom"]["external_id"];
        } else {
          src = this.options["videom"]["external_id"];
        }
      } else {
        if (this.options["videom"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videom"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videom"];
      }
    } else {
      aspect_ratio = this.options["aspect_desk"] || "16:9";
      if (this.options["videoType"] == "video_inside_media") {
        const sources = this.options["videod"]["sources"];
        let topQuality = null;
        sources.forEach((obj) => {
          if (obj.format === "mp4") {
            if (!topQuality) topQuality = obj;
            if (topQuality.height < obj.height) topQuality = obj;
          }
        });
        src = topQuality["url"] + "#t=0.001";
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
      } else if (this.options["videoType"] == "video_inside_media_external") {
        host = this.options["videod"]["host"];
        const aspectRatioHeight = Math.floor(
          100 / this.options["videod"]["aspect_ratio"]
        );
        if (!this.options["videoRatio"]) {
          aspect_ratio = `100:${aspectRatioHeight}`;
        } else {
          aspect_ratio = this.options["videoRatio"];
        }
        if (host == "youtube") {
          src =
            "https://www.youtube.com/watch?v=" +
            this.options["videod"]["external_id"];
        } else {
          src = this.options["videod"]["external_id"];
        }
      } else {
        if (this.options["videod"].includes("youtube")) {
          host = "youtube";
        } else if (this.options["videod"].includes("vimeo")) {
          host = "vimeo";
        }
        src = this.options["videod"];
      }
    }

    if (!src) {
      src = "https://www.youtube.com/watch?v=_9VUPq3SxOc";
      host = "youtube";
    }
    const type =
      host === "youtube"
        ? "video/youtube"
        : host === "vimeo"
          ? "video/vimeo"
          : "video/mp4";

    aspect_ratio = aspect_ratio.replace("/", ":");
    const payload = {
      aspectRatio: aspect_ratio,
      autoplay: false,
      muted: this.options["muted"],
      loop: this.options["loop"],
      controls: this.options["controls"],
      poster: false,
      preload: "metadata",
      playsinline: true,
      responsive: true,
      techOrder: [host],
      disablePictureInPicture: true,
      controlBar: {
        children: [
          "playToggle",
          "progressControl",
          "currentTimeDisplay",
          "timeDivider",
          "durationDisplay",
          "CustomControlSpacer",
          "VolumePanel"
        ],
      },

      sources: [
        {
          type: type,
          src: src,
        },
      ],
    };

    const videoplayerID = this.element.querySelector("video");
    this.videoPlayer = videojs(videoplayerID, payload);

    const _this = this;
    this.videoPlayer.on("ready", function () {
      _this.element.querySelector(".videoHolder").style.display = "block";

      if (_this.trueObserver == false && _this.options["viewport"]) {
        _this.createObserver();
      }
    });

    if (this.options["muted"] && host == "vimeo") {
      this.videoPlayer.on("play", function () {
        _this.videoPlayer.muted("true");
      });
    }

    if (this.options["controls"]) {
      if (host == "html5") {
        this.videoPlayer.on("touchstart", function () {
          if (event.target.closest(".vjs-control-bar")) {
            return;
          }

          if (_this.videoPlayer.paused()) {
            _this.videoPlayer.play();
          } else {
            _this.videoPlayer.pause();
          }
        });
      }
      if (host == "html5") return;
      this.videoPlayer.on("click", function () {
        if (event.target.closest(".vjs-control-bar")) {
          return;
        }

        if (_this.videoPlayer.paused()) {
          _this.videoPlayer.play();
        } else {
          _this.videoPlayer.pause();
        }
      });
    }
  }

  createObserver() {
    const observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: 0.2,
      rootMargin: "200px 0px 200px 0px",
    });

    observer.observe(this.element);
    this.trueObserver = true;
  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio === 1 || entry.isIntersecting == true) {
        if (!this.videoPlayer) {
          this.checkLoaded();
          return;
        }

        if (this.options["viewport"] && this.videoPlayer) {
          this.videoPlayer.muted("true");

          const checkIfPlaying = () => {
            if (!this.videoPlayer.el_.classList.contains("vjs-playing")) {
              this.videoPlayer.play();
              setTimeout(checkIfPlaying, 100); // Wait 100 milliseconds and check again
            }
          };

          checkIfPlaying();
        }
      } else if (
        entry.intersectionRatio === 0 ||
        entry.isIntersecting == false
      ) {
        if (
          this.videoPlayer &&
          this.videoPlayer.el_.classList.contains("vjs-playing")
        ) {
          this.videoPlayer.pause();
        }
      }
    });
  }
}
customElements.define("video-component", VideoComponent);

class FooterComponent extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    let breakpoint = responsive.getCurrentBreakpoint();
    if (breakpoint == "phone" || breakpoint == "tablet") {
      // this.dropdown = new Dropdown(this.element);
    }


    window.addEventListener('load', function() {
      const currentHash = window.location.hash;
    
      if (currentHash === '#footerFormMobile' || currentHash === '#footerFormDesktop') {
        // Disable smooth scrolling when the URL contains #footerFormMobile or #footerFormDesktop
        document.documentElement.style.scrollBehavior = 'auto';
    
        // Optionally, re-enable smooth scrolling after the page has settled
        setTimeout(function() {
          document.documentElement.style.scrollBehavior = 'smooth';
        }, 500); // Adjust the delay if needed
      }
    });

    document.documentElement.style.setProperty(
      "--footer-height",
      document.querySelector(".mainfooterWrapper").offsetHeight + "px"
    );

    window.onload = () =>
      setTimeout(() => {
        document.documentElement.style.setProperty(
          "--footer-height",
          document.querySelector(".mainfooterWrapper").offsetHeight + "px"
        );
      }, 500);
  }
}
customElements.define("footer-component", FooterComponent);


class ProductElement extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.domDelegate = new Delegate(this.element);
    this.bodyDelegate = new Delegate(document.body);
    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.pageOverlayElement = document.querySelector(".pageOverlay");


    this.initialization();
    this.bindEvents();
  }

  initialization() {
   
    //Start
    this.changeImageQuality();
    this.mainATCs = this.element.querySelectorAll('.ProductPage--ATC.default-btn');

    new AddToCart(this.element);

    this.allDrawers = this.element.querySelectorAll('.Drawer--wrapper');
    this.allDrawers.forEach((drawer) => {
      new Drawer(drawer);
    });

    var selectBoxes = this.element.querySelectorAll(".RevolutionSelectbox");
    if (selectBoxes.length > 0) {
      selectBoxes.forEach((item, i) => {
        new RevolutionSelectbox(item);
      });
    }

    this.productInfoWrapper = this.element.querySelector('.product-info__wrapper');
    this.carouselElement = this.element.querySelector(".mainSwiper");
    this.firstSlideImage = this.element.querySelector('.ProductSlider--Element');
    this.addToCartBtn = this.element.querySelectorAll('.MainProduct--ATC');
    this.options = JSON.parse(
      this.element.getAttribute("data-section-settings")
    );
    if (this.breakpoint !== 'desktop' && this.breakpoint !== 'lap' && this.options["slides_number"] > 1) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
      this.swiper = this.carouselElement.swiper;
    }
    if (this.options["enable_zoom"]) {
      new RevolutionImageZoom(this.element, this.carousel);
    }

    if (
      this.options["variant_image_id"] &&
      this.options["show_variant_image_on_load"]
    ) {
      this.calledBecauseOfThis = true;
      this.updateImage();
    }

    if (this.options["sticky_atc"] && this.breakpoint !== 'desktop' && this.breakpoint !== 'lap') {
      this.elementToHide = this.element.querySelector(".product-action__sticky");
      if (this.elementToHide) {
        this.elementToHide.classList.remove("sticky-pop-up");
        this.bindObserver();
      }
    }

     //add product to the local storage
     this.handleLocalStorage();

    /* Notify me START*/
    this.notifyMeBtns = this.querySelectorAll('.Button--NotifyMe');
    this.notifyMeOverlay = this.element.querySelector(".notifyMeOverlay");
    this.additionalContent = this.element.querySelector('.notify-me__additional-content');

    if (this.options["restock_info"]) {
      window.addEventListener("DOMContentLoaded", () => {


        const intervalId = setInterval(() => {
          if (document.querySelector(".appikon-bis-inline-form-wrapper")) {
            clearInterval(intervalId);


            const sendButton = document.querySelector(
              "#appikon-bis-inline-form-submit"
            );

            const subscribeTxt = sendButton.textContent.trim();
            sendButton.textContent = ''; // Clears any text content inside the button

            const spanFirst = document.createElement("span");
            const btnContainer = document.createElement("div");

            btnContainer.classList.add("ButtonTextContainer");
            // Create separate text nodes for each span
            btnContainer.appendChild(spanFirst);

            // Append text nodes to spans
            spanFirst.classList.add("ButtonText", "ButtonTextStart", "u-pb1");
            spanFirst.innerText = subscribeTxt;


            if (sendButton) {
              sendButton.classList.add(
                "Button--PrimaryOnLight",
                "Button--Normal"
              );
              sendButton.appendChild(btnContainer);
            }
            this.notifyMeBtns.forEach(btn => {
              btn.removeAttribute('disabled');
            })



            const productImage = this.element
              .querySelector(".ProductSlider--ImageFirst") ? this.element
                .querySelector(".ProductSlider--ImageFirst")
                .cloneNode(true) : null;

            const destContainer = this.element.querySelector(
              "#appikon-bis-inline-form-wrapper"
            );

            const closeButton = document.createElement("button");
            closeButton.classList.add("notify-me__btn-close");
            closeButton.setAttribute("data-action", "notify-close");
            closeButton.innerHTML = `
            <svg
        class="{{ icon_class }} {{ spacing }}"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M5.83351 5L15 14.4118L14.4271 15L5.26061 5.58824L5.83351 5Z" fill="#28272A"/>
        <path d="M5 14.414L14.1686 5L14.7142 5.56017L5.54557 14.9741L5 14.414Z" fill="#28272A"/>
      </svg>
          `;


            destContainer.appendChild(closeButton);

            if (this.additionalContent) {
              destContainer.appendChild(this.additionalContent);
              this.additionalContent.style.display = 'flex';
            }

            const atcButtons = document.querySelectorAll('.ProductPage--DefaultVariant');
            atcButtons.forEach(btn => btn.style.display = 'none');



            if (productImage)
              destContainer.appendChild(productImage);

            if (atcButtons) {
              const notifyMeButtons = document.querySelectorAll('.showNotifyMe');
              notifyMeButtons.forEach(btn => btn.style.display = 'flex');
            }

            this.pageOverlayElement.addEventListener(
              "click",
              this.closeNotifyPopup.bind(this)
            );

            this.domDelegate.on(
              "click",
              '[data-action="notify-open"]',
              this.openNotifyPopup.bind(this)
            );

            this.domDelegate.on(
              "click",
              '[data-action="notify-close"]',
              this.closeNotifyPopup.bind(this)
            );

            this.element.dispatchEvent(
              new CustomEvent("notify:added", {
                bubbles: true,
                detail: document.querySelectorAll(".Button--NotifyMe"),
              })
            );
          }
        }, 100);

        setTimeout(() => {
          clearInterval(intervalId);
        }, 5000);
      });
    }
    /* Notify me END */

    //Note whether the product info should be sticky
    this.stickyInfo = this.options["pdp_info_sticky"];

    //Complementary products block ->
    this.complementaryEl = this.element.querySelector(
      ".complementary_products--wrapper"
    );


    if (this.complementaryEl) {
      this.handleComplementaryProducts();
    }

    ///frame products block ->
    this.errorMsg = this.element.querySelector('.error-msg');
    this.frameCarouselEl = this.element.querySelector(".frame-products__swiper");
    if (this.frameCarouselEl)
      this.frameCarousel = new RevolutionSwiper(this.frameCarouselEl);

    this.selectedFrameBox = this.element.querySelector('.product-frame-card[aria-selected="true"]');

    if (this.breakpoint !== 'desktop' || this.breakpoint !== 'lap')
      this.initObserver();

    this.frame_id = this.element.querySelector('input[name="frame_id"]');

    //usps block init
    this.uspsCarouselEl = this.element.querySelector(".usps-carousel__blocks-wrapper");
    if (this.uspsCarouselEl)
      this.uspsCarousel = new RevolutionSwiper(this.uspsCarouselEl);
  }

  bindEvents() {
    this.domDelegate.on("variants:update",
      this.updateFramesProductVariants.bind(this));

    this.domDelegate.on(
      "click",
      '[data-action="toggle-unit"]',
      this.toggleUnit.bind(this)
    );


    this.domDelegate.on(
      "click",
      '[data-action="add-frame"]',
      this.addFrame.bind(this)
    );


    this.domDelegate.on(
      "click",
      '[data-action="remove-frame"]',
      this.removeFrame.bind(this)
    );

    this.domDelegate.on(
      "click",
      '[data-action="activate-link"]',
      this.makeLinkActive.bind(this)
    );
    this.domDelegate.on("variant:changed", this.updateImage.bind(this));

    this.domDelegate.on(
      "click",
      ".ProductAction--ChangeButton",
      this.scrollToTop.bind(this)
    );



   
    this.closeNotifyPopupBinder = this.closeNotifyPopup.bind(this);
  }


  handleLocalStorage(){
    const maxProducts = 6;
    const productId = this.options["product_id"];
    
    let viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');

    viewedProducts = viewedProducts.filter(p=>p!==productId);
    // Add the new product at the beginning
    viewedProducts.unshift(productId);
    // Keep only the last 8 products
    if (viewedProducts.length > maxProducts) {
      viewedProducts = viewedProducts.slice(0, maxProducts);
    }
    localStorage.setItem('viewedProducts', JSON.stringify(viewedProducts));
  }

  updateFramesProductVariants(event) {
    if(!this.frameCarouselEl)
      return;

    const productsToBeUpdated = this.frameCarouselEl.querySelectorAll('.product-frame-card.real-product');
   
   
    if(!event.target.currentVariant.available || event.detail.disableFrames){
      productsToBeUpdated.forEach(product => {
        product.dataset.disable = 'true';
      });
    }else{
      productsToBeUpdated.forEach(product => {
        product.dataset.disable = 'false';
      });
    }
    const variantToSet = event.detail.currentOptions[0];

    productsToBeUpdated.forEach(product => {
      product.setAttribute('data-disable', true);
      const priceToBeUpdated = product.querySelector('.product-frame-card__price');
      const scriptElement = product.querySelector('script[type="application/json"]');

      if (scriptElement) {
        const productData = JSON.parse(scriptElement.textContent);


        productData.forEach(variant => {
          if (variant.options[0] == variantToSet) {
            
            product.setAttribute("product-id", `${variant.id}`);
            let newVariantPrice = variant.price;
            const compare_price = variant.compare_at_price;
            let compare_span = ""

            if(product.dataset.discount){
             
              const discount = product.dataset.discount / 100;
              newVariantPrice = newVariantPrice - (newVariantPrice * discount);
              compare_span = `<span class="pdp-compare-at-price ">${Shopify.formatMoney(Math.round(variant.price), window.theme.moneyFormat)}</span>` 
              
            }
            
            priceToBeUpdated.dataset.price = newVariantPrice;
            let priceSpan = `<span>+` + Shopify.formatMoney(newVariantPrice, window.theme.moneyFormat); +`</span>`

            if (compare_price){
              let compare_price_span = `<span class="pdp-compare-at-price ">${Shopify.formatMoney(variant.compare_at_price, window.theme.moneyFormat)}</span>`
              priceSpan = `<span class="original-price">+${Shopify.formatMoney(variant.price, window.theme.moneyFormat)}</span>${compare_price_span}`;
            } 
        
            if(newVariantPrice < variant.price){
              
               priceSpan = `<span class="original-price"> ${Shopify.formatMoney(newVariantPrice, window.theme.moneyFormat)}</span>${compare_span}`;
            } 
           
            priceToBeUpdated.innerHTML = priceSpan;
            
            if(variant.available){
              product.setAttribute('data-disable', false);
            }
            if(!variant.available){
              
              product.setAttribute('out-of-stock', 'true');
            }else{
              product.removeAttribute('out-of-stock');
            }
          }

        })

        //update price in main ATC
        if (window.variantInfo?.show_price) {
          this.querySelector('.product-frame-card[data-action="remove-frame"]').click();
        }
      } else {
        console.error('Script element with type "application/json" not found in product:', product);
      }
    })

     //quick fix set for parent to be hidden
    productsToBeUpdated.forEach(product => {
      // Check if the product has 'data-disable' set to true
      if (product.getAttribute('data-disable') === 'true' && product.getAttribute('out-of-stock') !== 'true') {
        // Check if the product has a parent element and set it to hidden
        if (product.parentElement) {
          product.parentElement.setAttribute('hidden', true);
        }
      }else{
        if (product.parentElement) {
          product.parentElement.setAttribute('hidden', false);
        }
      }
    }); 


 // Call the update method on the Swiper instance
  this.frameCarouselEl.swiper.update();

  }

  toggleUnit(e) {
  // Return early if clicked unit is already active
  if (e.target.classList.contains('active')) {
    return;
  }
  
  // Get necessary elements
  const cmUnits = this.element.querySelectorAll('.unit-cm') || [];
  const inUnits = this.element.querySelectorAll('.unit-in') || [];
  const unit = this.element.querySelector('.variant-unit.active');
  const hiddenInput = document.getElementById('unit-selected-input');
  
  // Determine which unit is being switched to
  const switchingToInches = unit.classList.contains('first-unit');
  
  // Toggle visibility based on unit selection
  cmUnits.forEach(unit => unit.classList.toggle('hidden', switchingToInches));
  inUnits.forEach(unit => unit.classList.toggle('hidden', !switchingToInches));
  
  // Update hidden input value
  if (hiddenInput) {
    hiddenInput.value = switchingToInches ? 'in' : 'cm';
  }
  
  // Update active class
  unit.classList.remove('active');
  e.target.classList.add('active');
}



  removeFrame(e, target) {
    this.handleSelect(target);

    this.removeOverlay();

    //change add-to-cart-all action to add-to-cart 
    this.addToCartBtn.forEach(btn => {
      btn.setAttribute("data-action", "add-to-cart")
    });

    //Update ID for input
    this.frame_id.dataset.id = '';

    if (window.variantInfo?.show_price) {
      //update price in main ATC

      this.updateMainATCPrice(target);

    }
  }
  removeOverlay() {
    if (this.firstSlideImage) {
      this.firstSlideImage.querySelector('.ram_overlay')?this.firstSlideImage.querySelector('.ram_overlay').remove():null;
    } else {
      return
    }
  }

  addFrame(e, target) {
    e.preventDefault();
    this.handleSelect(target);

    if (this.breakpoint !== 'desktop' && this.breakpoint !== 'lap' && this.options["slides_number"] > 1) {
      this.swiper.slideTo(0);
    }else if (this.breakpoint === 'desktop' || this.breakpoint === 'lap'){
      const firstNavBtn = this.element.querySelector(".desktop_bullets .product-bullet");

      
      if(firstNavBtn){
        firstNavBtn.click();
      }
    }

    const selectedOptions = JSON.parse(
      target.getAttribute("data-card-settings")
    );

    const frameToAdd = selectedOptions["ram_image"];
    const imgSrc = selectedOptions["src"];
    const imgAlt = selectedOptions["alt"];


    const newImage = document.createElement('img');
    newImage.classList.add('ram_overlay');

    if (!frameToAdd) {
      this.errorMsg.classList.remove('hidden');
      return;
    }

    if(imgSrc){
      newImage.src = imgSrc;
    }
    else {
      newImage.src = frameToAdd;
    }

    if(imgAlt)
      newImage.alt = imgAlt;


    this.removeOverlay();
    this.firstSlideImage.appendChild(newImage);

    //change add to cart action to add to cart all
    this.addToCartBtn.forEach(btn => {
      btn.setAttribute("data-action", "add-all-to-cart")
    });

    //Update ID for input
    this.frame_id.dataset.id = target.getAttribute('product-id');

    if (window.variantInfo?.show_price) {
      //update price in main ATC
      this.updateMainATCPrice(target);
    }
  }

  updateMainATCPrice(el) {
    let priceToBeAdded = el.querySelector('.product-frame-card__price');
    let priceData = parseFloat(priceToBeAdded.dataset.price);

    if (!priceToBeAdded) {
      priceToBeAdded = 0;
    }

    this.mainATCs.forEach(btn => {
      let newAtcPrice = parseFloat(btn.dataset.price);
      const priceEl = btn.querySelector('.mainProductPrice');
      if(this.element.dataset.discount){
        const discount = this.element.dataset.discount / 100;

        newAtcPrice = newAtcPrice - (newAtcPrice * discount);
      }

      const finalPrice = Math.round(priceData + newAtcPrice);

      if (priceEl && finalPrice) {
        priceEl.textContent = `${Shopify.formatMoney(
          finalPrice,
          window.theme.moneyFormat
        )}`;
      } else {
        return;
      }
    })

  }

  handleSelect(el) {
    this.selectedFrameBox.setAttribute('aria-selected', false);
    el.setAttribute('aria-selected', true);
    this.selectedFrameBox = el;
  }

  async handleComplementaryProducts() {
    this.block_options = JSON.parse(
      this.complementaryEl.getAttribute("data-block-settings")
    );

    let optionToUse = this.block_options.select_type;
    this.complementaryElWrapper = this.element.querySelector(
      ".complementary_products--wrapper"
    );


   
    let url = `${window.routes.localeRootUrl}/recommendations/products?section_id=helper-complementary_products&product_id=${this.options["product_id"]}&limit=10&intent=${optionToUse}`;
   
    const response = await fetch(url);
    if (!response.ok) throw new Error(response.status);
    let content = await response.text();
    content = new DOMParser().parseFromString(content, "text/html");
    let hasProducts;

    const contentToInsert = content.querySelector(
      ".complementaryProducts--section"
    );

/*     FALLBACK LOGIC (IF NONE IS SET IN SEARCH AND DISCOVERY PULL PRODUCTS WITH THE SAME VENDOR) */
    if (!contentToInsert.querySelector('.complementryProducts--pdpSwiperWrapper .swiper-slide')) {
        
      const template = this.element.querySelector('#complementarySwiperTemplate');
      const swiperContainer = this.element.querySelector('.complementary_products--PdpSwiper');
     
      if (template && swiperContainer) {
        // Clone the content from the template and insert it into the DOM
        swiperContainer.innerHTML = template.innerHTML;
        this.carouselComplementaryTemplate = this.element.querySelector(
          "#complementarySwiperElementTemplate"
        );

        
      }else{
        return;
      }

      if (this.carouselComplementaryTemplate) {
        this.NewCarousel = new RevolutionSwiper(this.carouselComplementaryTemplate);
      }

      this.childEl = this.element.querySelector(
        ".complementaryProducts--sectionTemplate .complementaryProducts--imageWrapperTemplate"
      );
  
      if (this.childEl) {
        hasProducts = true;
      } else {
        hasProducts = false;
      }
      if (this.complementaryElWrapper && hasProducts) {
        this.complementaryElWrapper.style.display = "block";
      }
     
      return;
    }

   /*  FALLBACK LOGIC (IF NONE IS SET IN SEARCH AND DISCOVERY PULL PRODUCTS WITH THE SAME VENDOR) END */

  
    //Init swiper
    this.element
      .querySelector(".complementary_products--PdpSwiper")
      .appendChild(contentToInsert);
    this.carouselComplementary = this.element.querySelector(
      "#complementarySwiperElement"
    );
   
  
    if (this.carouselComplementary) {
      this.NewCarousel = new RevolutionSwiper(this.carouselComplementary);
    }

    this.childEl = this.element.querySelector(
      ".complementaryProducts--section .complementaryProducts--imageWrapper"
    );

    if (this.childEl) {
      hasProducts = true;
    } else {
      hasProducts = false;
    }
    if (this.complementaryElWrapper && hasProducts) {
      this.complementaryElWrapper.style.display = "block";
    }
  }

  initObserver() {
    // Use IntersectionObserver for observing elements
    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), {
      threshold: [0.5] // Adjust threshold as needed
    });

    // Get all media links to observe
    this.mediaLinks = this.element.querySelectorAll(".ProductSliderCell");
    this.mediaLinks.forEach((mediaSlide) => this.observer.observe(mediaSlide));


  }

  handleIntersect(entries) {
    entries.forEach((entry) => {
      if (entry.isIntersecting) {
        this.removeAllLinks();
        const slideID = entry.target.id;
        const anchorElements = this.element.querySelectorAll(
          `a[href="#${slideID}"]`
        );

        anchorElements.forEach((item) => {
          item.classList.add("active-link");
        });
      }
    });
  }

  removeAllLinks() {
    const activeLinks = this.element.querySelectorAll(".active-link");
    activeLinks.forEach((item) => {
      item.classList.remove("active-link");
    });
  }

  makeLinkActive(event) {
    const allLinks = this.element.querySelectorAll(".desktop_bullets.product-bullet");
    allLinks.forEach((item) => {
      item.classList.remove("active-link");
    });
    event.target.classList.add("active-link");
  }

  bindObserver() {
    const elementToObserve = this.element.querySelector(".ProductActions");
    const footerSection = document.body.querySelector(".mainfooterWrapper");

    const observerOptions = {
      threshold: [0, 0.5, 1], // Check for intersection at start, middle, and end of the observed element
      rootMargin: "0px",

    };

    const observer = new IntersectionObserver((entries) => {

      const scrollToATCVisible = entries.some(entry => entry.isIntersecting && entry.target === elementToObserve);
      const footerVisible = entries.some(entry => entry.isIntersecting && entry.target === footerSection);

      if (scrollToATCVisible || footerVisible) {
        // If the element is intersecting, hide the sticky-pop-up
        this.elementToHide.classList.remove("sticky-pop-up");
      } else {
        // If the element is not intersecting, show the sticky-pop-up
        this.elementToHide.classList.add("sticky-pop-up");
      }

    }, observerOptions);

    observer.observe(elementToObserve);
    observer.observe(footerSection);
  }

  openNotifyPopup() {
    event.preventDefault();
    this.isOpen = true;

    this.notifyMeOverlay.classList.add("is-visible");
    document.body.querySelector('#shopify-section-main-header').style.zIndex='2';
    this.domDelegate.on(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    bodyScrollLock.disableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.add("showNotifyMe");
  }

  closeNotifyPopup() {
    event.preventDefault();
    if (!this.isOpen) return;

    this.domDelegate.off(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    this.notifyMeOverlay.classList.remove("is-visible");
    document.body.querySelector('#shopify-section-main-header').style.zIndex='6';
    bodyScrollLock.enableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.remove("showNotifyMe");

    this.isOpen = false;
  }

  scrollToTop() {
    const elementToScroll = this.element.querySelector(".ScrollToATC");

    if (elementToScroll) {
      const elementTop = elementToScroll.getBoundingClientRect().top;
      const positionToScroll =
        elementTop +
        window.scrollY +
        elementToScroll.clientHeight -
        window.innerHeight +
        24;

      window.scrollTo({
        top: positionToScroll,
        behavior: "smooth",
      });
    }
  }

  updateImage(event) {
    if (event) {
      var imageID = event.detail.new_image;
    } else {
      var imageID = this.options["variant_image_id"];
    }

    var selector = "#Image--" + imageID;

    var imageEl = this.element.querySelector(selector);

    if (imageEl && imageEl.getAttribute("data-position") && this.carousel) {
      this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
    } else return;

    if (imageEl && imageEl.getAttribute("data-position") && this.carousel) {
      this.carousel.selectCell(parseInt(imageEl.getAttribute("data-position")));
    }else return;

    setTimeout(() => {
      if (this.calledBecauseOfThis && this.options["autoplay_slider"]) this.swiper.autoplay.start();
      this.calledBecauseOfThis = false;

    }, 300);
  }

  changeImageQuality() {
    var imageToReveal = null;
    imageToReveal = this.element.querySelector(".ProductSlider--ImageFirst");
    if (imageToReveal !== null) {
      const replaceUrl = imageToReveal
        .getAttribute("data-src")
        .replace("{width}x", "2600x");
      imageToReveal.src = replaceUrl;
    }
  }
}
customElements.define("product-component", ProductElement);


class VariantSelects extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.type = this.element.getAttribute("data-type");
    this.productID = this.element.getAttribute("data-product-id");
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);


    this.init();
    this.bindEvents();
    this.onQuantityChange();
    this.onVariantChange();

  }

  init() {
    this.regularPrice = document.querySelector(
      "product-component .pdp-regular-price .changePrice"
    );
    this.compareAtPrice = document.querySelector(
      "product-component .pdp-compare-at-price"
    );
    this.pricesWrapper = document.querySelector('.pdp-prices')
  }

  bindEvents() {
    this.delegateBody.on("quantity:changed", this.onQuantityChange.bind(this));

    var selectboxes = this.element.querySelectorAll("select, input");
    selectboxes.forEach((item) => {
      item.addEventListener("change", this.onVariantChange.bind(this));
    
    });
    this.delegateElement.on("keydown", onEnter((event) => {
      const input = event.target.querySelector("input");
        input.checked = true;
        this.onVariantChange({ target: input });
    })
    )

    this.delegateBody.on("notify:added", this.toggleAddButton.bind(this));

  

  }

  onQuantityChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
  }

  onVariantChange() {
    this.updateOptions();
    this.updateMasterId();
    this.toggleAddButton();
    this.updatePickupAvailability();
    this.updateVariantStatuses();
    this.updateMedia();
    this.updateURL();
    this.updateVariantInput();
    this.renderProductInfo();
    this.updateFrameProducts();
    this.updateFavorites();
  }


  updateFavorites(){
    document.querySelector('.pdp__fav-icon').dataset.size = this.currentVariant.title;
    if(this.element.dataset.inches == 'true'){
      document.querySelector('.pdp__fav-icon').dataset.size = this.element.querySelector(`.inputSelectboxCheckbox[value="${this.currentVariant.title}"]`).dataset.inches; 
    }

  }

  updatePriceBlock() {

    if (this.regularPrice) {
      this.regularPriceTag = this.currentVariant.price;
      this.regularPrice.innerHTML = Shopify.formatMoney(
        this.regularPriceTag,
        window.theme.moneyFormat
      );
    }
    if (this.compareAtPrice) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;

      if (this.compareAtPriceTag > this.currentVariant.price) {

        this.compareAtPrice.innerHTML = Shopify.formatMoney(
          this.compareAtPriceTag,
          window.theme.moneyFormat
        );
      } else {

        this.compareAtPrice.textContent = "";
      }
    }
    else if (this.currentVariant.compare_at_price && !this.compareAtPrice) {
      this.compareAtPriceTag = this.currentVariant.compare_at_price;
      const compareAtPriceDiv = document.createElement('span');
      compareAtPriceDiv.className = 'u-p2 pdp-compare-at-price';
      compareAtPriceDiv.textContent = `${Shopify.formatMoney(
        this.compareAtPriceTag,
        window.theme.moneyFormat
      )}`;

      if (this.pricesWrapper) {
        this.pricesWrapper.appendChild(compareAtPriceDiv);
        this.compareAtPrice = compareAtPriceDiv;
      }
    } else {
      if (this.compareAtPrice)
        this.compareAtPrice.textContent = "";

    }
  }

  updateFrameProducts() {
    this.checkedVariant =  Array.from(
      this.querySelectorAll("input:checked")
    ).some(input => input.hasAttribute('data-frame-disabled'));
    
    this.element.dispatchEvent(
      new CustomEvent("variants:update", {
        bubbles: true,
        detail: {
          eventName: "variant",
          currentOptions: this.currentVariant["options"],
          disableFrames: this.checkedVariant

        },
      })
    );
  }

  updateOptions() {
    this.options = Array.from(
      this.querySelectorAll("select, input:checked"),
      (select) => select.value
    );
  }

  updateVariantStatuses() {
    
    const selectedOptionOneVariants = this.variantData.filter(
      (variant) => this.querySelector(`input:checked`).value === variant.option1
    );
    const inputWrappers = [...this.querySelectorAll(".VariantSelect")];

    
    inputWrappers.forEach((option, index) => {
      if (index === 0) return;

      const optionInputs = [...option.querySelectorAll(`input`)];

      const previousOptionSelected =
        inputWrappers[index - 1].querySelector(":checked").value;

      const availableOptionInputsValue = selectedOptionOneVariants
        .filter(
          (variant) =>
            variant.available &&
            variant[`option${index}`] === previousOptionSelected
        )
        .map((variantOption) => variantOption[`option${index + 1}`]);
      this.setInputAvailability(optionInputs, availableOptionInputsValue);
    });
  }

  setInputAvailability(listOfOptions, listOfAvailableOptions) {
    listOfOptions.forEach((input) => {
      if (listOfAvailableOptions.includes(input.getAttribute("value"))) {
        input.closest(".Selectbox").removeAttribute("variant-notify-me");
        input.removeAttribute("disabled-variant");
      } else {
        input.setAttribute("disabled-variant", "true");
        input.closest(".Selectbox").setAttribute("variant-notify-me", "");
      }
    });
  }

  updateMasterId() {
    this.currentVariant = this.getVariantData().find((variant) => {
      this.options;

      return !variant.options
        .map((option, index) => {
          return this.options[index] == option;
        })
        .includes(false);
    });
  }

  updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const newMedia = this.currentVariant.featured_media.id;
    if (!newMedia) return;
    this.element.dispatchEvent(
      new CustomEvent("variant:changed", {
        bubbles: true,
        detail: { new_image: newMedia },
      })
    );
  }

  updateURL() {
    if (!this.currentVariant) return;

    const url = new URL(window.location.href);
    const searchParams = new URLSearchParams(url.search);
    const newParams = new URLSearchParams();

    // Preserve UTM parameters
    for (const [key, value] of searchParams.entries()) {
      if (key.startsWith('utm_')) {
        newParams.append(key, value);
      }
    }

    // Set the variant parameter
    newParams.set('variant', this.currentVariant.id);

    const newUrl = `${window.location.pathname}?${newParams.toString()}`;
    window.history.replaceState({}, '', newUrl);
  }

  updateVariantInput() {
    if (!this.currentVariant) {
      return;
    }
    const productForms = document.querySelectorAll(
      `#product-form-${this.productID}, #product-form-installment`
    );

    productForms.forEach((productForm) => {
      const input = productForm.querySelector('input[name="id"]');
     
      input.value = this.currentVariant.id;
      
      input.dataset.id = this.currentVariant.id;
      input.dispatchEvent(new Event("change", { bubbles: true }));
    });
  }

  updatePickupAvailability() {
    const pickUpAvailability = document.querySelector("pickup-availability");
    if (!pickUpAvailability) return;

    if (this.currentVariant && this.currentVariant.available) {
      pickUpAvailability.fetchAvailability(this.currentVariant.id);
    } else {
      pickUpAvailability.removeAttribute("available");
      pickUpAvailability.innerHTML = "";
    }
  }

  renderProductInfo() {
    const url = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
    const id = ".pdp-prices";


    fetch(url)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(responseText, "text/html");

        const destinations = document.querySelectorAll(id);
        const source = html.querySelector(id);

        if (source && destinations.length > 0) {
          destinations.forEach(destination => {
            destination.innerHTML = source.innerHTML;
          });
        }


        this.toggleAddButton();
      });

    this.updatePriceBlock();
  }

  toggleAddButton(e) {
    let quantity = "";
    const addButton = document.querySelectorAll(".MainProduct--ATC"),
      addButtonInner = document.querySelectorAll(
        ".MainProduct--ATC .ButtonText"
      ),
      quantityEl = document.querySelector(".QuantitySelector__ProductQuantity");

    const priceEl = this.currentVariant.price;
    if (priceEl) {
      addButton.forEach(btn => {
        btn.setAttribute('data-price', priceEl);
      })
    }
    if (quantityEl) {
      quantity = quantityEl.value;
    }

    if (!addButton) return;
    if (!quantity) {
      quantity = 1;
    }

    if (e) this.notifyMeButtons = e.detail;

    if (this.currentVariant.available == false) {
      if (this.notifyMeButtons) {
        this.notifyMeButtons.forEach((btn) => {
          btn.style.display = "flex";
          btn.removeAttribute('disabled');

        });

        addButton.forEach((btn) => (btn.style.display = "none"));
      } else {
        document.querySelectorAll('.Button--NotifyMe').forEach((btn) => (btn.style.display = "none"));
        addButton.forEach((btn) => (btn.style.display = "flex"));
      }

      addButton.forEach((btn) => {
        btn.setAttribute("disabled", "disabled");
        btn.classList.add("ProductCard--Sold__Out");
      });
      addButtonInner.forEach((btn) => {
        btn.innerHTML = window.variantStrings.soldOut;
      });
    } else {
      if (this.notifyMeButtons)
        this.notifyMeButtons.forEach((btn) => (btn.style.display = "none"));
      addButton.forEach((btn) => {
        btn.removeAttribute("disabled");
        btn.classList.remove("ProductCard--Sold__Out");
        btn.style.display = "flex";
      });
      let newAtcPrice = this.currentVariant.price * quantity;
      if(this.element.dataset.discount){
        const discount = this.element.dataset.discount / 100;

        newAtcPrice = Math.round(newAtcPrice - (newAtcPrice * discount) * quantity);
      }
      newAtcPrice = Math.round(newAtcPrice / 100) * 100;
      addButtonInner.forEach((btn) => {
        if (window.variantInfo.show_price) {
          var priceElement =
            "<span class='u-pb1 mainProductPrice'>" +
            Shopify.formatMoney(
              newAtcPrice,
              window.theme.moneyFormat
            );
          +"</span>";
          btn.innerHTML = window.variantStrings.addToCart + priceElement;
        } else {
          btn.innerHTML = window.variantStrings.addToCart;
        }

      });
      if (window.variantInfo?.show_price) {
        let newAtcPrice = this.currentVariant.price * quantity;
        if(this.element.dataset.discount){
          const discount = this.element.dataset.discount / 100;

          newAtcPrice = Math.round(newAtcPrice - (newAtcPrice * discount) * quantity);
        }
        newAtcPrice = Math.round(newAtcPrice / 100) * 100;
        var priceElement =
          "<span class='u-pb1 mainProductPrice'> " +
          Shopify.formatMoney(
            newAtcPrice,
            window.theme.moneyFormat
          ) +
          "</span>";
      } else {
        var priceElement = "";
      }
      addButtonInner.forEach((btn) => {
        btn.innerHTML = window.variantStrings.addToCart + priceElement;
      });
    }
  }

  getVariantData() {
    this.variantData =
      this.variantData ||
      JSON.parse(this.querySelector('[type="application/json"]').textContent);
    return this.variantData;
  }
}
customElements.define("variant-selects", VariantSelects);



class SearchBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.searchElement = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.searchInputElement = this.element.querySelector('[name="q"]');

    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.pageOverlayElement = this.element.querySelector(".sectionOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.initialSearchLayout = this.searchResultsElement.cloneNode(true);
    this.clearSearchButton = this.element.querySelector(".searchInput--clear");
    
    this.info = this.element.querySelector('.search-enter-info');
    this.transitionEndHandlerListener = this.transitionEndHandler.bind(this);
    this.element.addEventListener("transitionend", this.transitionEndHandlerListener);


    if (window.theme.showRecentSearches) {
      this.getRecentSearches();
    }

    this.handleFromLocalStorage();

    if (window.theme.showSuggestedSearches) {
      this.getSuggestedSearches();
    }




    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );

    this.bindEvents();
  }

  bindEvents() {
    this._onInputListener = this.debounce(this.onInput.bind(this), 450);

    this.delegateBody.on(
      "click",
      '[data-action="open-search"]',
      this.openSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="clear-input"]',
      this.resetSearch.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="close-search"]',
      this.closeSearch.bind(this)
    );

    this.delegateElement.on("keydown", onEscape((event) => {
      this.closeSearch(event);
    }));

    this.searchInputElement.addEventListener("input", this._onInputListener);

    this.delegateElement.on(
      "click",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateElement.on(
      "keypress",
      '[data-action="search-string"]',
      this.onInput.bind(this)
    );

    this.delegateBody.on("menu:open", this.closeSearch.bind(this));
    this.delegateBody.on("close:search", this.closeSearch.bind(this));
  }

  handleFromLocalStorage(){
    this.searchInitial = this.element.querySelector('.searchInitial--Products');
    const suggested = this.element.querySelector('.searchBar--suggesterPopularWrapper');
   
    if(this.searchInitial){
      this.viewedProductsTitle = this.searchInitial.querySelector('.predictiveSearch--title');
      this.initialProductsViewed = this.searchInitial.querySelector('.searchInitialView--products');
     
      let viewedProducts = JSON.parse(localStorage.getItem('viewedProducts') || '[]');
      if(viewedProducts.length>0 && this.viewedProductsTitle){
        suggested.style.display = 'none';
        this.viewedProductsTitle.innerText = `${window.searchStrings.viewedProducts}`;
        this.fetchViewedProducts(viewedProducts);
        this.initialProductsViewed.style.opacity = '0';
      }

      if(viewedProducts.length == 0 || !viewedProducts){
        suggested.style.display = 'block';
        suggested.dataset.visible = 'true';
      }
    }
  }


  async fetchViewedProducts(viewedProducts) {
    this.allPredictiveSearchInstances = [];
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    try {
        // Construct the query string using the product IDs
        const query = viewedProducts.map(id => `id:${id}`).join(' OR ');

        // Fetch products using the search API
        const response = await fetch(`${window.routes.localeRootUrl}/search?view=recently&type=product&q=${encodeURIComponent(query)}`);
        
        if (!response.ok) {
            throw new Error(`Error fetching products: ${response.status}`);
        }

        //Parse the fetched HTML response
        const data = await response.text();
        const parser = new DOMParser();
        const doc = parser.parseFromString(data, "text/html");

        // Extract the relevant products
        const fetchedProducts = Array.from(doc.querySelectorAll(".search-product-item"));

         // Reorder the products to match the order of IDs in viewedProducts
         const reorderedProducts = viewedProducts.map(id => 
          fetchedProducts.find(product => parseInt(product.dataset.productId) === id)
      ).filter(product => product); // filter out any undefined products

      // Replace the content of the element with class name .searchInitialView
      const initialViewElement = this.searchResultsElement.querySelector(".searchInitialView--products");
      if (initialViewElement) {
          initialViewElement.innerHTML = ""; // Clear current content
          reorderedProducts.forEach(product => {
              initialViewElement.appendChild(product);
          });
      }

      this.initialProductsViewed.style.opacity = '1';  
      

    } catch (error) {
        console.error('Failed to fetch viewed products:', error);
    }
}



  debounce(fn, delay) {
    var _this0 = this;

    var timer = null;

    return function () {
      for (
        var _len = arguments.length, args = Array(_len), _key = 0;
        _key < _len;
        _key++
      ) {
        args[_key] = arguments[_key];
      }

      clearTimeout(timer);

      timer = setTimeout(function () {
        fn.apply(_this0, args);
      }, delay);
    };
  }

  openSearch(event) {
    if (this.isOpen) {
      this.closeSearch();
      return;
    }

    event.preventDefault();
    this.element.removeEventListener(
      "transitionend",
      this.transitionEndHandlerListener
    );
    this.element.style.display = "block";
    document.documentElement.style.setProperty(
      "--search-header-height",
      `${this.searchInputElement.offsetHeight + 48}px`
    );
      document.documentElement.style.setProperty(
        "--viewport-height",
        `${window.innerHeight}px`
      );
    const _this = this;
    // Check if search is already open, close it if true



    this.element.dispatchEvent(
      new CustomEvent("menu:close", { bubbles: true })
    );

    this.element.dispatchEvent(
      new CustomEvent("drawer:close-other", { bubbles: true })
    );

    // Check if search element exists
    if (!this.element) {
      console.error("Search element not found");
      return;
    }

    // Show search element and page overlay
    const search = document.querySelector("#quickSearch");
    if (search) {
      if (new Responsive().matchesBreakpoint('phone')) {
        setTimeout(() => {
          this.element.setAttribute("aria-hidden", "false");
        }, 10);
      } else {
        this.element.setAttribute("aria-hidden", "false");
      }


    }
    this.pageOverlayElement.classList.add("is-visible");
    // Disable scrolling on body
    bodyScrollLock.disableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );

    // Focus on search input element after delay
    setTimeout(() => {
      if (_this.searchInputElement) {
        _this.searchInputElement.focus({ preventScroll: true });
        

      }
    }, 200);

    requestAnimationFrame(() => {
      document.body.dispatchEvent(
        new CustomEvent("favorites:retoggle", {
        })
    );
    });

    // Set isOpen to true
    this.isOpen = true;

    // Add event listener to page overlay to close search
    if (this.pageOverlayElement) {
      this.closeListener = this.closeSearch.bind(this);
      this.pageOverlayElement.addEventListener("click", this.closeListener);
    }

  }

  closeSearch() {
    event.preventDefault();
    this.eventType = event.type;
    if (!this.isOpen) {
      return;
    }
    bodyScrollLock.enableBodyScroll(
      this.element.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    this.element.setAttribute("aria-hidden", true);
 
      this.element.addEventListener("transitionend", this.transitionEndHandlerListener);
    

    this.pageOverlayElement.classList.remove("is-visible");


    this.isOpen = false;
  }

  transitionEndHandler() {

    const selectBoxOpen = document.body.querySelector('#header .RevolutionSelectbox--Button[aria-expanded="true"]');
    if (this.headerTransparent && this.eventType != 'menu:open' && !selectBoxOpen) {
     
      document.body
        .querySelector("#header")
        .toggleColor();
    }
    this.eventType = null;
    this.element.style.display = "none";
    this.element.removeEventListener(
      "transitionend",
      this.transitionEndHandlerListener
    );
  }

  async onInput(event) {
    this.allPredictiveSearchInstances = [];
    this.lastInputValue = event.target.value;
    this.searchResultsElement = this.element.querySelector(".searchWrapper");
    this.searchResultsElement.style.opacity = 0;
    this.clearSearchButton.setAttribute("aria-hidden", "false");
    if (event.target.getAttribute("data-value") && this.lastInputValue === 0) {
      this.lastInputValue = event.target.getAttribute("data-value");
      const el = this.element.querySelector(".searchInput");

      el.setAttribute("value", this.lastInputValue);
      el.value = this.lastInputValue;
      this.searchInputElement.removeAttribute('data-action');
    } else {
      this.searchInputElement.removeAttribute('data-action');
      if (this.lastInputValue === "") {
        this.initialSearchLayout.style.opacity = 0;
        this.resetSearch();
        return;
      }
    }

    try {
      const response = await fetch(
        `${routes.predictive_search_url}?q=${encodeURIComponent(
          this.lastInputValue
        )}&resources[limit_scope]=each&resources[options][fields]=title,product_type,variants.title,tag,body,author,vendor,variants.sku&section_id=search-predictive`
      );

      if (!response.ok) {
        var error = new Error(response.status);
        throw error;
      }

      const text = await response.text();
      const resultsMarkup = new DOMParser()
        .parseFromString(text, "text/html")
        .querySelector("#shopify-section-search-predictive").innerHTML;

      // Save bandwidth keeping the cache in all instances synced
      this.allPredictiveSearchInstances.forEach((predictiveSearchInstance) => {
        predictiveSearchInstance.cachedResults[queryKey] = resultsMarkup;
      });
     
      const div = document.createElement("div");
      div.innerHTML = resultsMarkup;

      const suggestedQueries = div.querySelector("template");
      const currentSuggestedQueries = this.element.querySelector(
        ".predictiveSearch--queries"
      );
      const currentRecentQueris = this.element.querySelector(
        "#predictiveSearch--recentSearches"
      );

      this.searchResultsElement.innerHTML = resultsMarkup;
      requestAnimationFrame(() => {
        document.body.dispatchEvent(
          new CustomEvent("favorites:retoggle", {
          })
      );
      });
      if (new Responsive().matchesBreakpoint("tablet-and-up")) {
        this.element.querySelector('.searchInnerWrapper').style.height = 'auto';
      }

      


      if (suggestedQueries) {
        if (currentRecentQueris) {
          currentRecentQueris.remove();
        }

        if (currentSuggestedQueries) {
          currentSuggestedQueries.remove();
        }
        const node = suggestedQueries.content.firstElementChild.cloneNode(true);
        this.searchResultsElement.prepend(node);
      }

      if(this.searchResultsElement.querySelector('.predictiveSearch').dataset.sumCounter == 0){
        this.info.style.display = 'none';
      } else {
        this.info.style.display = 'flex';
      }

 

      this.searchResultsElement.style.opacity = 1;

      if (window.theme.showRecentSearches) {
        this.recentSearches();
      }


    } catch (error) {
      if (error?.code === 20) {
        // Code 20 means the call was aborted
        return;
      }

      throw error;
    }
  }

  resetSearch() {
    this.searchResultsElement.innerHTML = this.initialSearchLayout.innerHTML;
    const currentSuggestedQueries = this.element.querySelector(
      ".predictiveSearch--queries"
    );
    if (currentSuggestedQueries) {
      currentSuggestedQueries.remove();
     
    }
    this.searchInputElement.value = "";
    this.searchInputElement.removeAttribute("value");

    if (window.theme.showRecentSearches ) { this.getRecentSearches(); }

    if (window.theme.showSuggestedSearches ) {
      this.getSuggestedSearches();
    }

    

    this.info.style.display = 'none';
    this.searchResultsElement.style.opacity = 1;
    this.clearSearchButton.setAttribute("aria-hidden", "true");

    this.handleFromLocalStorage();

     // Bring cursor back to the search input
     this.searchInputElement.focus();
  }

  recentSearches() {
    if (this.lastInputValue.length > 3) {
      var searchTerm = JSON.parse(localStorage.getItem("searchTerms") || "[]");
      if (!searchTerm.includes(this.lastInputValue)) {
        searchTerm.unshift(this.lastInputValue);
      }

      // Then, we save the search info into the local storage, by keeping only the 5 most recent
      try {
        localStorage.setItem(
          "searchTerms",
          JSON.stringify(searchTerm.slice(0, 5))
        );
      } catch (error) { }
    }
  }

  getRecentSearches() {
    let appendString = "";
    const items = JSON.parse(localStorage.getItem("searchTerms") || "[]");
    let elementToAdd = this.element.querySelector(".search--recentResults");
    if (items.length > 0) {
      items.forEach((id) => {
        appendString =
          appendString +
          "<li role='option' tabIndex='0' class='hover-diff-color recent-search u-p2' data-action='search-string' data-value='" +
          id +
          "'>" +
          id +
          "</li>";
      });

      elementToAdd.innerHTML = appendString;
    } else {
      this.querySelector("#predictiveSearch--recentSearches").style.display =
        "none";

    }
  }


  getSuggestedSearches() {
    let appendString = "";
    const arr = this.options.items;

    if (arr.length == 0) {
      return;
    }
    arr.sort(function () {
      return 0.5 - Math.random();
    });
    var filtred = arr.filter(function (a) {
      if (!a.includes("_")) {
        return a;
      }
    });

    var i;
    appendString = "";
    for (i = 0; i < 3; i++) {
      if (filtred[i]) {
        var filteredResult = filtred[i].replace(":", " ");
        filteredResult = filteredResult.replace("-", " ");
        appendString =
          appendString +
          "<li tabindex='0' class='u-p2 hover-diff-color recent-search' data-action='search-string' data-value='" +
          filteredResult +
          "'>" +
          filteredResult +
          "</li>";
      }

    }
    var appElement = this.searchElement.querySelector(
      ".Search--Suggested__results"
    );
    appElement.innerHTML = appendString;
  }
}
customElements.define("search-bar", SearchBar);

class ContactSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.bindEvents();
    this.toggleButton();
  }

  bindEvents() {
    this.delegateElement.on(
      "change",
      "[data-state='required']",
      this.toggleButton.bind(this)
    );

    this.delegateElement.on("keydown",".terms", (event)=>{
      if (event.key === "Enter") {
         const input = event.target.querySelector("input");
         input.checked = !input.checked;
         this.element.querySelector(".section-contact__button")
         .toggleAttribute("disabled", !input.checked);
        }
  })
  }
  

  toggleButton() {
    this.buttonState = true;

    var allBoxes = this.element.querySelectorAll("[data-state='required']");
    allBoxes.forEach((item, i) => {
      if (item.checked == false) {
        this.buttonState = false;
      }
    });
    if (this.buttonState == true) {
      this.element.querySelector(".section-contact__button")?this.element.querySelector(".section-contact__button").removeAttribute("disabled"):null;
    } else {
      this.element.querySelector(".section-contact__button")?this.element.querySelector(".section-contact__button").setAttribute("disabled", true):null;
    }
  }
}

customElements.define("contact-section", ContactSection);


class NewsletterPopup extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    if (window.location.href.indexOf("customer_posted=true#popupForm") > -1) {
      this.options.delay = 0;
      this.openNewsletter();
    }
    if (this.options.edit_mode) {
      this.options.delay = 0;
      this.openNewsletter();
    } else {
      this.handleOpenOptions();
    }
  }

  handleOpenOptions() {
    console.log('handle open options');
    const localKey = localStorage.getItem("popup-seen");

  if (localKey !== "true") {
    if (this.options.scroll_amount > 0) {
      this.myScrollListener = scrollListener.addScrollListener(this, this.scrollListener);
    } else {
      this.openNewsletter();
    }
  }
    }

  scrollListener = () => {
    const body = document.body;
    const html = document.documentElement;

    const docHeight = Math.max(
      body.scrollHeight,
      body.offsetHeight,
      html.clientHeight,
      html.scrollHeight,
      html.offsetHeight
    );

    const percScrolled = (window.scrollY / docHeight) * 100;

    if (percScrolled >= this.options.scroll_amount) {
      this.openNewsletter();
    }
  };

  openNewsletter() {
    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
    setTimeout(() => {
      this.element.setAttribute("aria-hidden", false);
      this.element.setAttribute("aria-expanded", true);
      this.pageOverlayElement.classList.add("is-visible");
      bodyScrollLock.disableBodyScroll(this.element, bodyScrollLockOptions);

      this.pageOverlayElement.addEventListener("click", this.closeNewsletter);

      localStorage.setItem("popup-seen", true);

      this.delegateElement.on(
        "click",
        '[data-action="close-modal"]',
        this.closeNewsletter
      );
    }, 1000 * this.options.delay);
  }

  closeNewsletter = (e) => {
    e.preventDefault();
    this.element.setAttribute("aria-hidden", true);
    this.element.setAttribute("aria-expanded", false);
    this.pageOverlayElement.classList.remove("is-visible");
    bodyScrollLock.clearAllBodyScrollLocks();

    this.pageOverlayElement.removeEventListener("click", this.closeNewsletter);

    if (this.myScrollListener) {
      this.myScrollListener.removeScrollListener();
    }
  };
}

customElements.define("newsletter-popup", NewsletterPopup);


class AccountHandler extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    this.drawer = new Drawer(this.element.querySelector('#accountDrawer'));
    this.bindEvents();

  }
  bindEvents() {

    this.delegateElement.on('click', '[data-action="toggle-tab"]', this.toggleTab.bind(this));
    this.delegateElement.on('click', '[data-action="submit-login"]', this.submitLogin.bind(this));
    this.delegateElement.on('click', '[data-action="submit-register"]', this.submitRegistration.bind(this));
    this.delegateElement.on('click', '[data-action="toggle-recovery"]', this.toggleRecovery.bind(this));
    this.delegateElement.on('click', '[data-action="submit-recovery"]', this.accountRecover.bind(this));
  }

  toggleRecovery() {
    event.preventDefault();
    const id = event.target.dataset.id;

    if (id == 'recoverFlex') {
      this.element.querySelector('#recoverFlex').setAttribute('aria-hidden', 'false');
      this.element.querySelector('#loginFlex').setAttribute('aria-hidden', 'true');
    }
    else {
      this.element.querySelector('#recoverFlex').setAttribute('aria-hidden', 'true');
      this.element.querySelector('#loginFlex').setAttribute('aria-hidden', 'false');
    }
  }

  accountRecover(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = '/account/recover';

    // Create the request body with the registration data
    const requestBody = {
      'email': this.element.querySelector('#RecoverEmail').value
    };

    event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        const responseText = await response.text();
        const tempDiv = document.createElement('div');
        tempDiv.innerHTML = responseText;

        if (responseText.indexOf('RecoverEmail-email-error') !== -1) {

          _this.element.querySelector('#recoverFlex .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('#RecoverEmail-email-error').innerHTML;
        } else if (responseText.indexOf('recoverSuccess') !== -1) {


          _this.element.querySelector('#recoverFlex .accountDrawer--SuccessSpace').innerHTML = tempDiv.querySelector('#recoverSuccess').innerHTML;
        }

        event.target.querySelector('.button--text').style.visibility = "visible";
        event.target.querySelector('.itemLoader').classList.remove('is-visible');


      } catch (error) {
        console.log('An error occurred during the registration request:', error);
      }
    })();
  }


  submitRegistration(event) {
    event.preventDefault();
    const _this = this;
    const registrationEndpoint = '/account';

    // Create the request body with the registration data
    const requestBody = {
      'customer': {
        'first_name': this.element.querySelector('#register #RegisterForm-FirstName').value,
        'last_name': this.element.querySelector('#register #RegisterForm-LastName').value,
        'email': this.element.querySelector('#register #RegisterForm-email').value,
        'password': this.element.querySelector('#register #RegisterForm-password').value
      }
    };

    event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(registrationEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });

        const responseText = await response.text();

        if (responseText.indexOf('registerErrors') !== -1) {
          console.log('Error occurred during registration');
          const tempDiv = document.createElement('div');
          tempDiv.innerHTML = responseText;

          _this.element.querySelector('#register .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.registerErrors').innerHTML;
        } else {
          location.href = window.routes.account_url;
        }

        event.target.querySelector('.ButtonText').style.visibility = "visible";
        event.target.querySelector('.itemLoader').classList.remove('is-visible');


      } catch (error) {
        console.log('An error occurred during the registration request:', error);
      }
    })();
  }


  submitLogin(event) {
    event.preventDefault();
    const _this = this;
    const loginEndpoint = '/account/login';

    // Create the request body with the login credentials
    const requestBody = {
      'customer': {
        'email': this.element.querySelector('#customer_login #CustomerEmail').value,
        'password': this.element.querySelector('#customer_login #CustomerPassword').value
      }
    };

    event.target.querySelector('.ButtonText').style.visibility = "hidden";
    event.target.querySelector('.itemLoader').classList.add('is-visible');

    // Send the AJAX request
    (async function () {
      try {
        const response = await fetch(loginEndpoint, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          body: JSON.stringify(requestBody)
        });


        const responseText = await response.text();

        if (responseText.indexOf('loginError') !== -1) {
          console.log('Incorrect email or password');
          const tempDiv = document.createElement('div');

          tempDiv.innerHTML = responseText;

          _this.element.querySelector('#login .accountDrawer--ErrorSpace').innerHTML = tempDiv.querySelector('.AlertError').innerHTML;
          event.target.querySelector('.ButtonText').style.visibility = "visible";
          event.target.querySelector('.itemLoader').classList.remove('is-visible');
        } else {
          location.href = window.routes.account_url;

        }



      } catch (error) {
        console.log('An error occurred during the login request:', error);
      }
    })();

  }

  toggleTab(event) {
    const id = event.target.dataset.id;
    const allTabs = this.element.querySelectorAll('.accountDrawer--Tab[aria-expanded="true"]');
    const allContent = this.element.querySelectorAll('.accountContent');

    allTabs.forEach((tab) => {
      tab.setAttribute('aria-expanded', 'false');
    });

    event.target.setAttribute('aria-expanded', 'true');

    allContent.forEach((content) => {
      content.setAttribute('aria-visible', 'false');
    });

    const content = this.element.querySelector(`#${id}`);
    if (content) {
      content.setAttribute('aria-visible', 'true');
    }
  }

}

customElements.define("account-handler", AccountHandler);


class LocalizationSelectors extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    new Popup(this.element, true, );

  }
}
customElements.define("localization-selectors", LocalizationSelectors);

class AnimatedAnnouncementBar extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.options = JSON.parse(this.element.getAttribute("data-section-settings"));
    this.closeButton = this.element.querySelector('.announcement-bar__close');
    

    document.documentElement.style.setProperty(
      "---announcement-dynamic-height",
      this.element.clientHeight + "px"
    );

    if (sessionStorage.getItem("annBarHidden", true)) {
      this.element.classList.add("hidden");
    } else {
      this.hideListener = this.hide.bind(this);
    }
    this.updateVisibleHeight();
    this.bindEvents();

    this.announcementItems = this.element.querySelectorAll('.annocement-bar__block');
    if (this.announcementItems.length > 1 && this.options["enableAnimation"]) {
      this.initialize();
    } else {
      this.announcementItems[0]?.classList.add('base');
    }
  }

  initialize() {
    this.currentIndex = 0;
    this.announcementItems[this.currentIndex].classList.add('active');
    setInterval(this.showNextElement.bind(this), this.options["cycleSpeed"]);
  }

  bindEvents() {
    scrollListener.addScrollListener(this, this.updateVisibleHeight.bind(this));
    responsive.addResizeListener(this, this.updateVisibleHeight.bind(this));

    if (this.hideListener) {
      this.delegateElement.on(
        'click',
        '[data-action="ann-bar-close"]',
        this.hideListener
      );
    }
  }

  hide() {
    this.element.classList.add("hidden");
    sessionStorage.setItem("annBarHidden", true);
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `0px`
    );
  }

  showNextElement() {
    this.announcementItems[this.currentIndex].classList.remove('active');
    this.currentIndex = (this.currentIndex + 1) % this.announcementItems.length;
    setTimeout(() => {
      this.announcementItems[this.currentIndex].classList.add('active');
    }, this.options["transitionSpeed"])
  }

  updateVisibleHeight() {
    const rect = this.element.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    // Calculate the visible height
    let visibleHeight = Math.min(rect.bottom, windowHeight) - Math.max(rect.top, 0);

    // Ensure the visibleHeight is never negative
    visibleHeight = Math.max(visibleHeight, 0);

    // Update the height of .announcementBar with the visible height
    document.documentElement.style.setProperty(
      "--announcement-dynamic-height",
      `${visibleHeight}px`
    );
  }
}
customElements.define("announcement-bar", AnimatedAnnouncementBar);

class SizeGuideTables extends HTMLElement {
  /* We need this cause of desktop */
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.tableContent = this.element.querySelector(".table-content");
    this.scrollbar = this.element.querySelector(".custom-scrollbar");
    this.scrollbarThumb = this.element.querySelector(".custom-scrollbar-thumb");

    this.init();
    this.bindEvents();
  }

  init() {
    this.updateScrollbarThumb();
    window.addEventListener("resize", () => this.updateScrollbarThumb());
  }

  bindEvents() {
    let isDragging = false;
    let startX, startScrollLeft;
    const slider = this.element.querySelector(".table-content");

    const startDragging = (e) => {
      isDragging = true;
      startX = e.type === "touchstart" ? e.touches[0].pageX : e.pageX;
      startScrollLeft = slider.scrollLeft;
    };

    const stopDragging = () => {
      isDragging = false;
    };

    const move = (e) => {
      e.preventDefault();
      if (!isDragging) {
        return;
      }
      const currentX = e.type === "touchmove" ? e.touches[0].pageX : e.pageX;
      const scroll = currentX - startX;
      slider.scrollLeft = startScrollLeft - scroll;

      this.syncScroll();
    };

    slider.addEventListener("mousedown", startDragging, false);
    slider.addEventListener("touchstart", startDragging, false);

    slider.addEventListener("mouseup", stopDragging, false);
    slider.addEventListener("touchend", stopDragging, false);
 
    slider.addEventListener("mousemove", move, false);
    slider.addEventListener("touchmove", move, false);

    this.tableContent.addEventListener("scroll", () => this.syncScroll(), false);
  }

  updateScrollbarThumb(){
    const contentWidth = this.tableContent.scrollWidth;
    const containerWidth = this.tableContent.clientWidth;
    const scrollRatio = containerWidth / contentWidth;

    this.scrollbarThumb.style.width = `${scrollRatio * 100}%`;
  }

  syncScroll() {
    const contentWidth = this.tableContent.scrollWidth;
    const containerWidth = this.tableContent.clientWidth;
    const scrollRatio = containerWidth / contentWidth;
    const scrollLeft = this.tableContent.scrollLeft;
    this.scrollbarThumb.style.transform = `translateX(${scrollLeft * scrollRatio}px)`;
  }



}
customElements.define("table-content", SizeGuideTables);

class InfiniteScroll {
  constructor(container, restoreState) {
    this.containerSelector = container;
    this.treshold = 650;
    this.handleScrollListener = this.handleScroll.bind(this);
    this.domDelegate = new Delegate(document.body);

    const pageNum = sessionStorage.getItem('pageNum');
    if (restoreState == true && pageNum && pageNum !== "1") {
      // Multi-page: fetch content then restore scroll
      const promises = this.generateFetchPromises(false);
      this.renderData(promises, true);
    } else {
      this.bindEvents();
      // Only restore scroll if this is a back navigation
      if (restoreState == true) {
        this.restoreScroll();
      }
    }
  }

  bindEvents() {
   
    this.listenerBinder = this.addUserScrollListener.bind(this);

    this.domDelegate.on(
      "click",
      '[data-action="load"]',
      this.listenerBinder
    );
  }

  initialize() {
    document.addEventListener("scroll", this.handleScrollListener);
  }

  addUserScrollListener(e) {
   
    e.preventDefault();
   
    this.handleClick();
    this.initialize();
    this.domDelegate.off(
      "click",
      this.listenerBinder
    );

    
  }

  handleScroll() {
   
    this.paginationElement = document.querySelector('#infiniteScroll');
    if (!this.paginationElement) return;
    const top = this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom = this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector('a');

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises);
      }
    }
  }

  handleClick() {
    event.preventDefault();
    
    event.target.closest('a').setAttribute('disabled', 'true');
    if(window.location.href.includes('/collections/'))
        sessionStorage.setItem('loadMoreClicked', 'true');
    this.paginationElement = document.querySelector('#infiniteScroll');
    if (!this.paginationElement) return;

    this.nextPageLinkElement = this.paginationElement.querySelector('a');

    if (this.nextPageLinkElement) {
      this.destroy();
      const nextPageUrl = this.nextPageLinkElement.href;

      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises);
    }
  }

  destroy() {
    // Remove the event listener when the instance is no longer needed
    document.removeEventListener("scroll", this.handleScrollListener);
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem('pageNum'));
      for (let i = 2; i <= limit; i++) {
        let url;


        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(fetch(url, {
          credentials: "same-origin",
          method: "GET",
        }));
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }));
    }

    return promises;
  }


  async renderData(promises, restoreContent) {
    try {
      // Keep scroll at top while loading if we're restoring content
      if (restoreContent) {
        window.scrollTo(0, 0);
      }

      const responses = await Promise.all(promises);
      const contents = await Promise.all(responses.map(response => response.text()));
      let isLastPromise = false;
      contents.forEach((content, index) => {

        isLastPromise = index === contents.length - 1;



        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error('Error fetching or parsing data:', error);
    }
  }


  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const contentToAdd = doc.querySelector(this.containerSelector);


    this.mainContainer = document.querySelector(this.containerSelector);
    this.paginationElement = document.querySelector('#infiniteScroll');
    if (this.paginationElement) {
      this.paginationElement.remove();
    }

    this.mainContainer.insertAdjacentHTML('beforeend', contentToAdd.innerHTML);
    if (window.theme.enableAnimations) {
    new RevolutionAnimation(this.mainContainer);
    }
    this.paginationElement = document.querySelector('#infiniteScroll');
    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );

    requestAnimationFrame(() => {
      document.body.dispatchEvent(
        new CustomEvent("favorites:retoggle", {
        })
    );
    });

  }

  
  restoreScroll() {
    const clickedProductId = sessionStorage.getItem('clickedProductId');
    if (!clickedProductId) return;

    const pageNum = sessionStorage.getItem('pageNum');
    const isMultiPage = pageNum && pageNum !== "1";

    const selector = `${this.containerSelector} [data-id='${clickedProductId}']`;

    // Shorter delay for single page since content is already loaded
    const delay = isMultiPage ? 100 : 10;

    setTimeout(() => {
      const targetElement = document.querySelector(selector);

      if (targetElement) {
        // For single page, images are cached so shorter timeout
        const imageTimeout = isMultiPage ? 500 : 100;

        const images = targetElement.querySelectorAll('img');
        const imagePromises = Array.from(images).map(img => {
          if (img.complete) return Promise.resolve();
          return new Promise(resolve => {
            img.onload = resolve;
            img.onerror = resolve;
            setTimeout(resolve, imageTimeout);
          });
        });

        Promise.all(imagePromises).then(() => {
          requestAnimationFrame(() => {
            requestAnimationFrame(() => {
              // Calculate target position to center the product
              const rect = targetElement.getBoundingClientRect();
              const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
              const targetPosition = rect.top + scrollTop - (window.innerHeight / 2) + (rect.height / 2);

              window.scrollTo({
                top: targetPosition,
                behavior: 'smooth'
              });
            });
          });
        });
      }
    }, delay);
  }
}


class MainBlog extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector('.swiper');
    new RevolutionSwiper(this.carouselElement);
    new InfiniteScroll("#main-blog_article-grid", true);
  }
}
customElements.define("blog-section", MainBlog);

class BlogShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.bodyDelegate = new Delegate(document.body);
    this.carouselElement = this.element.querySelector(".swiper");

    this.bindEvents();

  }

  bindEvents() {
    if (this.element.dataset.slider === "true") {

        this.matchesBreakpoint();
      
    }
  }

  matchesBreakpoint() {
    if (responsive.matchesBreakpoint("lap_and_up")) {
      if (this.carousel) {
        this.carousel.destroy();
      }
    } else {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }

}

customElements.define("blog-showcase", BlogShowcase);



sessionStorage.setItem("firstLoadRecomm", true);
class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this);

    if (sessionStorage.getItem("firstLoadRecomm") === "true") {
      sessionStorage.setItem("firstLoadRecomm", false);
      fetch(this.dataset.url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");
          if (recommendations && recommendations.innerHTML.trim().length) {
            const carouselElementNew = recommendations.querySelector(".product-recommendations__grid");
            const carouselElementOld = this.querySelector(".product-recommendations__grid");

            carouselElementOld.parentNode.replaceChild(
              carouselElementNew,
              carouselElementOld
            );

            carouselElementNew.classList.add("recomm-loaded");
            requestAnimationFrame(() => {
              document.body.dispatchEvent(
                new CustomEvent("favorites:retoggle", {
                })
            );
            });
            this.element.style.display = "block";
            if (window.theme.enableAnimations) {
            new RevolutionAnimation(carouselElementNew);
            }
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }
  }
}
customElements.define("product-recommendations", ProductRecommendations);


class Inspiration extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.carouselElement = this.element.querySelector('.swiper');
    this.carousel = new RevolutionSwiper(this.carouselElement);

    this.bindEvents();
  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="select-product"]',
      this.selectProduct.bind(this)
    );

    this.carouselElement.swiper.on(
      "slideChange",
      this.selectCircle.bind(this)
    );
  }

  selectCircle() {
    this.element.querySelector('.inspiration__product-circle.selected')?.classList.remove("selected");
    this.element.querySelector(`.inspiration__product-circle[data-id="${this.carouselElement.swiper.activeIndex}"]`)?.classList.add("selected");
  }

  selectProduct(e) {
    const targetId = e.target.closest('[data-action]').dataset.id;
    this.carousel.selectCell(targetId);
  }
}
customElements.define("section-inspiration", Inspiration);


class SecondaryCartDrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.pageOverlayElement = document.querySelector(".pageOverlay");
    this.pageOverlayClear = document.querySelector(".clearOverlay");
    this.init();
    this.bindEvents();
  }

  init() {

    const currentPath = window.location.pathname;
    this.cartPage = currentPath.includes('/cart') ? true : false;

    setTimeout(() => {

      this.secondaryDrawer = document.body.querySelector('.second-level-cart__drawer');
      this.containerProductList = this.secondaryDrawer.querySelector('.second-level-product-list');
      this.containerProductMatchingList = this.secondaryDrawer.querySelector('.second-level-already-in-cart');
      this.matchingTitle = this.secondaryDrawer.querySelector('.second-level__data-title.matching-title');

      this.scrollableContent = this.secondaryDrawer.querySelector('.second-level__wrapper');

      this.scrollableContent.style.height = window.innerHeight - 64 + 'px';

  
      this.options = JSON.parse(
        this.element.getAttribute("data-button-settings")
      );

      try {
      
        // Check if a custom product list is specified in the options

        const productListCollection = this.options['product_list_canvas'];

        // If a custom product list is specified, use it; otherwise, default to frames collection

        if (productListCollection) { 
          this.productsList = this.secondaryDrawer.querySelector('#canvas-collection-json');
        } else {
          // Use frames collection (default)
          this.productsList = this.secondaryDrawer.querySelector('#frames-collection-json');
        }
  
        const jsonString = this.productsList.textContent || this.productsList.innerText;
  
        const framesCollection = JSON.parse(jsonString);
        this.productsListArray = framesCollection;


      } catch (e) {
        console.error("Failed to parse data-products JSON", e);
        this.productsList = [];
      }

 

      

      this.isOpen = false;


    }, 50);

  }

  bindEvents() {
    this.delegateElement.on(
      "click",
      '[data-action="toggle-subdrawer"]',
      this.toggleNextElement.bind(this)
    );

    this.delegateBody.on(
      "click",
      '[data-action="toggle-prev-subdrawer"]',
      this.togglePreviusElement.bind(this)
    );

    this.delegateBody.on(
      "click",
      '.pageOverlay.is-visible',
      this.togglePreviusElement.bind(this)
    );

    this.delegateBody.on(
      "click",
      '.clearOverlay.is-visible',
      this.togglePreviusElement.bind(this)
    );
    this._closeListener = this.togglePreviusElement.bind(this);
    this.delegateBody.on('subdrawer:close',this._closeListener );
  }



  showDataForVariant(optionValue, optionName, choosenProduct, choosenProductVariant, itemToRemove, quantity, singleProductQuantity, matchedframes) {
    const filteredProductsWithVariants = this.productsListArray.reduce((acc, product) => {
      const matchingVariants = product.variants.filter(variant => variant.options.includes(optionValue));
      matchingVariants.forEach(matchingVariant => {
        acc.push({ product, variant: matchingVariant });
      });
      return acc;
    }, []);

    if (filteredProductsWithVariants.length > 0) {
      this.renderVariants(filteredProductsWithVariants, optionName, choosenProduct, choosenProductVariant, itemToRemove, quantity, singleProductQuantity, this.containerProductList, matchedframes);
    }

    
  }

  findInFrameProductList(matchedProducts, products) {
    let matchedProductDetails = [];

    matchedProducts.forEach(matchedProduct => {
      let foundProduct = products.find(product => product.product.id == matchedProduct.product_id);

      // If found, add it to the matchedProductDetails array
      if (foundProduct) {
        // Add item_key to the found product
        let productWithItemKey = { ...foundProduct, item_key: matchedProduct.item_key, single_frame_quantity: matchedProduct.single_frame_quantity };
        matchedProductDetails.push(productWithItemKey);
      }
    });

    return matchedProductDetails;
  }

  renderVariants(products, optionName, choosenProduct, choosenProductVariant, itemToRemove, quantityToAdd, singleProductQuantity, divElement, matchedframes) {
    divElement.innerHTML = ''; //Clear existing content

    if (matchedframes) {
      this.containerProductMatchingList.innerHTML = ''; //Clear existing content for matching frames
      let matchedProducts = [];

      matchedframes.forEach(matched => {
        let productId = matched.getAttribute('product-id');
        let itemKey = matched.getAttribute('item-key');
        let productQuantity = matched.getAttribute('data-single-frame-quantity');
        matchedProducts.push({ product_id: productId, item_key: itemKey, single_frame_quantity: productQuantity });
      })

      const matchedProductsToShow = this.findInFrameProductList(matchedProducts, products);
      matchedProductsToShow.forEach(product => {
        const productHtmlMatched = this.renderTemplate(product, true, choosenProduct, quantityToAdd, singleProductQuantity, itemToRemove, choosenProductVariant, optionName);
        this.containerProductMatchingList.insertAdjacentHTML('beforeend', productHtmlMatched);
      });

    }

    products.forEach(product => {
      const productHtml = this.renderTemplate(product, false, choosenProduct, quantityToAdd, singleProductQuantity, itemToRemove, choosenProductVariant, optionName);
      this.containerProductList.insertAdjacentHTML('beforeend', productHtml);
    });
    if (window.theme.enableAnimations) {
    new RevolutionAnimation();
    }
  }

  renderTemplate(product, matched, choosenProduct, quantityToAdd, singleProductQuantity, itemToRemove, choosenProductVariant, optionName) {
    
    

    //take an image from the variant, if the variant does not have an image, take an image from the product, if the product does not have an image, leave it blank
    const productImage = `${product.variant.featured_image && product.variant.featured_image.src ? `
      <a href="${window.routes.localeRootUrl}/products/${product.product.handle}" class="AspectRatio" style="--aspect-ratio: 0.8">
        <img class="cartItem--Image" src="${product.variant.featured_image.src}" alt="${product.variant.featured_image.alt}">
      </a>
      ` :
      product.product.featured_image ? `
      <a href="${window.routes.localeRootUrl}/products/${product.product.handle}" class="AspectRatio" style="--aspect-ratio: 0.8">
        <img class="cartItem--Image" src="${product.product.featured_image}&width=200" alt="${product.product.featured_image.alt}">
      </a>
      `:
        ''
      }`;


    let variantOrgPrice = product.variant.price ? Shopify.formatMoney(
      product.variant.price,
      window.theme.moneyFormat
    ) : '';
    let variantCompareAtPrice = product.variant.compare_at_price ? Shopify.formatMoney(
      product.variant.compare_at_price,
      window.theme.moneyFormat
    ) : '';


    if(this.options['frame_discount']){
      const discountAmount = this.options['frame_discount_amount'] / 100;
      variantOrgPrice = product.variant.price ? Shopify.formatMoney(
        product.variant.price - (product.variant.price * discountAmount),
        window.theme.moneyFormat
      ) : '';

      variantCompareAtPrice = product.variant.price ? Shopify.formatMoney(
        product.variant.price,
        window.theme.moneyFormat
      ) : '';
    }

    if (variantCompareAtPrice === variantOrgPrice) {
      variantCompareAtPrice = false;
    }

    const cartItemPrices = !matched ?
    `<div class="cartItem__prices">
      <div class="cartItem__price-wrapper">
        ${variantCompareAtPrice ? `<span class="u-p2 pdp-compare-at-price mr-s"> ${variantCompareAtPrice} </span>` : ''}
        <span class="orginal-price u-p2 ${variantCompareAtPrice ? 'alert-color' : ''}"> ${variantOrgPrice}</span>
      </div>
    </div>` :
    '';



    const productFormId = `product-form` + choosenProduct + product.variant.id;

    const formHtml = !matched ? `
    <form  method="post" class="product-form" enctype="multipart/form-data" id=${productFormId}>

      <input type="hidden" name="product_id--${choosenProductVariant}" data-id="${choosenProductVariant}"
       value="${choosenProductVariant}" >

      <input name="frame_id--${product.variant.id}"  
      type="hidden" 
      form="${productFormId}" 
      data-id="${product.variant.id}"
      data-find="">

    <button data-quantity='${quantityToAdd}' data-single-product-quantity='${singleProductQuantity}' type="submit" class="AddToCartAjax connect-product-btn" 
    data-action="remove-and-add-all-to-cart" data-remove-product="${itemToRemove}" data-choosen-product=${choosenProductVariant} tabindex="0" >
      <span class="txt-btn u-p2">${window.cartStrings.connect_product}</span>
    </button>
    </form>
    ` :
      `<button data-frame-variant-id='${product.variant.id}' data-single-frame-quantity='${product.single_frame_quantity}' data-decrease-item-with-key = '${product.item_key}' data-quantity='${quantityToAdd}' data-single-product-quantity='${singleProductQuantity}' type="submit" class="AddToCartAjax connect-product-btn" 
    data-action="remove-and-connect" data-remove-product="${itemToRemove}" 
    data-choosen-product=${choosenProductVariant}>
      <span class="txt-btn u-p2">${window.cartStrings.connect_product}</span>
    </button>`;


    return `
    <div class='cart-item-wrapper  cartItem add-bottom-line animatedContent'>
      <div class="carti-item__single-wrapper">
   
        <div class="cartItem--Image">
       
            ${productImage}
         
        </div>
        <div class="cartItem--Informations">
          <div class="cartItem__details">
            <div class="cartItem--Flex">
              <a href="${window.routes.localeRootUrl}/products/${product.product.handle}" class="cartItem__name break u-p2">${product.product.title}</a>
            </div>
            <div class="product-option--Wrapper">
              <div class="product-option">
                <div class="u-p2 sidecartDrawer--optionNameAndValue">
                  ${optionName}: <span class="u-p2 sidecart-drawer__option-value">${this.optionToShow}</span>
                </div>
              </div>
            </div>
          </div>
          <div class="action-prices-wrapper">
           ${cartItemPrices}
           
              ${formHtml}
           
          </div>
        </div>
      </div>
    </div>`;

  }


  handleMatchedVariants(optionValue, optionName) {
    const singleFrames = Array.from(document.body.querySelectorAll('.single-frame'));
    const matchedFrames = singleFrames.filter(frame => {
      const frameSizeOption = frame.getAttribute('data-size-option');
      const frameSizeName = frame.getAttribute('data-size-name');
      return frameSizeOption === optionValue && frameSizeName === optionName;
    })
    if (matchedFrames.length > 0) {
      this.matchingTitle.style.display = "block";
      return matchedFrames;
    } else {
      return;
    }

  }


  toggleNextElement(event, target) {
    event.preventDefault();
    if (this.isOpen) return;
    this.isOpen = true;

    if (this.cartPage) {
      this.pageOverlayElement.classList.add("is-visible");
    } else {
      this.pageOverlayClear.classList.add("is-visible");
    }

    let options;
  try {
    options = JSON.parse(this.element.getAttribute("data-button-settings"));
  } catch (err) {
    console.error("Invalid or missing data-button-settings", err);
    this.isOpen = false;
    return;
  }
    console.log(options['product_list'])
   
    const optionValue = options['size_option_value'];
    const optionName = options['size_option_name'];
    const choosenProduct = options['product_id'];
    const choosenProductVariant = options['item_id'];
    const itemToRemove = options['item_key'];
    const quantity = options['quantity'];
    const singleProductQuantity = options['quantity_of_single_product'];
    this.optionToShow = this.element.querySelector('[variant-option-to-show]')?this.element.querySelector('[variant-option-to-show]').getAttribute('variant-option-to-show'):null;

  

    //insert matched variants for target element
    const matchedframes = this.handleMatchedVariants(optionValue, optionName);

    //insert products variants for target element
    this.showDataForVariant(optionValue, optionName, choosenProduct, choosenProductVariant, itemToRemove, quantity, singleProductQuantity, matchedframes);


    this.secondaryDrawer.style.display = 'block';

    setTimeout(() => {
      this.secondaryDrawer.setAttribute("aria-expanded", "true");
      const focus = this.secondaryDrawer.querySelector('[data-scrollable]');
      bodyScrollLock.disableBodyScroll(focus, bodyScrollLockOptions);

      this.secondaryDrawer.focus();
    }, 15);
  }


  togglePreviusElement(event, target) {
    event.preventDefault();
    if (!this.isOpen) return;


    this.secondaryDrawer.setAttribute("aria-expanded", "false");
    const focus = this.secondaryDrawer.querySelector('[data-scrollable]');
    bodyScrollLock.enableBodyScroll(focus);
    this.transitionEndedListener = this.translateTransitionEnded.bind(this);
    this.secondaryDrawer.addEventListener("transitionend", this.transitionEndedListener);
    if (this.cartPage) {
      this.pageOverlayElement.classList.remove("is-visible");
    } else {
      this.pageOverlayClear.classList.remove("is-visible");
    }
    this.isOpen = false;
  }


  translateTransitionEnded() {
    if (event.propertyName == 'transform') {
      this.isOpen = false;
      this.secondaryDrawer.style.display = 'none';
      this.secondaryDrawer.removeEventListener("transitionend", this.transitionEndedListener);
    }
  }

}
customElements.define("secondary-cart-drawer", SecondaryCartDrawer);
class CartSubdrawer extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    new AddToCart(this.element);
  }
}
customElements.define("cart-subdrawer", CartSubdrawer);
class CartPage extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.loader = this.element.querySelector(".itemLoader");
    this.cartCount = document.querySelectorAll(".CartCount");
    this.options = JSON.parse(this.element.getAttribute("data-settings"));
    this.pageLoader = document.body.querySelector(".pageLoader");
    this.delegateBody = new Delegate(document.body);
    this.pageOverlay = document.body.querySelector(".pageOverlay");

    this.breakpoint = new Responsive().getCurrentBreakpoint();
    this.changeEvent = new Event("quantity:changed", { bubbles: true });

    this.addToCartInstance = new AddToCart(this.element);

    this.bindEvents();
    this.buildGroups();
  }
  onUnload() {
    this.delegateElement.off();
    document.removeEventListener("product:added", this.onProductAddedListener);
  }
  bindEvents() {
    if (window.theme.listener == "false") {

      this.onProductAddedListener = this.onProductAdded.bind(this);
      document.addEventListener("product:added", this.onProductAddedListener);
      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity"], [data-action="remove-item"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity"]',
        this.updateItemQuantity.bind(this)
      );
      this.delegateElement.on(
        "keydown",
        '[data-action="update-change-quantity"]',
        this.preventEvent.bind(this)
      );

      this.delegateElement.on(
        "click",
        '[data-action="update-item-quantity-for-group"]',
        this.updateItemQuantitForGroup.bind(this)
      );

      this.delegateElement.on(
        "change",
        '[data-action="update-change-quantity-for-group"]',
        this.updateItemQuantitForGroup.bind(this)
      );
      this.delegateElement.on(
        "keydown",
        '[data-action="update-change-quantity-for-group"]',
        this.preventEvent.bind(this)
      );

      this.delegateElement.on(
        "quantity:changed",
        ".QuantitySelector__CurrentQuantity",
        this.updateItemQuantity.bind(this)
      );
      window.theme.listener = "true";
    }

  }


  preventEvent(event, target) {
    if (event.which === 13 || event.keyCode === 13 && event.target.getAttribute('data-action') === "update-change-quantity-for-group") {
      event.preventDefault();
      this.updateItemQuantitForGroup(event, target);
    }
    if (event.which === 13 || event.keyCode === 13) {
      event.preventDefault();
      this.updateItemQuantity(event, target);
    }
  }

  async updateItemQuantitForGroup(event, target) {
    event.preventDefault();
    const productInfo = event.target.closest('.cartItem--Informations');
    const productId = productInfo.dataset.addAgain;
    const value = productInfo.querySelector('.QuantitySelector__CurrentQuantity');

    let quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(event.target.dataset.quantity);

    }



    if (quantity >= 2) {

      quantity = quantity - 1;
      try {
        await this.addToCartInstance.addToCartWithId(productId, quantity);
        /*  */
        value.setAttribute('value', '1');
        this.onProductAdded(event);
      } catch (error) {
        console.error('Error during add to cart:', error);
      }
    }

    if (quantity === 0) {

      this.addToCartInstance.removeGroup(event);

    }
    new CustomEvent("product:changed", {
            bubbles: true})

  }

  updateItemQuantity(event, target) {
    event.preventDefault();

    if (!target.classList.contains('additional-servece-button') && target
      .closest(".cartItem")
      .querySelector(".itemLoader"))
      target
        .closest(".cartItem")
        .querySelector(".itemLoader")
        .classList.add("is-visible");

    var _this = this;

    var quantity = null;
    if (target.tagName === "INPUT") {
      quantity = parseInt(Math.max(parseInt(target.value) || 0, 0));
    } else {
      quantity = parseInt(target.getAttribute("data-quantity"));
    }

    fetch(window.routes.localeRootUrl + "/cart/change.js", {
      body: JSON.stringify({
        id: target.getAttribute("data-line-id"),
        quantity: quantity,
      }),
      credentials: "same-origin",
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-Requested-With": "XMLHttpRequest",
      },
    }).then(function (response) {
      _this.renderCart(target.getAttribute("data-id"), true);
      if (response.ok) {
        _this.element.dispatchEvent(
          new CustomEvent("product:changed", {
            bubbles: true,
            detail: target.getAttribute("data-id").match(/\d+/),
          })
        );
        localStorage.setItem(
          target.getAttribute("data-id").match(/\d+/),
          quantity
        );
      }
    });
  }

  onProductAdded(e) {

    if (e.detail.onlyRender) {
     
      this.renderCart().then(()=>{
        if(this.pageOverlay.classList.contains('is-visible')){
           this.pageOverlay.classList.remove('is-visible'); 
           const focus = this.element.querySelector('[data-scrollable]');
           bodyScrollLock.enableBodyScroll(focus);
        }
      });
      
    } else {
          this.renderCart().then(()=>{
            if(this.pageOverlay.classList.contains('is-visible')){
             this.pageOverlay.classList.remove('is-visible'); 
             const focus = this.element.querySelector('[data-scrollable]');
             bodyScrollLock.enableBodyScroll(focus);
            }
          });
  
    }
  }

  renderCart(lineNumber, quantityChange) {
    

    this.pageLoader.style.width = 100 + "%";
    var _this = this;

    return fetch(
      window.routes.localeRootUrl + "/cart",
      {
        credentials: "same-origin",
        method: "GET",
      }
    ).then(function (content) {
      content.text().then(function (html) {
        _this.replaceContent(html, lineNumber, quantityChange);
      });
    });


  }

  replaceContent(html, lineNumber, quantityChange) {

   
    this.pageLoader.style.left = "unset";
    this.pageLoader.style.right = 0 + "px";
    this.pageLoader.style.width = 0 + "%";
    setTimeout(() => {
      this.pageLoader.style.left = 0 + "px";
      this.pageLoader.style.right = "unset";
    }, 550);
    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;

    this.tempOptions = JSON.parse(
      tempElement.querySelector("#cartPage").getAttribute("data-settings")
    );


    this.options = this.tempOptions;

    

    var number = this.tempOptions["itemCount"];
    this.cartCount.forEach(num => {
      num.innerHTML = `${number}`;
    });
    window.theme.cartCount = parseInt(number);


    if (lineNumber) {


      var cartNodeParent = this.element.querySelector("#" + lineNumber);
      const itemToReplaceWith = tempElement.querySelector(
        "#" + lineNumber
      );



      if (cartNodeParent && cartNodeParent.querySelector(".itemLoader")) {
        cartNodeParent
          .querySelector(".itemLoader")
          .classList.remove("is-visible");
      }
      if (itemToReplaceWith) {
        cartNodeParent.replaceWith(
          itemToReplaceWith
        );
        if (window.theme.enableAnimations) {
        new RevolutionAnimation(this.element);
        }
      } else {
        if (cartNodeParent.classList.contains('hidden-product'))
          this.renderCart();
        else {
          cartNodeParent.classList.add("removing");
          cartNodeParent.animate(
            [
              // keyframes
              { transform: "translateY(0px)", opacity: "1" },
              { transform: "translateY(30px)", opacity: "0" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
          setTimeout(() => {
            cartNodeParent.remove();
          }, 500);
        }
      }

      if (number > 0 && this.element.querySelector(
        ".CartFooter--Buttons")) {
        const checkoutButtonParent = this.element.querySelector(
          ".CartFooter--Buttons"
        );
        const checkoutButtonToReplace = tempElement.querySelector(
          ".cartCheckout--Button"
        );
        checkoutButtonParent.replaceChild(
          checkoutButtonToReplace,
          checkoutButtonParent.querySelector(".cartCheckout--Button")
        );

        const footerTotalParent = this.element.querySelector(
          ".MetaIcon--Wrappers"
        );
        const footerTotalToReplace = tempElement.querySelector(
          ".CartFooter--Totals"
        );
        if (footerTotalParent && footerTotalToReplace) {
          footerTotalParent.replaceChild(
            footerTotalToReplace,
            footerTotalParent.querySelector(".CartFooter--Totals")
          );

        }




        const cartFreeShippingParent = this.element.querySelector(
          ".cart-drawer__shipping-wrapper"
        );
        const cartFreeShippingToReplace = tempElement.querySelector(
          ".cart-drawer__shipping-wrapperLeftContent"
        );

        const shippingBarTemp = tempElement.querySelector(
          ".cart-drawer__shipping-wrapperLeftMoneyProgress"
        );
        const shippingBarCurrent = this.element.querySelector(
          ".cart-drawer__shipping-wrapperLeftMoneyProgress"
        );

        if (cartFreeShippingToReplace) {
          cartFreeShippingParent.replaceChild(
            cartFreeShippingToReplace,
            cartFreeShippingParent.querySelector(
              ".cart-drawer__shipping-wrapperLeftContent"
            )
          );

          if (shippingBarTemp && shippingBarCurrent) {
            shippingBarCurrent.style.width = shippingBarTemp.style.width;
          } else if (shippingBarCurrent && !shippingBarTemp) {
            shippingBarCurrent.remove();
          } else {
            cartFreeShippingParent.append(
              tempElement.querySelector(
                ".cart-drawer__shipping-wrapperLeftMoneyProgressBar"
              )
            );
          }
        }



      } else {
        this.element
          .querySelector(".CartDrawer--Footer")
          .classList.add("removing");

        const mainPartParent = this.element.querySelector(".CartDrawer");

        mainPartParent.innerHTML =
          tempElement.querySelector(".CartDrawer").innerHTML;

        if (window.theme.enableAnimations) {
          const mainPartchildren =
            mainPartParent.querySelector("#main-cartItems");
          mainPartchildren.animate(
            [
              // keyframes
              { opacity: "0" },
              { opacity: "1" },
            ],
            {
              // timing options
              duration: 500,
              fill: "forwards",
            }
          );
        }
      }
      if (this.element.querySelector(".itemLoader")) {
        setTimeout(() => {
          this.element
            .querySelector(".itemLoader")?this.element
            .querySelector(".itemLoader")
            .classList.remove("is-visible"):null;
        }, 250);
      }
    } else {
      const cartNodeParent =
        this.element.querySelector(".CartDrawer").parentNode;
      const currentScrollPosition =
        this.element.querySelector("#main-cartItems").scrollTop;

      cartNodeParent.replaceChild(
        tempElement.querySelector(".CartDrawer"),
        this.element.querySelector(".CartDrawer")
      );
      this.element.querySelector("#main-cartItems").scrollTop =
        currentScrollPosition;
    }

    this.element.dispatchEvent(new Event("cart:rendered", { bubbles: true}));

  }

  buildGroups() {
    function getElementsBetween(startElem, endElem) {
      if (!startElem || !endElem) return;

      const elements = [];
      let current = startElem.nextElementSibling;
    
      while (current && current !== endElem) {
        elements.push(current);
        current = current.nextElementSibling;
      }
    
      return elements;
    }

    const openings = this.element.querySelectorAll(".product-card__group-open");
    const closings = this.element.querySelectorAll(".product-card__group-closed");

    const index = openings.length;
    if (!index || index !== closings.length) return;

    for (let i = 0; i < index; i++) {
      const opening = openings[i];
      const closing = closings[i];      
      
      const elementsBetween = getElementsBetween(opening, closing);
      elementsBetween.forEach(elem => opening.append(elem));
      
      opening.classList = opening.dataset.classList;
      opening.removeAttribute("data-class-list");
      opening.removeAttribute("data-index");
      closing.remove();
    }
  }
}
customElements.define("cart-page", CartPage);

class ProductCard extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.atc = this.element.querySelector(".product-card__form-wrapper")

    this.delegateElement = new Delegate(this.element);
    this.variantInput = this.element.querySelector('.product-card__variant-input');

    this.variantItems = this.element.querySelectorAll(".RevolutionSelectbox--Item");
    this.variantDrawerButton = this.element.querySelector('[data-action="toggle-drawer"]');

    this.productDrawer = new Drawer(this.element.querySelector("#product-drawer"));
    this.drawerContent = this.element.querySelector(".product-drawer__content");

    this.productCardForm = new AddToCart(this.element.querySelector(".product-card__form"));

    this.showSelectors();
    this.bindEvents();

  }

  bindEvents() {
    this.delegateElement.on(
      'change',
      this.updateATC.bind(this)
    );

    this.delegateElement.on(
      'click',
      '[data-action="toggle-drawer"]',
      this.renderVariantOptions.bind(this)
    );

    if(responsive.matchesBreakpoint("lap_and_up")){
      this.delegateElement.on("mouseenter", this.showATC.bind(this));
      this.delegateElement.on("mouseleave", this.hideATC.bind(this));
    }
    // Handle selectbox changes (but NOT from drawer - drawer has its own handler)
    this.delegateElement.on(
      'click',
      '.RevolutionSelectbox--Content [data-action="selectbox-change"]',
      this.updateATC.bind(this)
    );

    this.delegateElement.on(
        'click',
        '[data-action="toggle-drawer"]',
        this.renderDrawerContent.bind(this)
    );

    // Listen for clicks on drawer content items
    this.delegateElement.on(
      'click',
      '.product-drawer__content [data-action="selectbox-change"]',
      this.handleDrawerSelection.bind(this)
    );

    // Listen for close button in drawer
    this.delegateElement.on(
      'click',
      '[data-action="close-drawer"]',
      this.closeProductDrawer.bind(this)
    );

  }



  // Initialize reovlution selectboxes
  showSelectors() {
    const selectboxes = this.element.querySelectorAll('.RevolutionSelectbox');
    selectboxes.forEach(el => new RevolutionSelectbox(el));
  }

  renderDrawerContent(e) {
    // Use DrawerContent if available (shows all variants), otherwise fall back to regular Content (size-filtered)
    const drawerContent = this.element.querySelector('.RevolutionSelectbox--DrawerContent');
    const content = drawerContent || this.element.querySelector('.RevolutionSelectbox--Content');

    this.drawerContent.innerHTML = "";
    if (content) {
      Array.from(content.children).forEach(child => {
        this.drawerContent.appendChild(child.cloneNode(true));
      });
    }
  }

  // Render product card options on click of selector on mobile
  renderVariantOptions(e) {
    e.preventDefault();
    e.stopPropagation();

    // Check if this is a single variant product
    const button = e.target.closest('[data-action="toggle-drawer"]');
    if (button && button.dataset.singleVariant === 'true') {
      // Add directly to cart for single variant products
      const variantId = button.dataset.variantId;
      const quantity = 1;

      // Add to cart via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      })
      .then(response => response.json())
      .then(() => {
        // Dispatch product:added event to open cart drawer
        document.dispatchEvent(new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: variantId,
            quantity: quantity
          }
        }));
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });

      return; // Exit early, don't open the drawer
    }

    // Copy selectbox content to drawer - use DrawerContent if available (shows all variants)
    const drawerContent = this.element.querySelector('.RevolutionSelectbox--DrawerContent');
    const content = drawerContent || this.element.querySelector('.RevolutionSelectbox--Content');
    if (content && this.drawerContent) {
      this.drawerContent.innerHTML = "";
      Array.from(content.children).forEach(child => {
        this.drawerContent.appendChild(child.cloneNode(true));
      });
    }

    // Open the drawer
    if (this.productDrawer) {
      this.productDrawer.openDrawer();
    }
  }

  // Handle selection from drawer - automatically add to cart
  handleDrawerSelection(e) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    // Update the variant input
    const variantInput = this.element.querySelector(`.product-card__variant-input[data-productid="${e.target.dataset.productid}"]`);

    if (variantInput) {
      variantInput.value = e.target.dataset.variant;
      variantInput.dataset.id = e.target.dataset.variant;
    }

    // Update data-size on favorites button
    const sizeElement = this.element.querySelector('[data-size]');
    if (sizeElement) {
      sizeElement.dataset.size = e.target.dataset.value;
    }

    // Update the selectbox button title to show selected size
    const selectedSize = e.target.dataset.value;
    const selectboxButton = this.element.querySelector('.RevolutionSelectbox--Title');
    if (selectboxButton && selectedSize) {
      selectboxButton.innerHTML = selectedSize;
    }

    // Close the drawer
    if (this.productDrawer) {
      this.productDrawer.closeDrawer();
    }

    // Automatically add to cart after a brief delay (to ensure drawer closes smoothly)
    setTimeout(() => {
      const variantId = e.target.dataset.variant;
      const quantity = 1;

      // Add to cart via AJAX
      fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      })
      .then(response => response.json())
      .then(() => {
        // Dispatch product:added event to open cart drawer
        document.dispatchEvent(new CustomEvent("product:added", {
          bubbles: true,
          detail: {
            variant: variantId,
            quantity: quantity
          }
        }));
      })
      .catch(error => {
        console.error('Error adding to cart:', error);
      });
    }, 100);
  }

  // Close product drawer
  closeProductDrawer(e) {
    e.preventDefault();
    e.stopPropagation();
    if (this.productDrawer) {
      this.productDrawer.closeDrawer();
    }
  }

  updateATC(e) {

    e.preventDefault();

    const variantInput = this.element.querySelector(`.product-card__variant-input[data-productid="${e.target.dataset.productid}"]`);

    if (!variantInput) {
      return;
    }

    variantInput.value = e.target.dataset.variant;
    variantInput.dataset.id = e.target.dataset.variant;

    const sizeElement = this.element.querySelector('[data-size]');
    if (sizeElement) {
      sizeElement.dataset.size = e.target.dataset.value;
    }

  }

  showATC(){
    this.atc.classList.add("is-mounted")
    requestAnimationFrame(()=>{
      requestAnimationFrame(()=>{
      this.atc.classList.add("is-visible");
      });
    });
  }

  hideATC(){
    this.atc.classList.remove("is-visible");
    this.atc.addEventListener("transitionend", () =>{
      if(!this.element.matches(":hover")){
        this.atc.classList.remove("is-mounted")
      }
    })
    , {once:true};
  }
}
customElements.define("product-card", ProductCard);

class FavoritesHeader extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateBody = new Delegate(document.body);

    this.toggleFavorites();
    this.bindEvents();
  }

  bindEvents() {

    // Debounced click for toggling favorites
      this.delegateBody.on(
        "click",
        '[data-action="toggle-favorites"]',
        debounce(this.toggleFavorites.bind(this), 300)
      );

      // Optional: debounce keydown if needed
      this.delegateBody.on(
        "keydown",
        '[data-action="toggle-favorites"]',
        (e) => {
          if (e.key === "Enter") {
            debounce(this.toggleFavorites.bind(this), 300)();
          }
        }
      );


    this.delegateBody.on(
      "click",
      '[data-action="toggle-favorites"]',
      this.addToFavorites.bind(this)
    );

    this.delegateBody.on(
      "keydown",
      '[data-action="toggle-favorites"]',
      this.addToFavorites.bind(this)
    );

    this.toggleFavoritesListener = this.toggleFavorites.bind(this);
    this.delegateBody.on('favorites:retoggle', this.toggleFavoritesListener);

  }

  toggleFavorites() {
    // Check if there's a favorites section with shared favorites from URL
    var items = this.getFavorites();

    // Look for an initialized favorites section (prefer favorites-section over drawer)
    var favoritesSection = document.querySelector("favorites-section");
    if (!favoritesSection) {
      favoritesSection = document.querySelector("favorites-drawer");
    }

    // If there's a favorites section showing shared favorites, use its count
    if (favoritesSection &&
        typeof favoritesSection.getFavoritesToShow === 'function' &&
        favoritesSection.disableShowingAddedProducts === true) {
      var sharedItems = favoritesSection.getFavoritesToShow();
      if (sharedItems.length > 0) {
        items = sharedItems;
      }
    }

    var favorites = [
      ...document.querySelectorAll(".product-card_favorites-container"),
    ];

    if (document.body.querySelector(".empty-favorite")) {
      if (items.length > 0) {
        document.body.querySelector(".empty-favorite").style.display = "none";
        document.body.querySelector(".solid-favorite").style.display = "flex";
        if (new Responsive().matchesBreakpoint("pocket")) {
          document.body.querySelector("favorites-header").style.display = "flex";
        }
      } else {
        document.body.querySelector(".empty-favorite").style.display = "flex";
        document.body.querySelector(".solid-favorite").style.display = "none";
        if (new Responsive().matchesBreakpoint("pocket")) {
          document.body.querySelector("favorites-header").style.display = "none";
        }
      }
    }
    favorites.forEach(function (item) {
      var state = item.getAttribute("state");
      var myID = item.getAttribute("data-id");
      var exists = items.some(fav => fav.id === myID);
      if (state == "not-active" && exists) {
        item.querySelector(".solid-favorite").style.display = "flex";
        item.querySelector(".empty-favorite").style.display = "none";
        item.setAttribute("state", "active");
      } else if (!exists) {
        item.querySelector(".solid-favorite").style.display = "none";
        item.querySelector(".empty-favorite").style.display = "flex";
        item.setAttribute("state", "not-active");
      }
    });

    // Update favorites count
    const favoritesCount = document.querySelector(".favorites-heading__count");
    if (favoritesCount) {
      favoritesCount.innerText = ` (${items.length}`;
    }
  }

  getFavorites() {
    return JSON.parse(localStorage.getItem("productFavorites") || "[]").filter(item => item.id !== null);
  }

  saveFavorites(items) {
    localStorage.setItem("productFavorites", JSON.stringify(items.slice(0, 50)));
    this.toggleFavorites();
  }

  removeFromFavorites(productId, size) {
    let items = this.getFavorites();
    items = items.filter(item => item.id !== productId);

    this.saveFavorites(items);
    document.body.dispatchEvent(new CustomEvent("favorite:remove", {
      detail: { id: productId, size: size }
    }));
  }

  addToFavorites(e) {
    if (e.key && e.key != "Enter") {
      return;
    }
    e.preventDefault();

    let items = this.getFavorites();
    const productId = e.target.parentElement.getAttribute("data-id") || e.target.getAttribute("data-id");
    let size = e.target.parentElement.getAttribute("data-size") || e.target.getAttribute("data-size") || null;

    // If size is empty string, treat it as null
    if (size === "" || size === "null" || size === "undefined") {
      size = null;
    }

    if (!productId) {
      return;
    }

    const existingItemIndex = items.findIndex(item => item.id === productId);

    if (existingItemIndex === -1) {
      items.unshift({ id: productId, size: size });
    } else {
      this.removeFromFavorites(productId, size);
      return;
    }

    this.saveFavorites(items);
    document.body.dispatchEvent(new CustomEvent("favorite:add", {
      detail: { id: productId, size: size }
    }));

    this.toggleMessage();
  }


toggleMessage() {
    const msgContainer = document.querySelector(".favourites__success-message");
    if (!msgContainer) return;

    msgContainer.style.display = "block";
    window.requestAnimationFrame(() => {
      msgContainer.setAttribute("aria-hidden", false);
    });

    setTimeout(() => {
      msgContainer.setAttribute("aria-hidden", true);

      setTimeout(() => {
        msgContainer.style.display = "none";
      }, 300)
    }, 2000)
  }
}
customElements.define("favorites-header", FavoritesHeader);

// Initialize session storage flags for each favorites element type
// Reset flags if there's a shared favorites URL parameter
const urlParams = new URLSearchParams(window.location.search);
const hasSharedFavorites = urlParams.has('favorites');
if (hasSharedFavorites) {
  console.log('Shared favorites detected in URL, resetting initialization flags');
  sessionStorage.setItem("firstLoad_favorites-section", "true");
  sessionStorage.setItem("firstLoad_favorites-drawer", "true");
} else {
  sessionStorage.setItem("firstLoad_favorites-section", "true");
  sessionStorage.setItem("firstLoad_favorites-drawer", "true");
}

class Favorites extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);

    this.options = JSON.parse(
      (document.querySelector("#favorites-section")?.getAttribute("data-section-settings")) ||
      (document.querySelector("#favorites-drawer")?.getAttribute("data-settings")) ||
      '{}'
    );

    this.favoritesHeader = document.querySelector("favorites-header");
    this.gridElement = this.element.querySelector(".favorites__grid");
    this.shareButton = this.element.querySelector(".favorites__share-button-container");
    this.subtotal = this.element.querySelector(".favorites__subtotal");
    this.total = this.element.querySelector(".favorites__total");
    this.infiniteScroll = this.element.querySelector("#favorites__infinite-scroll");
    this.showAllBtn = this.element.querySelector(".favorites__show-all-button");
    this.currentIndex = 0;
    this.disableShowingAddedProducts = false;
    this.treshold = 650;

    this.updateQueue = Promise.resolve();

    /* const recommendedSwiperElement = this.element.querySelector(".favorites-section__recommended-products");
    if (recommendedSwiperElement && !this.element.closest("#favorites-section")) {
      const swiperConfig = JSON.parse(recommendedSwiperElement.getAttribute("data-swiper-settings") || "{}");
      this.recommendedSwiper = new Swiper(recommendedSwiperElement, swiperConfig);
    }
 */
    // Determine element type for instance-specific initialization
    const elementType = this.element.tagName ? this.element.tagName.toLowerCase() : 'favorites';
    const storageKey = `firstLoad_${elementType}`;

    // Check if this is a shared favorites link
    const urlHasSharedFavorites = window.location.search.includes('favorites=');

    console.log(`=== Favorites Constructor Debug ===`);
    console.log(`Element type: ${elementType}`);
    console.log(`Storage key: ${storageKey}, value: ${sessionStorage.getItem(storageKey)}`);
    console.log(`URL has shared favorites: ${urlHasSharedFavorites}`);
    console.log(`Full URL: ${window.location.href}`);

    // Skip initialization if this is a drawer that contains a favorites-section child
    // The child will handle rendering to avoid duplicates
    const hasFavoritesSectionChild = elementType === 'favorites-drawer' &&
                                     this.element.querySelector('favorites-section');

    console.log(`Has favorites-section child: ${hasFavoritesSectionChild}`);

    // Force initialization for shared favorites links even if flag is false
    const shouldInitialize = !hasFavoritesSectionChild &&
                             (sessionStorage.getItem(storageKey) !== "false" || urlHasSharedFavorites);

    console.log(`Should initialize: ${shouldInitialize}`);

    if (shouldInitialize) {
      console.log(`>>> Initializing ${elementType} <<<`);
      sessionStorage.setItem(storageKey, "false");
      this.renderContent();
      this.bindEvents();
      new AddToCart(this.element);

      requestAnimationFrame(()=>{
        this.checkIfEmpty();
      });

      // Additional check after page load to ensure count is correct (for shared links)
      if (document.readyState === 'complete') {
        // Page already loaded, update immediately
        console.log('Page already loaded, updating count now');
        setTimeout(() => {
          this.updateCountAfterRender();
        }, 200);
      } else {
        // Wait for load event
        window.addEventListener('load', () => {
          console.log('Page loaded, updating count');
          setTimeout(() => {
            this.updateCountAfterRender();
          }, 500);
        });
      }
    } else {
      console.log(`>>> Skipping initialization for ${elementType} <<<`);
      console.log(`Reason - hasFavoritesSectionChild: ${hasFavoritesSectionChild}, storageKey value: ${sessionStorage.getItem(storageKey)}, urlHasSharedFavorites: ${urlHasSharedFavorites}`);
    }
  }

  bindEvents() {
    if (!this.disableShowingAddedProducts) {
      this.delegateBody.on(
        "favorite:remove",
        this.removeFavorite.bind(this)
      );

      this.delegateBody.on('invalid', () => {
        this.showSnackbar('invalid');
    });

      this.delegateBody.on(
        "favorite:add",
        this.addFavorite.bind(this)
      );

      this.delegateElement.on(
        'click',
        '[data-action="undo"]',
        () => this.addFavorite()
      );

    }

    this.saveProductSizeListener = this.saveProductSize.bind(this);
    this.delegateBody.on('favorites:size_change', this.saveProductSizeListener);

    this.delegateElement.on(
      'click',
      '[data-action="copy-link"]',
      this.copyUrlToClipboard.bind(this)
    );

    this.delegateElement.on(
      'click',
      '[data-action="load"]',
      this.handleClick.bind(this)
    );


    window.onload = this.showNotifyMeButtons();

    this.delegateBody.on(
      "click",
      '[data-action="notify-open"]',
      this.openNotifyPopup.bind(this)
    );

    this.closeNotifyPopupBinder = this.closeNotifyPopup.bind(this);

    window.addEventListener('beforeunload', this.clearSearchParameters.bind(this));

  }

  // Replace history state with a url without the favorites parameter when a user goes forward and back,
  // so that old favorites aren't displayed because of the old url
  // Preserves other parameters like search query (q)
  clearSearchParameters() {
    const url = new URL(window.location.href);
    url.searchParams.delete('favorites');
    window.history.replaceState({}, '', url.href);
  }


  hideSavedIconsIfShared() {
    const url = new URL(window.location.href);
    const isShared = url.searchParams.get('shared') === 'true';

    if (!isShared) return;

    document
        .querySelectorAll('.product-card_favorites-container')
        .forEach(el => {
          el.style.display = 'none';
        });
  }

  renderContent() {
    this.compareFavorites();

    const favoritesTotal = this.getFavoritesToShow().length;
    if (favoritesTotal > 0) {
      this.rerenderFavorites(0, this.options["productsToShow"]);
    } else {

     const inspiration = document.querySelector('[data-hidden="true"]');
     if (inspiration) {
     inspiration.style.display = 'block';
     inspiration.dataset.hidden = 'false';
     }
    }
    if (favoritesTotal > this.options["productsToShow"]) {
      this.showAllBtn.style.display = "block";
    }

    this.subtotal.innerHTML = this.options["productsToShow"];
    this.total.innerHTML = favoritesTotal;

    // Update the favorites count in the heading (for shared favorites)
    this.updateFavoritesCount(favoritesTotal);

    // Update header count after we've determined if showing shared favorites
    if (this.favoritesHeader && this.favoritesHeader.toggleFavorites) {
      this.favoritesHeader.toggleFavorites();
    }

    this.hideSavedIconsIfShared();

  }

  updateFavoritesCount(count) {
    // Try to find the count element in multiple ways
    let favoritesCount = this.element ? this.element.querySelector(".favorites-heading__count") : null;
    if (!favoritesCount) {
      favoritesCount = document.querySelector(".favorites-heading__count");
    }

    console.log('updateFavoritesCount called with count:', count);
    console.log('favoritesCount element found:', !!favoritesCount);

    if (favoritesCount) {
      // The HTML structure is: <p class="favorites-heading__count"><p> &nbsp;{{ 'sections.favorites.products' | t }})</p></p>
      // We need to update the inner p tag
      const innerP = favoritesCount.querySelector('p');

      if (innerP) {
        console.log('Updating inner p tag');
        // Keep the existing "products)" text and just update the count
        const currentText = innerP.innerText || '';
        const productsMatch = currentText.match(/\s+(.+)\)$/);
        const productsText = productsMatch ? productsMatch[1] : 'products';

        innerP.innerText = ` ${count} ${productsText})`;
        console.log(`Updated count to: ${count}. New text: "${innerP.innerText}"`);
      } else {
        // Fallback: set the whole element
        console.log('No inner p found, setting whole element');
        favoritesCount.innerText = ` (${count}`;
      }

      console.log(`Final element text: "${favoritesCount.innerText}"`);
    } else {
      console.warn('Could not find favorites-heading__count element');
    }
  }

  updateCountAfterRender() {
    // Use multiple checks with increasing delays to ensure count updates
    const updateWithDelay = (delay) => {
      setTimeout(() => {
        const actualCount = this.getFavoritesToShow().length;
        console.log(`Updating count with delay ${delay}ms, count: ${actualCount}`);
        this.updateFavoritesCount(actualCount);

        // Also update header
        if (this.favoritesHeader && this.favoritesHeader.toggleFavorites) {
          this.favoritesHeader.toggleFavorites();
        }
      }, delay);
    };

    // Try multiple times with increasing delays
    updateWithDelay(50);
    updateWithDelay(200);
    updateWithDelay(500);
  }

  checkIfEmpty() {
    const items = this.getFavoritesToShow();

    const favoritesHeading = this.element.querySelector(".favorites__heading");
    const backButton = this.element.querySelector(".favorites__back");
    const emptyHeading = this.element.querySelector(".favorites__heading-empty");
    const recommProds = this.element.querySelector(".favorites-section__recommended-products");
    const drawerFooter = document.querySelector(".favorites-drawer__footer");

    if (items.length === 0) {
      // Favorites is empty - show empty state
      this.infiniteScroll.style.display = 'none';
      this.gridElement.parentElement.style.display = 'none';
      if (this.shareButton) {
        this.shareButton.style.display = 'none';
      }

      if (favoritesHeading) {
        favoritesHeading.style.display = "none";
      }
      if (backButton) {
        backButton.style.display = "block";
      }
      if (emptyHeading) {
        emptyHeading.style.display = "flex";
      }
      if (recommProds) {
        recommProds.style.display = "block";
      }
      if (drawerFooter) {
        drawerFooter.style.display = "none";
      }

    } else {
      // Favorites has items - show normal state
      this.infiniteScroll.style.display = '';
      this.gridElement.parentElement.style.display = '';
      if (this.shareButton) {
        this.shareButton.style.display = '';
      }

      if (favoritesHeading) {
        favoritesHeading.style.display = "flex";
      }
      if (backButton) {
        backButton.style.display = "none";
      }
      if (emptyHeading) {
        emptyHeading.style.display = "none";
      }
      if (recommProds) {
        recommProds.style.display = "none";
      }
      if (drawerFooter) {
        drawerFooter.style.display = "flex";
      }
    }
  }


  // Scroll hanndler for infinite scroll
  handleScroll() {
    const top = this.infiniteScroll.getBoundingClientRect().top - this.treshold;
    const bottom = this.infiniteScroll.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.rerenderFavorites(this.currentIndex, this.currentIndex + this.options["productsToLoad"]);
    }
  }

  // CLick handler for 'show all' button
  async handleClick(e) {
    this.infiniteLoad = true;
    e.preventDefault();

    const button = e.target.closest('.Button');
    button.querySelector('.itemLoader').classList.add('is-visible');
    if(this.gridElement.querySelector('.product-card:last-child .product-card__link-wrapper')){
      this.gridElement.querySelector('.product-card:last-child .product-card__link-wrapper').focus();
    }

    await this.rerenderFavorites(this.currentIndex, this.getFavoritesToShow().length);

    button.style.display = 'none';

    const debouncedFunction = debounce(this.handleScroll.bind(this), 50);
    this.scrollListener = scrollListener.addScrollListener(this.element, debouncedFunction);
  }

  // Update viewing info below the 'show all' button
  showAndUpdateViewingInfo() {
    if(this.getFavoritesToShow().length > this.options["productsToShow"]){
      // Only set infiniteLoad to false if it hasn't been explicitly enabled by user clicking load button
      if (this.infiniteLoad !== true) {
        this.infiniteLoad = false;
      }
    }else {
      this.infiniteLoad = true;
      this.element.querySelector('.favorites__show-all-button').style.display = 'none';
    }
    const favoritesTotal = this.getFavoritesToShow().length;

    // Count actual visible product cards in the grid
    const visibleProductsCount = this.gridElement ? this.gridElement.querySelectorAll('.product-card').length : 0;

    // Update subtotal - show current number of visible items or total if all loaded
    if (visibleProductsCount >= favoritesTotal) {
      this.subtotal.innerHTML = favoritesTotal;
    } else {
      this.subtotal.innerHTML = visibleProductsCount;
    }

    this.total.innerHTML = favoritesTotal;
  }

  // Compare current favorites stored in local storage and favorites pasted in the url 
  compareFavorites() {
    if (!(this.arraysEqual(this.getFavoritesFromUrl(), this.getFavorites()) || this.getFavoritesFromUrl().length === 0)) {
      this.disableShowingAddedProducts = true;
    }
  }

  // Check if two object arrays are equal
  arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) return false;
    arr1.sort((a, b) => a.id.localeCompare(b.id));
    arr2.sort((a, b) => a.id.localeCompare(b.id));
    for (let i = 0; i < arr1.length; i++) {
      if (arr1[i].id !== arr2[i].id) return false;
    }
    return true;
  }

  // Update url with new product information
  updateUrl() {
    // Only update URL if we're on the saved page or the drawer is open
    // On the saved page, the wrapper has id="favorites-section" (not the custom element itself).
    const isOnSavedPage = Boolean(document.querySelector('#favorites-section'));
    const isDrawerOpen = this.Drawer?.isOpen === true;

    if (!isOnSavedPage && !isDrawerOpen) {
      return; // Don't update URL on other pages when drawer is closed
    }

    const productIds = this.base64Encode(JSON.stringify(this.getFavorites()));
    const url = new URL(window.location);
    url.searchParams.set('favorites', productIds);
    window.history.replaceState({}, '', url);
  }

  base64Encode(str) {
    return btoa(encodeURIComponent(str));
  }

  base64Decode(str) {
    return decodeURIComponent(atob(str));
  }

  // Initialize reovlution selectboxes
  showSelectors() {
    // Only initialize selectboxes within the favorites grid, not from search results
    if (!this.gridElement) return;
    const selectboxes = this.gridElement.querySelectorAll('.RevolutionSelectbox');
    selectboxes.forEach(el => new RevolutionSelectbox(el));
  }

  // Update current url with updated product size
  saveProductSize(e) {
    const items = this.getFavorites();
    const productId = e.detail.id;
    const productIndex = items.findIndex(item => item.id === productId);
  
    if (productIndex !== -1) {
      items[productIndex].size = e.detail.size;
      localStorage.setItem("productFavorites", JSON.stringify(items.slice(0, 50)));
      this.updateUrl();
    }
  }

  // Set sizes for all products on first load or when rendering new products
  setSizes() {
    if (!this.gridElement) return;
    const items = this.getFavoritesToShow();
    items.forEach(item => {
      if (item.size !== null) {
        // Only query within the favorites grid, not the entire page
        const selectedVariant = this.gridElement.querySelector(`[data-id="${item.id}"] .RevolutionSelectbox--Item[data-value="${item.size}"]`);
        if (!selectedVariant) return;
        const variantId = selectedVariant.dataset.variant;
        const buttonTitles = selectedVariant.closest('.RevolutionSelectbox').querySelectorAll('.RevolutionSelectbox--Title');
        buttonTitles.forEach(el => el.innerHTML = selectedVariant.dataset.value);
        const favContainer = this.gridElement.querySelector(`.product-card_favorites-container[data-id="${item.id}"]`);
        if (favContainer) {
          favContainer.setAttribute("data-size", item.size);
        }
        const productForm = this.gridElement.querySelector(`.product-card__form[data-productid="${item.id}"]`);
        if (productForm) {
          const variantInput = productForm.querySelector('.product-card__variant-input');
          if (variantInput) {
            variantInput.value = variantId;
          }
        }
      }
    });
  }

  saveFavorites(productId, size) {
    const items = this.getFavorites();

    const existingItemIndex = items.findIndex(item => item.id === productId);

    if (existingItemIndex === -1) {
      items.unshift({ id: productId, size: size });
    } else {
      items[existingItemIndex].size = size;
    }

    localStorage.setItem("productFavorites", JSON.stringify(items.slice(0, 50)));
  }

  removeFavorite(e) {
    const product = e.detail;
    this.lastRemovedProduct = product;

    // Chain to queue to avoid overlapping DOM updates
    this.updateQueue = this.updateQueue.then(async () => {
      // Small delay allows any animation or transition to complete
      await new Promise(r => setTimeout(r, 50));

      const favoriteElement = this.element.querySelector(`[data-id="${product.id}"]`);
      if (favoriteElement) {
        const productCard = favoriteElement.closest(".product-card");
        if (productCard) {
          productCard.remove();
        }
      }

      this.checkIfEmpty();
      this.updateUrl();

      const favoritesTotal = this.getFavoritesToShow().length;
      const visibleCount = this.gridElement
        ? this.gridElement.querySelectorAll(".product-card").length
        : 0;

      // Only fetch a replacement if more products exist
      if (this.currentIndex < favoritesTotal && visibleCount < this.options["productsToShow"]) {
        await this.rerenderFavorites(this.currentIndex, this.currentIndex + 1, false, true);
      }



      this.showAndUpdateViewingInfo();
      this.showSnackbar("undo");
    });
  }


  toggleFavorites() {
    this.checkIfEmpty();
    // Update the count in the heading
    const favoritesTotal = this.getFavoritesToShow().length;
    this.updateFavoritesCount(favoritesTotal);
    // Also update the header
    if (this.favoritesHeader && this.favoritesHeader.toggleFavorites) {
      this.favoritesHeader.toggleFavorites();
    }
  }

  getFavorites() {
    return JSON.parse(localStorage.getItem("productFavorites") || "[]").filter(item => item.id !== null);
  }

  // Get object array of product ids and sizes from url
  getFavoritesFromUrl() {
    const url = new URL(window.location);
    const encodedProductData = url.searchParams.get('favorites');
    if (!encodedProductData) {
      return [];
    }
    const decodedProductData = this.base64Decode(encodedProductData);

    return JSON.parse(decodedProductData);
  }

  // Get object array of product ids and sizes that are currently shown on the screen
  getFavoritesToShow() {
    var items;

    if (this.disableShowingAddedProducts) {
      items = this.getFavoritesFromUrl();
    } else {
      items = this.getFavorites();
    }

    return items;
  }

  // Get product ids in a format that is necessary for a fetch call
  getSearchQueryStrings(startIndex, endIndex, preserveIndex = false) {
    const items = this.getFavoritesToShow();
    const bucketSize = 10;
    const limitedItems = items.slice(startIndex, endIndex);

    if (!preserveIndex) {
      this.currentIndex = endIndex; // only advance index normally
    }

    const idBuckets = Array.from(
      { length: Math.ceil(limitedItems.length / bucketSize) },
      (_, i) =>
        limitedItems
          .slice(i * bucketSize, (i + 1) * bucketSize)
          .map(item => `id:${item.id}`)
          .join(" OR ")
    );

    return idBuckets;
  }


  // Add a single favorite
  async addFavorite(e) {
    var productId;
    var size = null;
    var sizeExists = true;
    if (e && e.detail) {
      productId = e.detail.id;
      size = e.detail.size || null;
      sizeExists = false;
    } else {
      productId = this.lastRemovedProduct.id;
      size = this.lastRemovedProduct.size;
    }

    try {
      const response = await fetch(`/search?view=favorites&type=product&q=id:${productId}`);
      const html = await response.text();
      if (sizeExists) {
        this.saveFavorites(productId, this.lastRemovedProduct.size);
      } else {
        this.saveFavorites(productId, size);
      }
      this.appendContent(html, true);
    } catch (error) {
      console.error('Error fetching favorite:', error);
    }
  }

  // Add multiple favorites
  async rerenderFavorites(startIndex, endIndex, clear, preserveIndex = false) {
    if (this.currentIndex >= this.getFavoritesToShow().length && this.scrollListener) {
      this.scrollListener.removeScrollListener();
      return;
    }

    if (clear) {
      this.gridElement.innerHTML = "";
    }

    const queryStrings = this.getSearchQueryStrings(startIndex, endIndex, preserveIndex);

    if (queryStrings.length === 0) {
      const response = await fetch("/?section_id=main-favorites");
      const html = await response.text();
      this.appendContent(html);
      // Update count after content is appended
      this.updateCountAfterRender();
      return;
    }

    for (const queryString of queryStrings) {
      const response = await fetch(`${window.routes.localeRootUrl}/search?view=favorites&type=product&q=${queryString}`, {
        credentials: "same-origin",
        method: "GET",
      });
      const html = await response.text();
      this.appendContent(html);
    }

    // Update count after all products are rendered
    this.updateCountAfterRender();
    return true;
  }


  // Append product cards to grid
  appendContent(html, one) {
    // Ensure gridElement is valid - try to requery if it's null
    if (!this.gridElement) {
      this.gridElement = this.element.querySelector(".favorites__grid");

      if (!this.gridElement) {
        console.error('Favorites grid element not found');
        return;
      }
    }

    var tempElement = document.createElement("div");
    tempElement.innerHTML = html;
    var gridElement = tempElement.querySelector(".favorites__grid");

    // Safety check: ensure we found a valid grid element with products
    if (!gridElement || !gridElement.firstElementChild) {
      console.warn('No valid favorites grid found in response');
      return;
    }

    if (!one) {
      while (gridElement.firstElementChild) {
        this.gridElement.appendChild(gridElement.firstElementChild);
      }
    } else {
      this.gridElement.prepend(gridElement.firstElementChild);
    }

    this.toggleFavorites();
    if (!this.disableShowingAddedProducts) {
      this.updateUrl();
    }
    this.showAndUpdateViewingInfo();
    this.showNotifyMeButtons();
    this.showSelectors();
    this.setSizes();

    if(!this.infiniteLoad){
      const maxVisible = this.options["productsToShow"];
      const cards = this.gridElement.querySelectorAll('.product-card');
      if (cards.length > maxVisible) {
        for (let i = maxVisible; i < cards.length; i++) {
          cards[i].remove();
        }
      }
    }

    this.hideSavedIconsIfShared();

  }

  async copyUrlToClipboard() {
    const favoritesPayload = this.base64Encode(JSON.stringify(this.getFavorites()));

    // Prefer sharing a link to the favorites page when copying from the drawer
    // so the receiver lands on the correct page.
    let baseHref = window.location.href;
    if (this.element.tagName && this.element.tagName.toLowerCase() === 'favorites-drawer') {
      const viewAllLink =
        this.element.querySelector('.favorites-drawer__footer a[href]:not(.favorites-drawer__footer-button--continue)') ||
        this.element.querySelector('.favorites-drawer__footer a[href]');
      if (viewAllLink) {
        baseHref = viewAllLink.href;
      }
    }

    const url = new URL(baseHref);
    url.searchParams.set('favorites', favoritesPayload);
    url.searchParams.set('shared', 'true');
    try {
      await navigator.clipboard.writeText(url.href);
      this.showSnackbar("copy");
    } catch (error) {
      console.error('Failed to copy URL: ', error);
    }
  }

  showSnackbar(identifier) {

    this.snackbar = this.element.querySelector(`.favorites__snackbar--${identifier}`);
    this.snackbar.setAttribute('aria-hidden', 'false');

    const clickHandler = () => {
      clearTimeout(this.snackbarTimeout);
      this.snackbar.setAttribute('aria-hidden', 'true');
      this.delegateBody.off("click", clickHandler);
    };

    this.delegateBody.on("click", clickHandler);

    // Clear the previous timeout if it exists
    if (this.snackbarTimeout) {
      clearTimeout(this.snackbarTimeout);
    }

    this.snackbarTimeout = setTimeout(() => {
      this.snackbar.setAttribute('aria-hidden', 'true');
      if(identifier === "undo"){
        this.rerenderFavorites(this.currentIndex, this.currentIndex + 1);
        this.showAndUpdateViewingInfo();
      }
    }, 3000);
  }

  openNotifyPopup() {
    event.preventDefault();
  }

  showNotifyMeButtons() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }

    this.intervalId = setInterval(() => {
      this.notifyMePopup = document.querySelector(
        ".appikon-bis-inline-form-wrapper"
      );

      if (this.notifyMePopup) {
        clearInterval(intervalId);

        const productImage = this.element
          .querySelector(".ProductSlider--ImageFirst")
          .cloneNode(true);
        const destContainer = this.element.querySelector(
          "#appikon-bis-inline-form-wrapper"
        );
        destContainer.appendChild(productImage);

        const closeButton = document.createElement("button");
        closeButton.classList.add("notifyMe--Close");
        closeButton.setAttribute("data-action", "notify-close");
        closeButton.innerHTML = `
          <svg
            width="20"
            height="20"
            viewBox="0 0 20 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path d="M10.9978 9.96635L15.9478 5.01636C16.1785 4.74696 16.163 4.34537 15.9122 4.09456C15.6614 3.84375 15.2598 3.82824 14.9904 4.05895L10.0404 9.00894L5.09045 4.05216C4.82104 3.82145 4.41945 3.83696 4.16865 4.08777C3.91784 4.33858 3.90233 4.74017 4.13304 5.00957L9.08303 9.96635L4.12625 14.9163C3.93248 15.0823 3.84807 15.3428 3.90774 15.5909C3.9674 15.8389 4.16107 16.0326 4.40911 16.0923C4.65716 16.1519 4.91771 16.0675 5.08366 15.8737L10.0404 10.9238L14.9904 15.8737C15.2598 16.1045 15.6614 16.0889 15.9122 15.8381C16.163 15.5873 16.1785 15.1857 15.9478 14.9163L10.9978 9.96635Z" fill="#555555"/>
          </svg>`;
        destContainer.appendChild(closeButton);

        this.pageOverlayElement.addEventListener(
          "click",
          this.closeNotifyPopup.bind(this)
        );

        this.domDelegate.on(
          "click",
          '[data-action="notify-open"]',
          this.openNotifyPopup.bind(this)
        );

        this.domDelegate.on(
          "click",
          '[data-action="notify-close"]',
          this.closeNotifyPopup.bind(this)
        );

        if (this.element.querySelector("variant-selects")) {
          this.element.dispatchEvent(
            new CustomEvent("notify:added", {
              bubbles: true,
              detail: this.element.querySelectorAll(".ProductPage--NotifyMe"),
            })
          );
        }
      }
    }, 100);

    setTimeout(() => {
      clearInterval(this.intervalId);
    }, 10000);
  }

  openNotifyPopup() {
    event.preventDefault();
    this.isOpen = true;

    this.notifyMeOverlay.classList.add("is-visible");
    this.domDelegate.on(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    bodyScrollLock.disableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.add("showNotifyMe");
  }

  closeNotifyPopup() {
    event.preventDefault();
    if (!this.isOpen) return;

    this.domDelegate.off(
      "click",
      ".notifyMeOverlay",
      this.closeNotifyPopupBinder
    );
    this.notifyMeOverlay.classList.remove("is-visible");

    bodyScrollLock.enableBodyScroll(
      document.querySelector("[data-scrollable]"),
      bodyScrollLockOptions
    );
    document
      .querySelector(".appikon-bis-inline-form-wrapper")
      .classList.remove("showNotifyMe");

    this.isOpen = false;
  }
}
customElements.define("favorites-section", Favorites);

class FavoritesDrawer extends Favorites {
  constructor() {
    super();
    this.Drawer = new Drawer(this.element);
  }
}
customElements.define("favorites-drawer", FavoritesDrawer);

class CountryModal extends HTMLElement {
  constructor() {
    super();
    this.element = this;

    const selectBoxes = this.element.querySelectorAll('.RevolutionSelectbox');
    if (responsive.matchesBreakpoint("lap_and_up")) {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item);
        });
      }
    } else {
      if (selectBoxes.length > 0) {
        selectBoxes.forEach((item, i) => {
          new RevolutionSelectbox(item, true, true);
        });
      }
    }

    this.bindEvents();
  }

  bindEvents() {
    document.addEventListener("change:countrySelector", this.updateLanguageOptions.bind(this));
    this.element.addEventListener("keydown", (event) => {
      if (event.key === "Enter") {
        const focusedItem = this.element.querySelector('.country-selector__dropdown--country .RevolutionSelectbox--Item:focus');
        if (focusedItem) {
          focusedItem.click();
        }
      }
    });

    
  }


  updateLanguageOptions() {
    const languagesJSON = event.detail.languages;
    // Parse the JSON data
    const languages = JSON.parse(languagesJSON);
    
    // Get the container where the radio buttons will be appended
    const container = this.element.querySelector('.country-selector__dropdown--language .RevolutionSelectbox--InnerContent');
    container.innerHTML = ''; // Clear existing content

    const exampleItem = this.element.querySelector('.RevolutionSelectbox--Item--Example');
    
    // Loop through each language and create elements
    languages.forEach(language => {
      // Clone the example item
      const newItem = exampleItem.cloneNode(true);

      // Remove the RevolutionSelectbox--Item--Example class
      newItem.classList.remove('RevolutionSelectbox--Item--Example');

      // Set data-value and data-name attributes
      newItem.setAttribute('data-value', language.iso);
      newItem.setAttribute('data-name', language.name);

      // Set the inner HTML to language name
      newItem.innerHTML = language.name;

      // Append the new item to the container
      container.appendChild(newItem);
    });


    const newSelectbox = this.element.querySelector('.country-selector__dropdown--language .RevolutionSelectbox');
    if (responsive.matchesBreakpoint("lap_and_up")) {
      new RevolutionSelectbox(newSelectbox);
    } else {
      new RevolutionSelectbox(newSelectbox, true, true);
    }

    const languageButton = this.element.querySelector('[data-select="language_code"]');
    if(!languageButton) return;
    const languageButtonTitle = languageButton.querySelector('.RevolutionSelectbox--Title');
    const languageSelector = this.element.querySelector('#language_selector');
    languageSelector.value = languages[0].iso;
    languageButtonTitle.innerHTML = languages[0].name;
    console.log(languages.length);
    if (languages.length < 2) {
 

      languageButton.style.pointerEvents = 'none';
      languageButtonTitle.style.color = 'var(--primary_grey)';
      languageButton.querySelector('.Svg--arrow-down-sharp').style.opacity = '0';

    } else {
    
      languageButton.style.pointerEvents = 'all';
      languageButtonTitle.style.color = 'var(--primary_text)';
      languageButton.querySelector('.Svg--arrow-down-sharp').style.opacity = '1';
    }
  }
}
customElements.define("country-modal", CountryModal); 


class CollectionBanner extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    if (!responsive.matchesBreakpoint("lap_and_up")) {
      this.carouselElement = this.element.querySelector(".collection-banner-links__swiper-mobile .swiper");
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }

    this.bindEvents();
  }

  bindEvents() {
   
  }

}
customElements.define("collection-banner", CollectionBanner);

class SearcInfiniteScroll extends HTMLElement{ 
  constructor() {
    super();
    this.element = this;
    this.treshold = 650;
    this.handleScrollListener = this.handleScroll.bind(this);
    this.delegateBody = new Delegate(document.body);
    this.delegateElement = new Delegate(this.element);
      this.bindEvents();
    this.running = false; 
 
  }

  bindEvents() {
    this.listenerBinder = this.addUserScrollListener.bind(this);

    this.delegateElement.on(
      "click",
      '[data-action="load"]',
      this.listenerBinder
    );
  }

  addUserScrollListener(e) {

    e.preventDefault();
    this.handleClick();
    this.initialize();
    this.initObserver();
    this.running == true;
    this.delegateElement.off(
      "click",
      this.listenerBinder
    );
  }

  initialize() {
    document.addEventListener("scroll", this.handleScrollListener);
  }

  initObserver() {
    const observerOptions = {
        root: null, // Use the viewport as the root
        rootMargin: '0px', // No margin around the root
        threshold: 0 // Trigger callback when even one pixel is in view
    };

    this.observer = new IntersectionObserver(this.handleIntersect.bind(this), observerOptions);
    this.observer.observe(this.mainContainer);
}

handleIntersect(entries) {
    entries.forEach(entry => {
        if (entry.isIntersecting) {
          if (this.running == false) {
            this.initialize();
            this.running = true;
          }
          
        } else {
           this.destroy();
        }
    });
}




  handleClick() {
    event.preventDefault();
    event.target.closest('a').setAttribute('disabled','true');
    this.lastClick = event.target.parentElement.id;
    this.paginationElement = event.target.closest(".btnLoad--wrapper");
    this.mainContainer = event.target.closest('[data-results]');
    if (!this.paginationElement) return;

    this.nextPageLinkElement = this.paginationElement.querySelector('a');


    if (this.nextPageLinkElement) {

      const nextPageUrl = this.nextPageLinkElement.href;

      const promises = this.generateFetchPromises(nextPageUrl);
      this.renderData(promises, false, this.paginationElement);
    }
  }

  handleScroll() {

    this.paginationElement = document.querySelector(`#${this.lastClick}`);
   

    if (!this.paginationElement) return;
    const top = this.paginationElement.getBoundingClientRect().top - this.treshold;
    const bottom = this.paginationElement.getBoundingClientRect().bottom + this.treshold;

    if (top <= window.innerHeight && bottom >= 0) {
      this.nextPageLinkElement = this.paginationElement.querySelector('a');

      if (this.nextPageLinkElement) {
        this.destroy();
        const nextPageUrl = this.nextPageLinkElement.href;
        const promises = this.generateFetchPromises(nextPageUrl);
        this.renderData(promises, false, this.paginationElement);
      }
    }
  }


  destroy() {
    // Remove the event listener when the instance is no longer needed
    document.removeEventListener("scroll", this.handleScrollListener);
  }

  generateFetchPromises(nextPageUrl) {
    const promises = [];

    if (nextPageUrl == false) {
      const hasSearchParameters = window.location.search.length > 0;
      const limit = parseInt(sessionStorage.getItem('pageNum'));
      for (let i = 2; i <= limit; i++) {
        let url;

        // Build the URL based on the condition
        if (hasSearchParameters) {
          url = `${window.location.href}&page=${i}`;
        } else {
          url = `${window.location.href}?page=${i}`;
        }

        promises.push(fetch(url, {
          credentials: "same-origin",
          method: "GET",
        }));
      }
    } else {
      const url = `${nextPageUrl}`;

      promises.push(fetch(url, {
        credentials: "same-origin",
        method: "GET",
      }));
    }

    return promises;
  }


  async renderData(promises, restoreContent, paginationElement) {

    try {
      const responses = await Promise.all(promises);
      const contents = await Promise.all(responses.map(response => response.text()));
      let isLastPromise = false;
      contents.forEach((content, index) => {
        isLastPromise = index === contents.length - 1;
        this.appendContent(content, isLastPromise, restoreContent);
      });
    } catch (error) {
      console.error('Error fetching or parsing data:', error);
    }
  }


  appendContent(content, lastPromise, restoreContent) {
    const parser = new DOMParser();
    const doc = parser.parseFromString(content, 'text/html');
    const mainAreaId = this.mainContainer.getAttribute('id');

    const newMainContainer = doc.querySelector(`#${mainAreaId}`);
    this.viewingItems = this.mainContainer.querySelector('.template-style');
 
    
    const newViewingItems = newMainContainer.querySelector('.template-style');

    if (newViewingItems && this.viewingItems) {
      this.viewingItems.innerHTML = newViewingItems.innerHTML;
    }



    const blocksToAdd = newMainContainer.querySelectorAll('[data-items]');


    blocksToAdd.forEach(block => {
      this.mainContainer.insertAdjacentHTML('beforeend', block.outerHTML);
    });
    this.element.querySelector('a').remove();
    this.mainContainer.appendChild(this.element);
    const newPaginationLink = newMainContainer.querySelector('.btnLoad--wrapper a');
    console.log(newPaginationLink);
    if (newPaginationLink) {
      
      newPaginationLink.style.display = "none";

      this.element.querySelector('.btnLoad--wrapper').appendChild(newPaginationLink);
    }

    if (lastPromise) {
      this.initialize();
    }

    if (lastPromise && restoreContent) {
      this.restoreScroll();
    }

    document.dispatchEvent(
      new CustomEvent("pagination:finished", { bubbles: true })
    );
    
    requestAnimationFrame(() => {
      document.body.dispatchEvent(
        new CustomEvent("favorites:retoggle", {
        })
    );
    });

  }
  restoreScroll() {
    const selector = `${this.containerSelector} [data-id='${sessionStorage.getItem('clickedProductId')}']`;
    const targetElement = document.querySelector(selector);
    if (targetElement) {
      targetElement.scrollIntoView({
        behavior: 'smooth', // You can use 'auto' for instant scrolling
        block: 'end',     // You can use 'center' or 'end' for different alignments
      });
    }
  }


}
customElements.define("infinite-scroll", SearcInfiniteScroll);


class Search extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);
    this.delegateBody = new Delegate(document.body);
    this.element.style.opacity = '0';
    this.breakpoint = new Responsive().getCurrentBreakpoint();

    // Find result elements
    this.resultElements = this.element.querySelectorAll(".Search--Result");
 
    this.resultArticles = this.element.querySelector('.Search--Result.Article--Result');
    this.resultProducts = this.element.querySelector('.Search--Result.searchProducts--results');
    this.resultCollections = this.element.querySelector('.Search--Result.Collection--Result');

    // Find buttons to toggle between products and articles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.openCollectionBtn = this.element.querySelector("#collectionBtn");
    new AddToCart(this.element);


    if (this.openProductBtn && this.openProductBtn.classList.contains('active')) {
      if(this.resultArticles) this.resultArticles.style.display = 'none';
      if(this.resultCollections) this.resultCollections.style.display = 'none';
    }

    if (this.openArticleBtn && this.openArticleBtn.classList.contains('active')) {
      if(this.resultsProduct) this.resultProducts.style.display = 'none';
      if(this.resultCollections) this.resultCollections.style.display = 'none';
    }

    if (this.openCollectionBtn && this.openCollectionBtn.classList.contains('active')) {
      if(this.resultsProduct) this.resultProducts.style.display = 'none';
      if(this.resultArticles) this.resultArticles.style.display = 'none';
    }


    this.bindEvents();
  }

  bindEvents() {
    // Toggle between products and articles when buttons are clicked
    this.delegateElement.on(
      "click",
      '[data-action="toggle-products"]',
      this.showProducts.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-articles"]',
      this.showArticles.bind(this)
    );
    this.delegateElement.on(
      "click",
      '[data-action="toggle-collections"]',
      this.showCollections.bind(this)
    );

    document.addEventListener(
      "DOMContentLoaded",
      this.handleMainSearchWithPagination.bind(this)
    );

  }

  handleMainSearchWithPagination() {
    const currentURL = window.location.href;
    const url = new URL(currentURL);
    // Extract the 'q' parameter
    const searchQuery = url.searchParams.get('q');

    if (!searchQuery) {
      return;
    }

    const updatedURL = `/search?q=${encodeURIComponent(searchQuery)}`;

    const predictiveURL = routes.predictive_search_url;
    const searchInput = this.querySelector('.Search--Input');
    const lastInputValue = searchInput?.dataset.inputValue || searchQuery;

    const articleURL = updatedURL + '&type=article';

    const productURL = updatedURL + '&type=product';

    // Create promises for collections data
    const collectionPromise = fetch(`${predictiveURL}?q=${encodeURIComponent(lastInputValue)}&resources[limit_scope]=each&resources[options][fields]=product_type,tag,title,variants.title&section_id=collection_search_item`)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const collectionResults = doc.querySelector('div');
        
        return collectionResults;
      });

    const articlePromise = fetch(articleURL)
      .then(response => response.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        const articleResults = doc.querySelectorAll('.templateSearch');
        
        return Array.from(articleResults).map(result => result.innerHTML);
      });


    const productPromise = fetch(productURL)
      .then(response => response.text())
      .then(html => {
        // Parse HTML string into a DOM document
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Find elements with class 'templateSearch' and extract their innerHTML
        const productResults = doc.querySelectorAll('.templateSearch');
        return Array.from(productResults).map(result => result.innerHTML);
      });

    // Create separate divs for articles, collections and product data
    Promise.all([articlePromise, productPromise, collectionPromise]).then((results) => {
      var articleData = results[0];
      var productData = results[1];
      var collectionData = results[2];
      console.log(results);
      // Create div for article data
      var articleDiv = document.createElement('div');
      articleDiv.innerHTML = articleData.join('');
      console.log(collectionData);
      if(collectionData){
      var collectionDiv = document.createElement('div');
      collectionDiv.innerHTML = collectionData?collectionData.outerHTML:null;
      }

      // Create div for product data
      var productDiv = document.createElement('div');
      productDiv.innerHTML = productData.join('');

       this.updateResultNumber(productDiv, articleDiv, collectionDiv);
      this.updateContentGrid(productDiv, articleDiv, collectionDiv); 
    });


  }

  updateContentGrid(productData, articleData, collectionData) {
    const productGrid = productData.querySelector('.searchProducts--results');
    const articleGrid = articleData.querySelector('.Article--Result');
    const collectionGrid = collectionData?collectionData.querySelector('.collection-results-grid'):null;

    const oldDataProduct = this.element.querySelector('.searchProducts--results');
    const oldDataArticle = this.element.querySelector('.Article--Result');
    const oldDataCollection = this.element.querySelector('.Collection--Result');

    // Replace the content of the destination elements with the cloned content

    if (oldDataProduct && productGrid){
      oldDataProduct.innerHTML = productGrid.innerHTML; // Clear old content
      requestAnimationFrame(() => {
        document.body.dispatchEvent(
          new CustomEvent("favorites:retoggle", {
          })
      );
      });
    }
   

    if (oldDataCollection && collectionGrid){
      oldDataCollection.innerHTML = collectionGrid.innerHTML; // Clear old content

    }


    if((!oldDataCollection || oldDataCollection.dataset.empty == 'true') && !oldDataProduct && !oldDataArticle && collectionGrid){


   this.element.querySelector('.empty_state').innerHTML = collectionData.querySelector('.main-templateSearch--WrapperBtns').innerHTML;
      this.element.querySelector('.Collection--Result').innerHTML = collectionData.querySelector('.collection-results-grid').innerHTML;
      this.element.querySelector('.Collection--Result').style.display = 'grid';
    }



    if (oldDataArticle && articleGrid) {
      oldDataArticle.innerHTML = articleGrid.innerHTML; // Clear old content
    }

    this.element.style.opacity = '1';
  }

  updateResultNumber(div1, div2, div3) {

    const productNumber = div1.querySelector('.main-templateSearch--WrapperBtns') ? div1.querySelector('.main-templateSearch--WrapperBtns').dataset.count : null;
    const articleNumber = div2.querySelector('.main-templateSearch--WrapperBtns') ? div2.querySelector('.main-templateSearch--WrapperBtns').dataset.count : null;
    const collectionNumber = parseInt(div3 && div3.querySelector('.collection-results-grid') ? div3.querySelector('.collection-results-grid').dataset.count : null);
    


    //load btns update total num
    this.element.querySelector('.loadMoreBtn--itemsNumProducts') ? this.element.querySelector('.loadMoreBtn--itemsNumProducts').innerHTML = productNumber : null;
    this.element.querySelector('.loadMoreBtn--itemsNumArticles') ? this.element.querySelector('.loadMoreBtn--itemsNumArticles').innerHTML = articleNumber : null;
    
    // Find number of products, collections and articles and display them
    const itemNumber = document.body.querySelector("#productBtn .itemNumber") ? document.body.querySelector("#productBtn .itemNumber") : null;
    
   
    if (itemNumber) {
      itemNumber.innerHTML = productNumber;
      
      if (productNumber == 0 || !productNumber) {
        this.openProductBtn?this.openProductBtn.style.display = "none":null;
      }
    }


    const itemNumber_3 = this.element.querySelector(".itemNumber_3") ? this.element.querySelector(".itemNumber_3") : null;
    const itemNumber_2 = this.element.querySelector(".itemNumber_2") ? this.element.querySelector(".itemNumber_2") : null;
    console.log(itemNumber_2);
    if (itemNumber_2) {
      itemNumber_2.innerHTML = articleNumber;
      if (articleNumber == 0 || !articleNumber) {
        console.log('here?');
        this.openArticleBtn?this.openArticleBtn.style.display = "none":null;
      }
    }

    if (itemNumber_3) {

      itemNumber_3.innerHTML = collectionNumber;
      if (collectionNumber == 0 || !collectionNumber) {
        this.openCollectionBtn?this.openCollectionBtn.style.display = "none":null;
      }
    }

    if (productNumber !== 0) {
      this.showProducts();
    }

    console.log(articleNumber);
    
    if ((productNumber == 0 || !productNumber) && articleNumber !== 0 && articleNumber) {
      this.showArticles();
    }

   
  }


  showProducts() {
    // Hide result articles and collections
    if (this.resultArticles || this.resultCollections) {
      if(this.resultArticles){
        this.element.querySelector('.Search--Result.Article--Result').style.display = 'none';
      }

      if(this.resultCollections){
        this.element.querySelector('.Search--Result.Collection--Result').style.display = 'none';
      }
      
    }
   
    const activeBarDesk = this.element.querySelector('.desktop-active-bar');
    const activeBarMob = this.element.querySelector('.mobile-active-bar');


      if(this.breakpoint === 'desktop' || this.breakpoint === 'lap'){
        if (activeBarDesk) {
          activeBarDesk.style.display = 'flex';
        }
        const filterBarDesktop = this.element.querySelector('.FilterBar.not_mobile');
        if (filterBarDesktop) {
          filterBarDesktop.style.display = 'flex';
        }
      }

      if(this.breakpoint === 'tablet' || this.breakpoint === 'phone'){
        if (activeBarMob) {
          activeBarMob.style.display = 'flex';
        }
        const filterBarMobile = this.element.querySelector('.FilterBar.not_desktop');
        if (filterBarMobile) {
          filterBarMobile.style.display = 'flex';
        }
      }


   

    // Show product elements and hide article and collection elements
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    productElements.forEach(product => {
      product.classList.remove("hidden");
    });

    const articleElements = this.element.querySelectorAll(".article-wrapper");
    articleElements.forEach(article => {
      article.classList.add("hidden");
    });
    const collectionElements = this.element.querySelectorAll(".collection-wrapper");
    collectionElements.forEach(article => {
      article.classList.add("hidden");
    });

    // Show product load more button if exists
    const viewProducts = this.element.querySelector(".products-load-more");
    if (viewProducts) {
      viewProducts.classList.remove("hidden");
    }

    // Update button styles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openCollectionBtn = this.element.querySelector("#collectionBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    if (this.openProductBtn)
      this.openProductBtn.classList.add("active");
    if (this.openCollectionBtn)
      this.openCollectionBtn.classList.remove("active");
    if (this.openArticleBtn)
      this.openArticleBtn.classList.remove("active");

    // Show result products
    if (this.element.querySelector('#mainCollectionHolder')) {
      this.element.querySelector('#mainCollectionHolder').style.display = 'block'
    }
  }

  showCollections(){
    // Hide result products and filter search bars
    if (this.resultProducts) {
      const mainCollectionHolder = this.element.querySelector('#mainCollectionHolder');
      if (mainCollectionHolder) {
        mainCollectionHolder.style.display = 'none';
      }

      if(this.breakpoint === 'desktop' || this.breakpoint === 'lap'){
        const filterBarDesktop = this.element.querySelector('.FilterBar.not_mobile');
        if (filterBarDesktop) {
          filterBarDesktop.style.display = 'none';
        }
      }

      if(this.breakpoint === 'tablet' || this.breakpoint === 'phone'){
        const filterBarMobile = this.element.querySelector('.FilterBar.not_desktop');
        if (filterBarMobile) {
          filterBarMobile.style.display = 'none';
        }
      }
      const activeBar = this.element.querySelectorAll('.collection__active-filters.in-the-line');
      activeBar.forEach(active => {
        active.style.display ='none';
      })

    }

    

    // Show collection elements and hide product and article elements
    const collectiolnElements = this.element.querySelectorAll(".collection-wrapper");
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");

    collectiolnElements.forEach(collection =>{
      collection.classList.remove("hidden");
    })

    articleElements.forEach(article => {
      article.classList.add("hidden");
    });

    productElements.forEach(product => {
      product.classList.add("hidden");
    });

    // Hide product and article load more button
    const viewProducts = this.element.querySelector(".products-load-more");
    const viewArticles = this.element.querySelector(".articles-load-more");
    if (viewProducts || viewArticles) {
      if (viewProducts)
        viewProducts.classList.add("hidden");
      if(viewArticles)
        viewArticles.classList.add("hidden");
    }

    // Update button styles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openCollectionBtn = this.element.querySelector('#collectionBtn');
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.openProductBtn.classList.remove("active");
    this.openArticleBtn.classList.remove("active")
    this.openCollectionBtn.classList.add("active");

    // Show result articles
    if (this.resultCollections) {
      this.resultCollections.style.display = 'grid';
    }
  }

  showArticles() {
    // Hide result products and collections and filter search bars
    if (this.resultProducts) {
      const mainCollectionHolder = this.element.querySelector('#mainCollectionHolder');
      if (mainCollectionHolder) {
        mainCollectionHolder.style.display = 'none';
      }
    }

    if(this.breakpoint === 'desktop' || this.breakpoint === 'lap'){
      const filterBarDesktop = this.element.querySelector('.FilterBar.not_mobile');
      if (filterBarDesktop) {
        filterBarDesktop.style.display = 'none';
      }
    }

    if(this.breakpoint === 'tablet' || this.breakpoint === 'phone'){
      const filterBarMobile = this.element.querySelector('.FilterBar.not_desktop');
      if (filterBarMobile) {
        filterBarMobile.style.display = 'none';
      }
    }
    const activeBar = this.element.querySelectorAll('.collection__active-filters.in-the-line');
      activeBar.forEach(active => {
        active.style.display ='none';
      })
    if (this.resultCollections) {
      const collectionResult = this.element.querySelector('.Search--Result.Collection--Result');
      if (collectionResult) {
        collectionResult.style.display = 'none';
      }
    }

    // Show article elements and hide product and collection elements
    const articleElements = this.element.querySelectorAll(".article-wrapper");
    const productElements = this.element.querySelectorAll(".SearchProductWrapper");
    const collectionElements = this.element.querySelectorAll(".collection-wrapper");

    articleElements.forEach(article => {
      article.classList.remove("hidden");
    });

    productElements.forEach(product => {
      product.classList.add("hidden");
    });

    collectionElements.forEach(collection => {
      collection.classList.add("hidden");
    })

    // Hide product load more button
    const viewProducts = this.element.querySelector(".products-load-more");
    if (viewProducts) {
      viewProducts.classList.add("hidden");
    }
    // Show article load more button if exists
    const articleProducts = this.element.querySelector(".articles-load-more");
    if (articleProducts) {
      articleProducts.classList.remove("hidden");
    }

    // Update button styles
    this.openProductBtn = this.element.querySelector("#productBtn");
    this.openCollectionBtn = this.element.querySelector("#collectionBtn");
    this.openArticleBtn = this.element.querySelector("#articleBtn");
    this.openProductBtn.classList.remove("active");
    this.openCollectionBtn.classList.remove("active");
    this.openArticleBtn.classList.add("active");

    // Show result articles
    if (this.resultArticles) {
      this.resultArticles.style.display = 'grid';
    }
  }

}

customElements.define("search-component", Search);

class SliderTextSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");
    this.carousel = new RevolutionSwiper(this.carouselElement);


  }
}
customElements.define("slider-text", SliderTextSection);

class NerdyForm extends HTMLElement {
  constructor(){
    super();
    this.element = this;
    this.nativeSelect = this.element.querySelector('select');
    this.delegateElement = new Delegate(this.element);

    this.bindEvents();
  }

  connectedCallback(){
    if (this.nativeSelect) {
      this.injectDropdown();
      this.moveNerdyErrorMSg();
    }

  }

  bindEvents(){
    this.delegateElement.on(
      "click",
      'input[type="checkbox"]+label',
      this.handleLabelClick.bind(this)
    );
  }

  handleLabelClick(event){
    event.target.closest('label').previousElementSibling.click();
  }

  injectDropdown(){
    const options = Array.from(this.nativeSelect.options);

    const selectId = this.nativeSelect.id;

    const placeholderText = options[0] ? options[0].textContent : 'Select an option';

    const wrapper = document.createElement('div');
    wrapper.className = 'RevolutionSelectbox';
    wrapper.setAttribute('data-select', this.nativeSelect.name);

    wrapper.innerHTML = `
      <button class="RevolutionSelectbox--Button u-p1" data-action="toggle-selectbox" aria-expanded="false" type="button">
        <span class="RevolutionSelectbox--Title">${placeholderText}</span>
        <svg 
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        >
        <rect width="20" height="20" fill="white"/>
        <path d="M9.60942 12.5067L15.5437 6.09236L16 6.58563L10.0658 13L9.60942 12.5067Z"/>
        <path d="M9.93423 12.9076L4 6.49328L4.45635 6.00001L10.3906 12.4144L9.93423 12.9076Z"/>
      </svg>
      </button>
      <div class="RevolutionSelectbox--Content RevolutionSelectbox--animation" aria-hidden="true" style="display: none;">
        <div class="RevolutionSelectbox--InnerContent" data-scrollable>
          ${options.map((option) => {
            const isSelected = option.selected ? 'selected="selected"' : '';
            const isDisabled = option.disabled ? 'disabled="true"' : '';
            return `
              <div class="RevolutionSelectbox--Item u-p1"
                   data-action="selectbox-change"
                   data-value="${option.value}"
                   data-name="${option.textContent}"
                   data-selectboxid="${selectId}"
                   ${isSelected}
                   ${isDisabled}
                   tabindex="0">
                ${option.textContent}
              </div>
            `;
          }).join('')}
        </div>
      </div>
    `;

    this.nativeSelect.parentNode.insertBefore(wrapper, this.nativeSelect);

    wrapper.appendChild(this.nativeSelect);

    this.nativeSelect.style.display = "none";

    this.dropdown = new RevolutionSelectbox(wrapper);
  }

  moveNerdyErrorMSg(){
   const dropdown = this.dropdown.element;
   const errorMsg = dropdown.nextElementSibling;

   if(errorMsg && errorMsg.classList.contains("nf-invalid-tooltip") && dropdown){
    dropdown.appendChild(errorMsg);
   }

  }

}
customElements.define("nerdy-form", NerdyForm);

class CollectionShowcase extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.delegateElement = new Delegate(this.element);

    const grid = this.element.querySelector(".collection-showcase__grid-desktop");
    if (grid) {
      const items = grid.querySelectorAll(".collection-showcase__collection");

      if (items.length === 5) {
        items[4].style.display = 'none';
      }
    }
  }
}

customElements.define('collection-showcase', CollectionShowcase);


class PdpUspSection extends HTMLElement {
  constructor() {
    super();
    this.element = this;
    this.carouselElement = this.element.querySelector(".swiper");

    const responsive = new Responsive();
    const breakpoint = responsive.getCurrentBreakpoint();
    const isMobile = breakpoint === "phone" || breakpoint === "tablet";

    if (isMobile && this.carouselElement) {
      this.carousel = new RevolutionSwiper(this.carouselElement);
    }
  }
}

customElements.define("pdp-usp-section", PdpUspSection);

function onEnter(callback){
  return function(event){
    if(event.key === 'Enter' || event.keyCode === 13) {
      callback(event);
   }
 }
}

function onEscape(callback) {
  return function(event) {
    if (event.key === 'Escape' || event.keyCode === 27) {
      callback(event);
    }
  }
}
